(function(){"use strict";try{if(typeof document!="undefined"){var o=document.createElement("style");o.appendChild(document.createTextNode(".dropdown-menu .active:not(.form-control){color:#16181b;background-color:#eee}.dropdown-menu [data-active=true] a.dropdown-item,.dropdown-menu .dropdown-item:focus,.dropdown-menu li:focus .dropdown-item :not(.disabled){color:#16181b;background-color:#eee}.dropdown-menu li:focus{outline:none}.dropdown-menu.dropdown-menu-dark [data-active=true] a.dropdown-item,.dropdown-menu.dropdown-menu-dark .dropdown-item:focus,.dropdown-menu.dropdown-menu-dark li:focus .dropdown-item{color:#fff;background-color:#1266f1}.btn-group.dropstart>.dropdown-menu{right:0!important}.select-input-label-active{color:#1266f1!important}")),document.head.appendChild(o)}}catch(d){console.error("vite-plugin-css-injected-by-js",d)}})();
import { jsx as a, jsxs as K, Fragment as be } from "react/jsx-runtime";
import ne, { useState as N, useEffect as B, useRef as te, useCallback as P, useMemo as Fe, useImperativeHandle as xt, forwardRef as Lt, createContext as gn, useContext as He, Children as ys, cloneElement as lr, useId as ar } from "react";
import E from "clsx";
import { usePopper as wt } from "react-popper";
import Qt, { createPortal as ws } from "react-dom";
import { flip as ks } from "@popperjs/core";
import { AnimatePresence as Ft, motion as Mt } from "framer-motion";
import ur from "chartjs-plugin-datalabels";
import { Chart as Ns, registerables as dr } from "chart.js";
import { Scatter as fr, Bubble as mr, Radar as hr, PolarArea as pr, Doughnut as vr, Pie as br, Line as gr, Bar as yr } from "react-chartjs-2";
import Wn from "deepmerge";
const wr = ne.forwardRef(
  ({ breakpoint: e, fluid: t, children: n, className: s, tag: r = "div", ...o }, c) => {
    const i = E(`${t ? "container-fluid" : `container${e ? "-" + e : ""}`}`, s);
    return /* @__PURE__ */ a(r, { className: i, ...o, ref: c, children: n });
  }
);
wr.displayName = "MDBContainer";
const kr = ne.forwardRef(
  ({
    center: e,
    children: t,
    className: n,
    end: s,
    lg: r,
    md: o,
    offsetLg: c,
    offsetMd: i,
    offsetSm: l,
    order: d,
    size: u,
    sm: m,
    start: f,
    tag: h = "div",
    xl: v,
    xxl: g,
    xs: p,
    ...y
  }, b) => {
    const k = E(
      u && `col-${u}`,
      p && `col-xs-${p}`,
      m && `col-sm-${m}`,
      o && `col-md-${o}`,
      r && `col-lg-${r}`,
      v && `col-xl-${v}`,
      g && `col-xxl-${g}`,
      !u && !p && !m && !o && !r && !v && !g ? "col" : "",
      d && `order-${d}`,
      f && "align-self-start",
      e && "align-self-center",
      s && "align-self-end",
      l && `offset-sm-${l}`,
      i && `offset-md-${i}`,
      c && `offset-lg-${c}`,
      n
    );
    return /* @__PURE__ */ a(h, { className: k, ref: b, ...y, children: t });
  }
);
kr.displayName = "MDBCol";
const Nr = ne.forwardRef(
  ({ className: e, color: t = "primary", pill: n, light: s, dot: r, tag: o = "span", children: c, notification: i, ...l }, d) => {
    const u = E(
      "badge",
      s ? t && `badge-${t}` : t && `bg-${t}`,
      r && "badge-dot",
      n && "rounded-pill",
      i && "badge-notification",
      e
    );
    return /* @__PURE__ */ a(o, { className: u, ref: d, ...l, children: c });
  }
);
Nr.displayName = "MDBBadge";
const Mr = ({ ...e }) => {
  const [t, n] = N(!1), s = E("ripple-wave", t && "active");
  return B(() => {
    const r = setTimeout(() => {
      n(!0);
    }, 50);
    return () => {
      clearTimeout(r);
    };
  }, []), /* @__PURE__ */ a("div", { className: s, ...e });
}, xr = (...e) => {
  const t = ne.useRef();
  return ne.useEffect(() => {
    e.forEach((n) => {
      n && (typeof n == "function" ? n(t.current) : n.current = t.current);
    });
  }, [e]), t;
}, yn = ne.forwardRef(
  ({
    className: e,
    rippleTag: t = "div",
    rippleCentered: n,
    rippleDuration: s = 500,
    rippleUnbound: r,
    rippleRadius: o = 0,
    rippleColor: c = "dark",
    children: i,
    onMouseDown: l,
    ...d
  }, u) => {
    const m = te(null), f = xr(u, m), h = "rgba({{color}}, 0.2) 0, rgba({{color}}, 0.3) 40%, rgba({{color}}, 0.4) 50%, rgba({{color}}, 0.5) 60%, rgba({{color}}, 0) 70%", v = [0, 0, 0], g = ["primary", "secondary", "success", "danger", "warning", "info", "light", "dark"], [p, y] = N([]), [b, k] = N(!1), M = E(
      "ripple",
      "ripple-surface",
      r && "ripple-surface-unbound",
      b && `ripple-surface-${c}`,
      e
    ), L = () => {
      if (g.find((H) => H === (c == null ? void 0 : c.toLowerCase())))
        return k(!0);
      {
        const H = I(c).join(",");
        return `radial-gradient(circle, ${h.split("{{color}}").join(`${H}`)})`;
      }
    }, I = (Y) => {
      const H = (D) => (D.length < 7 && (D = `#${D[1]}${D[1]}${D[2]}${D[2]}${D[3]}${D[3]}`), [parseInt(D.substr(1, 2), 16), parseInt(D.substr(3, 2), 16), parseInt(D.substr(5, 2), 16)]), A = (D) => {
        const Q = document.body.appendChild(document.createElement("fictum")), _ = "rgb(1, 2, 3)";
        return Q.style.color = _, Q.style.color !== _ || (Q.style.color = D, Q.style.color === _ || Q.style.color === "") ? v : (D = getComputedStyle(Q).color, document.body.removeChild(Q), D);
      }, J = (D) => (D = D.match(/[.\d]+/g).map((Q) => +Number(Q)), D.length = 3, D);
      return Y.toLowerCase() === "transparent" ? v : Y[0] === "#" ? H(Y) : (Y.indexOf("rgb") === -1 && (Y = A(Y)), Y.indexOf("rgb") === 0 ? J(Y) : v);
    }, T = (Y) => {
      const { offsetX: H, offsetY: A, height: J, width: D } = Y, Q = A <= J / 2, _ = H <= D / 2, U = (q, F) => Math.sqrt(q ** 2 + F ** 2), $ = A === J / 2 && H === D / 2, X = {
        first: Q === !0 && _ === !1,
        second: Q === !0 && _ === !0,
        third: Q === !1 && _ === !0,
        fourth: Q === !1 && _ === !1
      }, O = {
        topLeft: U(H, A),
        topRight: U(D - H, A),
        bottomLeft: U(H, J - A),
        bottomRight: U(D - H, J - A)
      };
      let C = 0;
      return $ || X.fourth ? C = O.topLeft : X.third ? C = O.topRight : X.second ? C = O.bottomRight : X.first && (C = O.bottomLeft), C * 2;
    }, x = (Y) => {
      var C;
      const H = (C = f.current) == null ? void 0 : C.getBoundingClientRect(), A = Y.clientX - H.left, J = Y.clientY - H.top, D = H.height, Q = H.width, _ = {
        offsetX: n ? D / 2 : A,
        offsetY: n ? Q / 2 : J,
        height: D,
        width: Q
      }, U = {
        delay: s && s * 0.5,
        duration: s && s - s * 0.5
      }, $ = T(_), X = o || $ / 2, O = {
        left: n ? `${Q / 2 - X}px` : `${A - X}px`,
        top: n ? `${D / 2 - X}px` : `${J - X}px`,
        height: o ? `${o * 2}px` : `${$}px`,
        width: o ? `${o * 2}px` : `${$}px`,
        transitionDelay: `0s, ${U.delay}ms`,
        transitionDuration: `${s}ms, ${U.duration}ms`
      };
      return b ? O : { ...O, backgroundImage: `${L()}` };
    }, V = (Y) => {
      const H = x(Y), A = p.concat(H);
      y(A), l && l(Y);
    };
    return B(() => {
      const Y = setTimeout(() => {
        p.length > 0 && y(p.splice(1, p.length - 1));
      }, s);
      return () => {
        clearTimeout(Y);
      };
    }, [s, p]), /* @__PURE__ */ K(t, { className: M, onMouseDown: (Y) => V(Y), ref: f, ...d, children: [
      i,
      p.map((Y, H) => /* @__PURE__ */ a(Mr, { style: Y }, H))
    ] });
  }
);
yn.displayName = "MDBRipple";
const Ae = ne.forwardRef(
  ({
    className: e,
    color: t = "primary",
    outline: n,
    children: s,
    rounded: r,
    disabled: o,
    floating: c,
    size: i,
    href: l,
    block: d,
    active: u,
    toggle: m,
    noRipple: f,
    tag: h = "button",
    role: v = "button",
    ...g
  }, p) => {
    const [y, b] = N(u || !1);
    let k;
    const M = t && ["light", "link"].includes(t) || n ? "dark" : "light";
    t !== "none" ? n ? t ? k = `btn-outline-${t}` : k = "btn-outline-primary" : t ? k = `btn-${t}` : k = "btn-primary" : k = "";
    const L = E(
      t !== "none" && "btn",
      k,
      r && "btn-rounded",
      c && "btn-floating",
      i && `btn-${i}`,
      `${(l || h !== "button") && o ? "disabled" : ""}`,
      d && "btn-block",
      y && "active",
      e
    );
    return l && h !== "a" && (h = "a"), ["hr", "img", "input"].includes(h) || f ? /* @__PURE__ */ a(
      h,
      {
        className: L,
        onClick: m ? () => {
          b(!y);
        } : void 0,
        disabled: o && h === "button" ? !0 : void 0,
        href: l,
        ref: p,
        role: v,
        ...g,
        children: s
      }
    ) : /* @__PURE__ */ a(
      yn,
      {
        rippleTag: h,
        rippleColor: M,
        className: L,
        onClick: m ? () => {
          b(!y);
        } : void 0,
        disabled: o && h === "button" ? !0 : void 0,
        href: l,
        ref: p,
        role: v,
        ...g,
        children: s
      }
    );
  }
);
Ae.displayName = "MDBBtn";
const Er = ne.forwardRef(
  ({ className: e, children: t, shadow: n, toolbar: s, size: r, vertical: o, tag: c = "div", role: i = "group", ...l }, d) => {
    let u;
    s ? u = "btn-toolbar" : o ? u = "btn-group-vertical" : u = "btn-group";
    const m = E(u, n && `shadow-${n}`, r && `btn-group-${r}`, e);
    return /* @__PURE__ */ a(c, { className: m, ref: d, role: i, ...l, children: t });
  }
);
Er.displayName = "MDBBtnGroup";
const Ms = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", color: s, grow: r, size: o, ...c }, i) => {
    const l = E(
      `${r ? "spinner-grow" : "spinner-border"}`,
      s && `text-${s}`,
      `${o ? r ? "spinner-grow-" + o : "spinner-border-" + o : ""}`,
      e
    );
    return /* @__PURE__ */ a(n, { className: l, ref: i, ...c, children: t });
  }
);
Ms.displayName = "MDBSpinner";
const Dr = ne.forwardRef(
  ({ className: e, children: t, border: n, background: s, tag: r = "div", shadow: o, alignment: c, ...i }, l) => {
    const d = E(
      "card",
      n && `border border-${n}`,
      s && `bg-${s}`,
      o && `shadow-${o}`,
      c && `text-${c}`,
      e
    );
    return /* @__PURE__ */ a(r, { className: d, ref: l, ...i, children: t });
  }
);
Dr.displayName = "MDBCard";
const Tr = ne.forwardRef(
  ({ className: e, children: t, border: n, background: s, tag: r = "div", ...o }, c) => {
    const i = E("card-header", n && `border-${n}`, s && `bg-${s}`, e);
    return /* @__PURE__ */ a(r, { className: i, ...o, ref: c, children: t });
  }
);
Tr.displayName = "MDBCardHeader";
const Br = ne.forwardRef(
  ({ className: e, children: t, tag: n = "p", ...s }, r) => {
    const o = E("card-subtitle", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
Br.displayName = "MDBCardSubTitle";
const Lr = ne.forwardRef(
  ({ className: e, children: t, tag: n = "h5", ...s }, r) => {
    const o = E("card-title", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
Lr.displayName = "MDBCardTitle";
const Sr = ne.forwardRef(
  ({ className: e, children: t, tag: n = "p", ...s }, r) => {
    const o = E("card-text", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
Sr.displayName = "MDBCardText";
const Ir = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", ...s }, r) => {
    const o = E("card-body", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
Ir.displayName = "MDBCardBody";
const Ar = ne.forwardRef(
  ({ className: e, children: t, border: n, background: s, tag: r = "div", ...o }, c) => {
    const i = E("card-footer", n && `border-${n}`, s && `bg-${s}`, e);
    return /* @__PURE__ */ a(r, { className: i, ...o, ref: c, children: t });
  }
);
Ar.displayName = "MDBCardFooter";
const Zi = ({ className: e, children: t, overlay: n, position: s, fluid: r, ...o }) => {
  const c = E(s && `card-img-${s}`, r && "img-fluid", n && "card-img", e);
  return /* @__PURE__ */ a("img", { className: c, ...o, children: t });
}, $r = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", ...s }, r) => {
    const o = E("card-img-overlay", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
$r.displayName = "MDBCardOverlay";
const el = ({ className: e, children: t, ...n }) => {
  const s = E("card-link", e);
  return /* @__PURE__ */ a("a", { className: s, ...n, children: t });
}, Rr = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", ...s }, r) => {
    const o = E("card-group", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
Rr.displayName = "MDBCardGroup";
const Hr = ne.forwardRef(
  ({ className: e, tag: t = "ul", horizontal: n, horizontalSize: s, light: r, numbered: o, children: c, small: i, ...l }, d) => {
    const u = E(
      "list-group",
      n && (s ? `list-group-horizontal-${s}` : "list-group-horizontal"),
      r && "list-group-light",
      o && "list-group-numbered",
      i && "list-group-small",
      e
    );
    return /* @__PURE__ */ a(t, { className: u, ref: d, ...l, children: c });
  }
);
Hr.displayName = "MDBListGroup";
const Wr = ne.forwardRef(
  ({ className: e, tag: t = "li", active: n, disabled: s, action: r, color: o, children: c, noBorders: i, ...l }, d) => {
    const u = t === "button", m = E(
      "list-group-item",
      n && "active",
      s && !u && "disabled",
      r && "list-group-item-action",
      o && `list-group-item-${o}`,
      i && "border-0",
      e
    );
    return /* @__PURE__ */ a(t, { className: m, disabled: u && s, ref: d, ...l, children: c });
  }
);
Wr.displayName = "MDBListGroupItem";
const pt = ({ children: e, containerRef: t, disablePortal: n }) => {
  const [s, r] = N(!1);
  return B(() => {
    !n && r(!0);
  }, [n]), n ? /* @__PURE__ */ a(be, { children: e }) : s ? ws(/* @__PURE__ */ a(be, { children: e }), (t == null ? void 0 : t.current) || document.body) : null;
}, Cr = ({
  className: e,
  children: t,
  disableMouseDown: n,
  tag: s = Ae,
  tooltipTag: r = "div",
  options: o,
  placement: c = "top",
  title: i,
  wrapperProps: l,
  wrapperClass: d,
  onOpen: u,
  onClose: m,
  onMouseEnter: f,
  onMouseLeave: h,
  type: v,
  ...g
}) => {
  const [p, y] = N(null), [b, k] = N(null), [M, L] = N(!1), [I, T] = N(!1), [x, V] = N(!1), [Y, H] = N(!1), A = E("tooltip", x && "show", "fade", e), { styles: J, attributes: D } = wt(p, b, {
    placement: c,
    ...o
  });
  B(() => {
    let $, X;
    return M || I ? (H(!0), $ = setTimeout(() => {
      V(!0);
    }, 4)) : (V(!1), X = setTimeout(() => {
      H(!1);
    }, 300)), () => {
      clearTimeout($), clearTimeout(X);
    };
  }, [M, I]);
  const Q = ($) => {
    u == null || u($), !$.defaultPrevented && L(!0), f == null || f($);
  }, _ = ($) => {
    m == null || m($), !$.defaultPrevented && L(!1), h == null || h($);
  }, U = P(
    ($) => {
      $.target === p ? T(!0) : T(!1);
    },
    [p]
  );
  return B(() => {
    if (!n)
      return document.addEventListener("mousedown", U), () => {
        document.removeEventListener("mousedown", U);
      };
  }, [U, n]), /* @__PURE__ */ K(be, { children: [
    /* @__PURE__ */ a(
      s,
      {
        className: d,
        onMouseEnter: Q,
        onMouseLeave: _,
        ref: y,
        ...l,
        type: v,
        children: t
      }
    ),
    Y && /* @__PURE__ */ a(pt, { children: /* @__PURE__ */ a(
      r,
      {
        ref: k,
        className: A,
        style: J.popper,
        ...D.popper,
        role: "tooltip",
        ...g,
        children: /* @__PURE__ */ a("div", { className: "tooltip-inner", children: i })
      }
    ) })
  ] });
}, Yr = ne.forwardRef(
  ({
    around: e,
    between: t,
    bottom: n,
    center: s,
    children: r,
    className: o,
    evenly: c,
    end: i,
    middle: l,
    start: d,
    tag: u = "div",
    top: m,
    ...f
  }, h) => {
    const v = E(
      "row",
      e && "justify-content-around",
      t && "justify-content-between",
      n && "align-self-end",
      s && "justify-content-center",
      c && "justifty-content-evenly",
      i && "justify-content-end",
      l && "align-self-center",
      d && "justify-content-start",
      m && "align-self-start",
      o
    );
    return /* @__PURE__ */ a(u, { className: v, ...f, ref: h, children: r });
  }
);
Yr.displayName = "MDBRow";
const it = ({
  animate: e,
  className: t,
  icon: n,
  fab: s,
  fas: r,
  fal: o,
  far: c,
  flag: i,
  spin: l,
  fixed: d,
  flip: u,
  list: m,
  size: f,
  pull: h,
  pulse: v,
  color: g,
  border: p,
  rotate: y,
  inverse: b,
  stack: k,
  iconType: M,
  children: L,
  ...I
}) => {
  let T;
  i ? T = "flag" : s ? T = "fab" : r ? T = "fas" : c ? T = "far" : o ? T = "fal" : T = "fa";
  const x = E(
    M ? `fa-${M}` : T,
    e && `fa-${e}`,
    i ? `flag-${i}` : n && `fa-${n}`,
    f && `fa-${f}`,
    g && `text-${g}`,
    p && "fa-border",
    y && `fa-rotate-${y}`,
    h && `fa-pull-${h}`,
    l && !e && "fa-spin",
    m && "fa-li",
    d && "fa-fw",
    v && !e && "fa-pulse",
    b && "fa-inverse",
    u && `fa-flip-${u}`,
    k && `fa-stack-${k}`,
    t
  );
  return /* @__PURE__ */ a("i", { className: x, ...I, children: L });
}, Pr = ne.forwardRef(
  ({
    className: e,
    children: t,
    tag: n = "p",
    variant: s,
    color: r,
    blockquote: o,
    note: c,
    noteColor: i,
    listUnStyled: l,
    listInLine: d,
    ...u
  }, m) => {
    const f = E(
      s && s,
      o && "blockquote",
      c && "note",
      r && `text-${r}`,
      i && `note-${i}`,
      l && "list-unstyled",
      d && "list-inline",
      e
    );
    return o && (n = "blockquote"), (l || d) && (n = "ul"), /* @__PURE__ */ a(n, { className: f, ref: m, ...u, children: t });
  }
);
Pr.displayName = "MDBTypography";
const Xr = ne.forwardRef(
  ({ className: e, color: t, uppercase: n, bold: s, children: r, ...o }, c) => {
    const i = E(
      "breadcrumb",
      s && "font-weight-bold",
      t && `text-${t}`,
      n && "text-uppercase",
      e
    );
    return /* @__PURE__ */ a("nav", { "aria-label": "breadcrumb", children: /* @__PURE__ */ a("ol", { className: i, ref: c, ...o, children: r }) });
  }
);
Xr.displayName = "MDBBreadcrumb";
const Or = ne.forwardRef(
  ({ className: e, active: t, current: n = "page", children: s, ...r }, o) => {
    const c = E("breadcrumb-item", t && "active", e);
    return /* @__PURE__ */ a("li", { className: c, ref: o, "aria-current": t && n, ...r, children: s });
  }
);
Or.displayName = "MDBBreadcrumbItem";
const Fr = (e) => {
  if (e !== !1)
    return `navbar-expand-${e}`;
}, xs = ne.forwardRef(
  ({
    className: e,
    children: t,
    light: n,
    dark: s,
    scrolling: r,
    fixed: o,
    sticky: c,
    scrollingNavbarOffset: i,
    color: l,
    transparent: d,
    expand: u,
    tag: m = "nav",
    bgColor: f,
    ...h
  }, v) => {
    const [g, p] = N(!1), y = E(
      {
        "navbar-light": n,
        "navbar-dark": s,
        "scrolling-navbar": r || i,
        "top-nav-collapse": g,
        [`text-${l}`]: l && d ? g : l
      },
      o && `fixed-${o}`,
      c && "sticky-top",
      "navbar",
      u && Fr(u),
      f && `bg-${f}`,
      e
    ), b = P(() => {
      i && window.pageYOffset > i ? p(!0) : p(!1);
    }, [i]);
    return B(() => ((r || i) && window.addEventListener("scroll", b), () => {
      window.removeEventListener("scroll", b);
    }), [b, r, i]), /* @__PURE__ */ a(m, { className: y, role: "navigation", ...h, ref: v, children: t });
  }
);
xs.displayName = "MDBNavbar";
const Vr = ne.forwardRef(
  ({ children: e, className: t = "", disabled: n = !1, active: s = !1, tag: r = "a", ...o }, c) => {
    const i = E("nav-link", n ? "disabled" : s ? "active" : "", t);
    return /* @__PURE__ */ a(r, { "data-test": "nav-link", className: i, style: { cursor: "pointer" }, ref: c, ...o, children: e });
  }
);
Vr.displayName = "MDBNavbarLink";
const jr = ne.forwardRef(
  ({ className: e, children: t, tag: n = "a", ...s }, r) => {
    const o = E("navbar-brand", e);
    return /* @__PURE__ */ a(n, { className: o, ref: r, ...s, children: t });
  }
);
jr.displayName = "MDBNavbarBrand";
const Kr = ne.forwardRef(
  ({ children: e, className: t, active: n, text: s, tag: r = "li", ...o }, c) => {
    const i = E("nav-item", n && "active", s && "navbar-text", t);
    return /* @__PURE__ */ a(r, { ...o, className: i, ref: c, children: e });
  }
);
Kr.displayName = "MDBNavbarItem";
const qr = ne.forwardRef(
  ({ children: e, className: t, right: n, fullWidth: s = !0, left: r, tag: o = "ul", ...c }, i) => {
    const l = E("navbar-nav", s && "w-100", n && "ms-auto", r && "me-auto", t);
    return /* @__PURE__ */ a(o, { className: l, ref: i, ...c, children: e });
  }
);
qr.displayName = "MDBNavbarNav";
const _r = ne.forwardRef(
  ({ children: e, className: t, tag: n = "button", ...s }, r) => {
    const o = E("navbar-toggler", t);
    return /* @__PURE__ */ a(n, { ...s, className: o, ref: r, children: e });
  }
);
_r.displayName = "MDBNavbarToggler";
const zr = ne.forwardRef(
  ({ children: e, bgColor: t, color: n, className: s, ...r }, o) => {
    const c = E(t && `bg-${t}`, n && `text-${n}`, s);
    return /* @__PURE__ */ a("footer", { className: c, ...r, ref: o, children: e });
  }
);
zr.displayName = "MDBFooter";
const Ur = ne.forwardRef(
  ({ children: e, size: t, circle: n, center: s, end: r, start: o, className: c, ...i }, l) => {
    const d = E(
      "pagination",
      s && "justify-content-center",
      n && "pagination-circle",
      r && "justify-content-end",
      t && `pagination-${t}`,
      o && "justify-content-start",
      c
    );
    return /* @__PURE__ */ a("ul", { className: d, ...i, ref: l, children: e });
  }
);
Ur.displayName = "MDBPagination";
const Gr = ne.forwardRef(
  ({ children: e, className: t, tag: n = "a", ...s }, r) => {
    const o = E("page-link", t);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: e });
  }
);
Gr.displayName = "MDBPaginationLink";
const Qr = ne.forwardRef(
  ({ children: e, className: t, active: n, disabled: s, ...r }, o) => {
    const c = E("page-item", n && "active", s && "disabled", t);
    return /* @__PURE__ */ a("li", { className: c, ...r, ref: o, children: e });
  }
);
Qr.displayName = "MDBPaginationItem";
const Jr = ({
  className: e,
  classNameResponsive: t,
  responsive: n,
  align: s,
  borderColor: r,
  bordered: o,
  borderless: c,
  children: i,
  color: l,
  hover: d,
  small: u,
  striped: m,
  ...f
}) => {
  const h = E(
    "table",
    s && `align-${s}`,
    r && `border-${r}`,
    o && "table-bordered",
    c && "table-borderless",
    l && `table-${l}`,
    d && "table-hover",
    u && "table-sm",
    m && "table-striped",
    e
  ), v = Fe(() => /* @__PURE__ */ a("table", { className: h, ...f, children: i }), [i, h, f]);
  if (n) {
    const g = E(
      typeof n == "string" ? `table-responsive-${n}` : "table-responsive",
      t
    );
    return /* @__PURE__ */ a("div", { className: g, children: v });
  } else
    return v;
}, Zr = ({ className: e, children: t, dark: n, light: s, ...r }) => {
  const o = E(n && "table-dark", s && "table-light", e);
  return /* @__PURE__ */ a("thead", { className: o, ...r, children: t });
}, eo = ({ className: e, children: t, ...n }) => {
  const s = E(e);
  return /* @__PURE__ */ a("tbody", { className: s, ...n, children: t });
}, Es = ne.forwardRef(
  ({
    animated: e,
    children: t,
    className: n,
    style: s,
    tag: r = "div",
    valuenow: o,
    valuemax: c,
    striped: i,
    bgColor: l,
    valuemin: d,
    width: u,
    ...m
  }, f) => {
    const h = E(
      "progress-bar",
      l && `bg-${l}`,
      i && "progress-bar-striped",
      e && "progress-bar-animated",
      n
    ), v = { width: `${u}%`, ...s };
    return /* @__PURE__ */ a(
      r,
      {
        className: h,
        style: v,
        ref: f,
        role: "progressbar",
        ...m,
        "aria-valuenow": Number(u) ?? o,
        "aria-valuemin": Number(d),
        "aria-valuemax": Number(c),
        children: t
      }
    );
  }
);
Es.displayName = "MDBProgressBar";
const to = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", height: s, style: r, ...o }, c) => {
    const i = E("progress", e), l = { height: `${s}px`, ...r };
    return /* @__PURE__ */ a(n, { className: i, ref: c, style: l, ...o, children: ne.Children.map(t, (d) => {
      if (!ne.isValidElement(d) || d.type !== Es) {
        console.error("Progress component only allows ProgressBar as child");
        return;
      } else
        return d;
    }) });
  }
);
to.displayName = "MDBProgress";
const no = (e) => {
  const [t, n] = N(!1), [s, r] = N(null);
  return B(() => {
    r(() => new IntersectionObserver(([o]) => {
      n(o.isIntersecting);
    }));
  }, []), B(() => {
    if (!(!e.current || !s))
      return s.observe(e.current), () => s.disconnect();
  }, [s, e]), t;
}, Et = (e, t) => Fe(() => t !== void 0 ? t : e, [t, e]), gt = ne.forwardRef(
  ({
    className: e,
    size: t,
    contrast: n,
    value: s,
    defaultValue: r,
    id: o,
    labelClass: c,
    wrapperClass: i,
    wrapperStyle: l,
    wrapperTag: d = "div",
    label: u,
    onChange: m,
    children: f,
    labelRef: h,
    labelStyle: v,
    type: g,
    onBlur: p,
    readonly: y = !1,
    showCounter: b = !1,
    ...k
  }, M) => {
    var j;
    const [L, I] = N(r), T = Fe(() => s !== void 0 ? s : L, [s, L]), [x, V] = N(0), [Y, H] = N(!1), [A, J] = N(0), D = te(null), Q = no(D), _ = te(null), U = h || _;
    xt(M, () => D.current);
    const $ = E("form-outline", n && "form-white", i), X = E(
      "form-control",
      Y && "active",
      g === "date" && "active",
      t && `form-control-${t}`,
      e
    ), O = E("form-label", c), C = P(() => {
      var w;
      (w = U.current) != null && w.clientWidth && V(U.current.clientWidth * 0.8 + 8);
    }, [U]), q = (w) => {
      I(w.target.value), b && J(w.target.value.length), m == null || m(w);
    }, F = P(
      (w) => {
        D.current && (H(!!T), p && p(w));
      },
      [T, p]
    );
    return B(() => {
      C();
    }, [(j = U.current) == null ? void 0 : j.clientWidth, C, Q]), B(() => {
      if (T)
        return H(!0);
      H(!1);
    }, [T]), /* @__PURE__ */ K(d, { className: $, style: l, children: [
      /* @__PURE__ */ a(
        "input",
        {
          type: g,
          readOnly: y,
          className: X,
          onBlur: F,
          onChange: q,
          onFocus: C,
          value: s,
          defaultValue: r,
          id: o,
          ref: D,
          ...k
        }
      ),
      u && /* @__PURE__ */ a("label", { className: O, style: v, htmlFor: o, ref: U, children: u }),
      /* @__PURE__ */ K("div", { className: "form-notch", children: [
        /* @__PURE__ */ a("div", { className: "form-notch-leading" }),
        /* @__PURE__ */ a("div", { className: "form-notch-middle", style: { width: x } }),
        /* @__PURE__ */ a("div", { className: "form-notch-trailing" })
      ] }),
      f,
      b && k.maxLength && /* @__PURE__ */ a("div", { className: "form-helper", children: /* @__PURE__ */ a("div", { className: "form-counter", children: `${A}/${k.maxLength}` }) })
    ] });
  }
);
gt.displayName = "MDBInput";
const tn = Lt(
  ({
    className: e,
    inputRef: t,
    labelClass: n,
    wrapperClass: s,
    labelStyle: r,
    wrapperTag: o = "div",
    wrapperStyle: c,
    label: i,
    inline: l,
    btn: d,
    id: u,
    btnColor: m,
    disableWrapper: f,
    toggleSwitch: h,
    ...v
  }, g) => {
    let p = "form-check-input", y = "form-check-label";
    d && (p = "btn-check", m ? y = `btn btn-${m}` : y = "btn btn-primary");
    const b = E(
      i && !d && "form-check",
      l && !d && "form-check-inline",
      h && "form-switch",
      s
    ), k = E(p, e), M = E(y, n), L = /* @__PURE__ */ K(be, { children: [
      /* @__PURE__ */ a("input", { className: k, id: u, ref: t, ...v }),
      i && /* @__PURE__ */ a("label", { className: M, style: r, htmlFor: u, children: i })
    ] });
    return /* @__PURE__ */ a(be, { children: f ? L : /* @__PURE__ */ a(o, { style: c, className: b, ref: g, children: L }) });
  }
);
tn.displayName = "InputTemplate";
const Wt = ({ ...e }) => /* @__PURE__ */ a(tn, { type: "checkbox", ...e }), tl = ({ ...e }) => /* @__PURE__ */ a(tn, { type: "radio", ...e }), Ds = ({
  className: e,
  children: t,
  open: n = !1,
  id: s,
  navbar: r,
  tag: o = "div",
  collapseRef: c,
  style: i,
  onOpen: l,
  onClose: d,
  ...u
}) => {
  const [m, f] = N(!1), [h, v] = N(void 0), [g, p] = N(!1), y = E(
    g ? "collapsing" : "collapse",
    !g && m && "show",
    r && "navbar-collapse",
    e
  ), b = te(null), k = c ?? b, M = P(() => {
    m && v(void 0);
  }, [m]);
  return B(() => {
    var L;
    h === void 0 && m && v((L = k == null ? void 0 : k.current) == null ? void 0 : L.scrollHeight);
  }, [h, m, k]), B(() => {
    m !== n && (n ? l == null || l() : d == null || d(), f(n)), m && p(!0);
    const L = setTimeout(() => {
      p(!1);
    }, 350);
    return () => {
      clearTimeout(L);
    };
  }, [n, m, l, d]), B(() => {
    var L;
    v(m ? (L = k == null ? void 0 : k.current) == null ? void 0 : L.scrollHeight : 0);
  }, [m, k, t]), B(() => (window.addEventListener("resize", M), () => {
    window.removeEventListener("resize", M);
  }), [M]), /* @__PURE__ */ a(o, { style: { height: h, ...i }, id: s, className: y, ...u, ref: k, children: t });
}, Ts = gn(null), so = ({
  children: e,
  isOpen: t = !1,
  options: n,
  animation: s = !0,
  dropup: r,
  dropright: o,
  dropleft: c,
  onClose: i,
  onOpen: l
}) => {
  const [d, u] = N(t), [m, f] = N(null), [h, v] = N(null), [g, p] = N(-1);
  return /* @__PURE__ */ a(
    Ts.Provider,
    {
      value: {
        animation: s,
        activeIndex: g,
        isOpenState: d,
        setReferenceElement: f,
        setPopperElement: v,
        setActiveIndex: p,
        popperElement: h,
        setIsOpenState: u,
        referenceElement: m,
        onClose: i,
        onOpen: l,
        dropup: r,
        options: n,
        dropright: o,
        dropleft: c
      },
      children: e
    }
  );
}, ro = (e) => e instanceof HTMLElement, oo = (e) => e instanceof Node, Ct = () => {
  const e = He(Ts);
  if (!e)
    throw new Error("Missing context data");
  return e;
}, co = () => {
  const { isOpenState: e, setIsOpenState: t, setActiveIndex: n, popperElement: s, referenceElement: r, onClose: o } = Ct(), c = P(
    (i) => {
      e && (o == null || o(i)), !(!e || !oo(i.target) || s && s.contains(i.target) || r && r.contains(i.target) || i.defaultPrevented) && (t(!1), setTimeout(() => n(-1), 300));
    },
    [e, t, n, s, r, o]
  );
  B(() => (document.addEventListener("mousedown", c), () => document.removeEventListener("mousedown", c)), [c]);
}, io = ({
  className: e,
  tag: t = "div",
  group: n,
  children: s,
  dropup: r,
  dropright: o,
  dropleft: c,
  wrapper: i,
  ...l
}) => {
  co();
  const d = E(
    n ? "btn-group" : "dropdown",
    r && "dropup",
    o && "dropend",
    c && "dropstart",
    e
  );
  return i ? /* @__PURE__ */ a(t, { className: d, ...l, children: s }) : /* @__PURE__ */ a(be, { children: s });
}, nl = ({ animation: e, onClose: t, onOpen: n, wrapper: s = !0, ...r }) => /* @__PURE__ */ a(so, { animation: e, onClose: t, onOpen: n, ...r, children: /* @__PURE__ */ a(io, { wrapper: s, ...r }) }), lo = ({
  childTag: e,
  children: t,
  disabled: n,
  link: s,
  divider: r,
  header: o,
  href: c = "#"
}) => {
  const i = E("dropdown-item", n && "disabled");
  return s ? e ? /* @__PURE__ */ a(e, { className: i, children: t }) : /* @__PURE__ */ a("a", { href: c, className: i, children: t }) : r ? e ? /* @__PURE__ */ a(e, { className: "dropdown-divider", children: t }) : /* @__PURE__ */ a("hr", { className: "dropdown-divider" }) : o ? e ? /* @__PURE__ */ a(e, { className: "dropdown-header", children: t }) : /* @__PURE__ */ a("h6", { className: "dropdown-header", children: t }) : /* @__PURE__ */ a(be, { children: t });
};
const sl = ({
  onClick: e,
  tag: t = "li",
  childTag: n,
  children: s,
  style: r,
  link: o,
  divider: c,
  header: i,
  disabled: l,
  href: d,
  preventCloseOnClick: u,
  ...m
}) => {
  const { setIsOpenState: f, onClose: h, setActiveIndex: v } = Ct();
  return /* @__PURE__ */ a(t, { style: r, onClick: (p) => {
    h == null || h(p), e == null || e(p), !(l || u || p.defaultPrevented) && (setTimeout(() => v(-1), 300), f(!1));
  }, ...m, children: /* @__PURE__ */ a(
    lo,
    {
      link: o,
      divider: c,
      header: i,
      disabled: l,
      href: d,
      childTag: n,
      children: s
    }
  ) });
}, Cn = (e, t, n) => n === "up" ? e <= 0 ? t[t.length - 1].props.divider === !0 || t[t.length - 1].props.disabled === !0 : t[e - 1].props.divider === !0 || t[e - 1].props.disabled === !0 : e === t.length - 1 ? t[0].props.divider === !0 || t[0].props.disabled === !0 : t[e + 1].props.divider === !0 || t[e + 1].props.disabled === !0, ao = (e) => {
  const { activeIndex: t, isOpenState: n, setIsOpenState: s, setActiveIndex: r, onClose: o } = Ct(), c = P(
    (i) => {
      const l = ["ArrowUp", "ArrowDown", "Tab", "Enter", "Escape"];
      if (!(!Array.isArray(e) || !l.includes(i.key))) {
        if (ro(document.activeElement) && document.activeElement.blur(), i.key === "ArrowUp") {
          i.preventDefault();
          const d = Cn(t, e, "up");
          if (t === 1) {
            r(d ? e.length - 1 : 0);
            return;
          }
          if (t <= 0) {
            r(d ? e.length - 2 : e.length - 1);
            return;
          }
          r((u) => d ? u - 2 : u - 1);
        }
        if (i.key === "ArrowDown" || i.key === "Tab") {
          i.preventDefault();
          const d = Cn(t, e, "down");
          if (t === e.length - 2) {
            r((u) => d ? 0 : u + 1);
            return;
          }
          if (t === e.length - 1) {
            r(d ? 1 : 0);
            return;
          }
          r((u) => d ? u + 2 : u + 1);
        }
        if (i.key === "Enter") {
          const d = document.querySelector('[data-active="true"]'), u = d == null ? void 0 : d.firstElementChild;
          if (u)
            return u.click();
          if (o == null || o(i), i.defaultPrevented)
            return;
          s(!1), setTimeout(() => r(-1), 300);
        }
        if (i.key === "Escape") {
          if (o == null || o(i), i.defaultPrevented)
            return;
          s(!1), setTimeout(() => r(-1), 300);
        }
      }
    },
    [e, s, r, t, o]
  );
  B(() => (n && document.addEventListener("keydown", c), () => {
    n && document.removeEventListener("keydown", c);
  }), [n, c]), B(() => {
    const i = document.querySelector('[data-active="true"]'), l = i == null ? void 0 : i.firstElementChild;
    return l == null || l.focus(), () => l == null ? void 0 : l.blur();
  }, [t]);
}, uo = () => {
  const { isOpenState: e } = Ct(), [t, n] = N(!1), [s, r] = N(!1), [o, c] = N(e);
  return B(() => {
    let i;
    return e || (r(!0), n(!1), i = setTimeout(() => {
      r(!1), c(!1);
    }, 300)), e && (n(!0), r(!1), c(!0), i = setTimeout(() => {
      n(!1);
    }, 300)), () => clearTimeout(i);
  }, [e]), { open: o, isFadeIn: t, isFadeOut: s };
};
const rl = ({
  className: e,
  tag: t = "ul",
  children: n,
  style: s,
  dark: r,
  responsive: o = "",
  appendToBody: c = !1,
  alwaysOpen: i,
  ...l
}) => {
  const {
    activeIndex: d,
    setPopperElement: u,
    isOpenState: m,
    animation: f,
    referenceElement: h,
    popperElement: v,
    options: g,
    dropleft: p,
    dropup: y,
    dropright: b
  } = Ct(), { open: k, isFadeIn: M, isFadeOut: L } = uo();
  ao(n);
  const I = () => {
    if (b)
      return "right-start";
    if (p)
      return "left-start";
    const Y = v && getComputedStyle(v).getPropertyValue("--mdb-position").trim() === "end";
    return y ? Y ? "top-end" : "top-start" : Y ? "bottom-end" : "bottom-start";
  }, { styles: T } = wt(h, v, {
    placement: I(),
    modifiers: [ks],
    ...g
  }), x = E(
    "dropdown-menu",
    r && "dropdown-menu-dark",
    m && "show",
    f && "animation",
    M && "fade-in",
    L && "fade-out",
    o && `dropdown-menu-${o}`,
    e
  );
  if (!k && !i)
    return null;
  const V = /* @__PURE__ */ a(
    t,
    {
      className: x,
      style: { position: "absolute", zIndex: 1e3, ...T.popper, ...s },
      ref: u,
      ...l,
      children: ys.map(
        n,
        (Y, H) => lr(Y, {
          tabIndex: 0,
          "data-active": d === H && !0,
          className: E(d === H ? "active" : "", Y.props.className)
        })
      )
    }
  );
  return /* @__PURE__ */ a(pt, { disablePortal: !c, children: V });
}, ol = ({
  className: e,
  tag: t = Ae,
  children: n,
  onClick: s,
  split: r,
  ...o
}) => {
  const { setIsOpenState: c, setReferenceElement: i, isOpenState: l, setActiveIndex: d, onClose: u, onOpen: m } = Ct(), f = E("dropdown-toggle", r && "dropdown-toggle-split", e);
  return /* @__PURE__ */ a(
    t,
    {
      onClick: (v) => {
        s == null || s(v), l ? u == null || u(v) : m == null || m(v), !v.defaultPrevented && (c((g) => !g), setTimeout(() => d(-1), 300));
      },
      ref: i,
      className: f,
      "aria-expanded": !!l,
      ...o,
      children: n
    }
  );
}, fo = ({
  className: e,
  btnClassName: t,
  btnChildren: n,
  children: s,
  tag: r = Ae,
  onOpen: o,
  onClose: c,
  popperTag: i = "div",
  open: l,
  placement: d = "bottom",
  dismiss: u,
  options: m,
  poperStyle: f,
  onClick: h,
  disablePortal: v = !1,
  ...g
}) => {
  const [p, y] = N(), [b, k] = N(), { styles: M, attributes: L } = wt(p, b, { placement: d, ...m }), [I, T] = N(l ?? !1), x = Et(I, l), [V, Y] = N(!1), [H, A] = N(!1), J = E("popover fade", V && x && "show", e), D = (_) => {
    x && !u ? c == null || c() : x || o == null || o(), u ? (A(!0), T(!0)) : T(!x), h && h(_);
  }, Q = P(
    (_) => {
      H && b && x && p && !p.contains(_.target) && (T(!1), c == null || c());
    },
    [H, x, b, p, c]
  );
  return B(() => {
    const _ = setTimeout(() => {
      Y(x);
    }, 150);
    return () => {
      clearTimeout(_);
    };
  }, [x]), B(() => (x && document.addEventListener("mousedown", Q), () => {
    document.removeEventListener("mousedown", Q);
  }), [Q, x]), /* @__PURE__ */ K(be, { children: [
    /* @__PURE__ */ a(r, { onClick: D, className: t, ...g, ref: y, children: n }),
    (V || x) && /* @__PURE__ */ a(pt, { disablePortal: v, children: /* @__PURE__ */ a(
      i,
      {
        className: J,
        ref: k,
        style: { ...M.popper, ...f },
        ...L.popper,
        children: s
      }
    ) })
  ] });
}, mo = ({
  className: e,
  children: t,
  tag: n = "div",
  ...s
}) => {
  const r = E("popover-body", e);
  return /* @__PURE__ */ a(n, { className: r, ...s, children: t });
}, cl = ({
  className: e,
  children: t,
  tag: n = "h3",
  ...s
}) => {
  const r = E("popover-header", e);
  return /* @__PURE__ */ a(n, { className: r, ...s, children: t });
}, il = ({
  animationDirection: e,
  appendToBody: t,
  backdrop: n = !0,
  children: s,
  className: r,
  closeOnEsc: o = !0,
  setOpen: c,
  leaveHiddenModal: i = !0,
  modalRef: l,
  onClose: d,
  onClosePrevented: u,
  onOpen: m,
  open: f,
  staticBackdrop: h,
  nonInvasive: v = !1,
  tag: g = "div",
  ...p
}) => {
  const [y, b] = N(f), [k, M] = N(f), [L, I] = N(f), [T, x] = N(!1), [V, Y] = N(0), [H, A] = N([]), J = te(null), D = l || J, Q = E(
    "modal",
    T && "modal-static",
    e,
    "fade",
    k && "show",
    y && v && "modal-non-invasive-show",
    r
  ), _ = E("modal-backdrop", "fade", y && "show"), U = P(() => {
    M((q) => (q && (d == null || d()), !1)), setTimeout(() => {
      b(!1), c == null || c(!1);
    }, 150), setTimeout(() => {
      I(!1);
    }, 350);
  }, [d, c]), $ = P(
    (q) => {
      v || k && q.target === D.current && (h ? (x(!0), u == null || u(), setTimeout(() => {
        x(!1);
      }, 300)) : U());
    },
    [k, D, h, U, u, v]
  ), X = P(
    (q) => {
      k && q.key === "Tab" && (q.preventDefault(), Y(V + 1)), o && k && q.key === "Escape" && (h ? (x(!0), u == null || u(), setTimeout(() => {
        x(!1);
      }, 300)) : U());
    },
    [k, o, V, h, U, u]
  );
  B(() => {
    var j;
    const q = (j = D.current) == null ? void 0 : j.querySelectorAll(
      "button, a, input, select, textarea, [tabindex]"
    ), F = Array.from(q).filter((w) => w.tabIndex !== -1).sort((w, W) => w.tabIndex === W.tabIndex ? 0 : W.tabIndex === null ? -1 : w.tabIndex === null ? 1 : w.tabIndex - W.tabIndex);
    A(F), Y(F.length - 1);
  }, [D]), B(() => {
    H && H.length > 0 && (V === H.length ? (H[0].focus(), Y(0)) : H[V].focus());
  }, [V, H]), B(() => {
    const q = () => {
      const j = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - j);
    }, F = window.innerWidth > document.documentElement.clientWidth && window.innerWidth >= 576;
    if (L && F && !v) {
      const j = q();
      document.body.classList.add("modal-open"), document.body.style.overflow = "hidden", document.body.style.paddingRight = `${j}px`;
    } else
      document.body.classList.remove("modal-open"), document.body.style.overflow = "", document.body.style.paddingRight = "";
    return () => {
      document.body.classList.remove("modal-open"), document.body.style.overflow = "", document.body.style.paddingRight = "";
    };
  }, [L, v]), B(() => {
    f ? (m == null || m(), I(!0), setTimeout(() => {
      b(!0);
    }, 0), setTimeout(() => {
      M(!0), c == null || c(!0);
    }, 150)) : U();
  }, [f, U, c, m]), B(() => {
    const q = (F) => {
      F.target.closest(".modal-dialog") || window.addEventListener("mouseup", $, { once: !0 });
    };
    return window.addEventListener("mousedown", q), window.addEventListener("keydown", X), () => {
      window.removeEventListener("mousedown", q), window.removeEventListener("keydown", X);
    };
  }, [X, $]);
  const O = /* @__PURE__ */ a(be, { children: (i || f || L) && Qt.createPortal(
    /* @__PURE__ */ K(be, { children: [
      /* @__PURE__ */ a(
        g,
        {
          className: Q,
          ref: D,
          style: { display: L || f ? "block" : "none", pointerEvents: v ? "none" : "initial" },
          ...p,
          children: s
        }
      ),
      Qt.createPortal(
        n && L && !v && /* @__PURE__ */ a("div", { className: _ }),
        document.body
      )
    ] }),
    document.body
  ) }), C = /* @__PURE__ */ a(be, { children: (i || f || L) && /* @__PURE__ */ K(be, { children: [
    /* @__PURE__ */ a(
      g,
      {
        className: Q,
        ref: D,
        style: { display: L || f ? "block" : "none", pointerEvents: v ? "none" : "initial" },
        ...p,
        children: s
      }
    ),
    Qt.createPortal(
      n && L && !v && /* @__PURE__ */ a("div", { onClick: U, className: _ }),
      document.body
    )
  ] }) });
  return /* @__PURE__ */ a(be, { children: t ? O : C });
}, ho = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", ...s }, r) => {
    const o = E("modal-content", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
ho.displayName = "MDBModalContent";
const po = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", ...s }, r) => {
    const o = E("modal-header", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
po.displayName = "MDBModalHeader";
const vo = ne.forwardRef(
  ({ className: e, children: t, tag: n = "h5", ...s }, r) => {
    const o = E("modal-title", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
vo.displayName = "MDBModalTitle";
const bo = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", ...s }, r) => {
    const o = E("modal-body", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
bo.displayName = "MDBModalBody";
const go = ne.forwardRef(
  ({ className: e, children: t, tag: n = "div", ...s }, r) => {
    const o = E("modal-footer", e);
    return /* @__PURE__ */ a(n, { className: o, ...s, ref: r, children: t });
  }
);
go.displayName = "MDBModalFooter";
const wn = ne.createContext({
  activeElement: null,
  setTargets: null
}), ll = ({
  container: e = typeof window !== void 0 ? window : null,
  className: t,
  children: n,
  offset: s = 10,
  ...r
}) => {
  const o = E("sticky-top", t), [c, i] = N(null), [l, d] = N([]), u = e instanceof Window, m = P(() => {
    var y, b, k;
    if (!l.length)
      return;
    const f = u ? window.pageYOffset : (y = e == null ? void 0 : e.current) == null ? void 0 : y.scrollTop, h = Number(s), v = (b = l[l.length - 1]) == null ? void 0 : b.current, g = (k = l[0]) == null ? void 0 : k.current;
    f + h < g.offsetTop && i(null), l.forEach((M, L) => {
      var V;
      const I = (V = l[L + 1]) == null ? void 0 : V.current, T = M.current;
      if (f > T.offsetTop - h && f < (I == null ? void 0 : I.offsetTop) - h) {
        i(T);
        return;
      }
    }), f > v.offsetTop - h && i(v);
  }, [s, l, u, e]);
  return B(() => {
    const f = u ? e : e == null ? void 0 : e.current;
    return m(), f == null || f.addEventListener("scroll", m), () => {
      f == null || f.removeEventListener("scroll", m);
    };
  }, [m, e, u]), /* @__PURE__ */ a("div", { className: o, ...r, children: /* @__PURE__ */ a("ul", { className: "nav flex-column nav-pills menu-sidebar", children: /* @__PURE__ */ a(wn.Provider, { value: { activeElement: c, setTargets: d }, children: n }) }) });
}, al = ({
  className: e,
  collapsible: t,
  targetRef: n,
  children: s,
  subsections: r,
  onClick: o,
  onActivate: c,
  ...i
}) => {
  var g;
  const { activeElement: l, setTargets: d } = He(wn), u = () => r == null ? void 0 : r.some((p) => p.current.id === (l == null ? void 0 : l.id)), m = (l == null ? void 0 : l.id) === ((g = n.current) == null ? void 0 : g.id), f = m || u();
  m && (c == null || c(l == null ? void 0 : l.id));
  const h = E("nav-link", t && "collapsible-scrollspy", f && "active", e), v = (p) => {
    const y = n == null ? void 0 : n.current;
    y == null || y.scrollIntoView({ behavior: "smooth" }), o == null || o(p);
  };
  return B(() => {
    d((p) => [...p, n]);
  }, [d, n]), /* @__PURE__ */ a("li", { className: "nav-item", style: { cursor: "pointer" }, children: /* @__PURE__ */ a("a", { className: h, onClick: v, ...i, children: s }) });
}, ul = ({
  collapsible: e,
  className: t,
  children: n,
  style: s,
  ...r
}) => {
  const [o, c] = N("0px"), { activeElement: i } = He(wn), l = E("nav flex-column", t), d = te(null);
  B(() => {
    const m = () => e == null ? void 0 : e.some((h) => h.current.id === (i == null ? void 0 : i.id)), f = d.current;
    m() ? c(`${f == null ? void 0 : f.scrollHeight}px`) : c("0px");
  }, [i, e]);
  const u = {
    overflow: "hidden",
    height: o,
    transition: "height .5s ease",
    flexWrap: "nowrap",
    ...s
  };
  return /* @__PURE__ */ a("ul", { className: l, ref: d, style: e ? u : s, ...r, children: n });
}, dl = ({ ...e }) => /* @__PURE__ */ a(tn, { type: "checkbox", toggleSwitch: !0, ...e }), yo = ({ value: e, min: t = "0", max: n = "100", showThumb: s }) => {
  const r = Number(e), [o, c] = N(
    (r || 0 - Number(t)) * 100 / (Number(n) - Number(t))
  ), i = E("thumb", s && "thumb-active");
  return B(() => {
    c((Number(e) - Number(t)) * 100 / (Number(n) - Number(t)));
  }, [e, n, t]), /* @__PURE__ */ a("span", { className: i, style: { left: `calc(${o}% + (${8 - o * 0.15}px))` }, children: /* @__PURE__ */ a("span", { className: "thumb-value", children: e }) });
}, Yn = ({
  className: e,
  defaultValue: t = 0,
  disableTooltip: n,
  labelId: s,
  max: r,
  min: o,
  onMouseDown: c,
  onMouseUp: i,
  onTouchStart: l,
  onTouchEnd: d,
  onChange: u,
  labelClass: m,
  value: f,
  label: h,
  id: v,
  inputRef: g,
  ...p
}) => {
  const [y, b] = N(t), [k, M] = N(!1), L = E("form-range", e), I = E("form-label", m);
  return /* @__PURE__ */ K(be, { children: [
    h && /* @__PURE__ */ a("label", { className: I, id: s, htmlFor: v, children: h }),
    /* @__PURE__ */ K("div", { className: "range", children: [
      /* @__PURE__ */ a(
        "input",
        {
          type: "range",
          onMouseDown: (A) => {
            M(!0), c && c(A);
          },
          onMouseUp: (A) => {
            M(!1), i && i(A);
          },
          onTouchStart: (A) => {
            M(!0), l && l(A);
          },
          onTouchEnd: (A) => {
            M(!1), d && d(A);
          },
          onChange: (A) => {
            b(A.target.value), u && u(A);
          },
          className: L,
          value: f || y,
          id: v,
          min: o,
          max: r,
          ref: g,
          ...p
        }
      ),
      !n && /* @__PURE__ */ a(yo, { value: f || y, showThumb: k, min: o, max: r })
    ] })
  ] });
}, wo = Lt(
  ({ className: e, labelClass: t, labelStyle: n, inputRef: s, size: r, label: o, id: c, ...i }, l) => {
    const d = E("form-control", `form-control-${r}`, e), u = E("form-label", t), m = te(null);
    return xt(l, () => m.current || (s == null ? void 0 : s.current)), /* @__PURE__ */ K(be, { children: [
      o && /* @__PURE__ */ a("label", { className: u, style: n, htmlFor: c, children: o }),
      /* @__PURE__ */ a("input", { className: d, type: "file", id: c, ref: m, ...i })
    ] });
  }
);
wo.displayName = "MDBFile";
const Bs = ne.forwardRef(
  ({
    className: e,
    children: t,
    noBorder: n,
    textBefore: s,
    textAfter: r,
    noWrap: o,
    tag: c = "div",
    textTag: i = "span",
    textClass: l,
    size: d,
    textProps: u,
    ...m
  }, f) => {
    const h = E("input-group", o && "flex-nowrap", d && `input-group-${d}`, e), v = E("input-group-text", n && "border-0", l), g = (p) => /* @__PURE__ */ a(be, { children: p && Array.isArray(p) ? p.map((y, b) => /* @__PURE__ */ a(i, { className: v, ...u, children: y }, b)) : /* @__PURE__ */ a(i, { className: v, ...u, children: p }) });
    return /* @__PURE__ */ K(c, { className: h, ref: f, ...m, children: [
      s && g(s),
      t,
      r && g(r)
    ] });
  }
);
Bs.displayName = "MDBInputGroup";
const Ls = ne.forwardRef(
  ({ className: e, children: t, isValidated: n = !1, onReset: s, onSubmit: r, noValidate: o = !0, ...c }, i) => {
    const [l, d] = N(n), u = E("needs-validation", l && "was-validated", e), m = (h) => {
      h.preventDefault(), d(!0), r && r(h);
    }, f = (h) => {
      h.preventDefault(), d(!1), s && s(h);
    };
    return B(() => {
      d(n);
    }, [n]), /* @__PURE__ */ a(
      "form",
      {
        className: u,
        onSubmit: m,
        onReset: f,
        ref: i,
        noValidate: o,
        ...c,
        children: t
      }
    );
  }
);
Ls.displayName = "MDBValidation";
const ko = ne.forwardRef(
  ({ className: e, fill: t, pills: n, justify: s, children: r, ...o }, c) => {
    const i = E(
      "nav",
      n ? "nav-pills" : "nav-tabs",
      t && "nav-fill",
      s && "nav-justified",
      e
    );
    return /* @__PURE__ */ a("ul", { className: i, ref: c, ...o, children: r });
  }
);
ko.displayName = "MDBTabs";
const No = ne.forwardRef(
  ({ className: e, children: t, style: n, tag: s = "li", ...r }, o) => {
    const c = E("nav-item", e);
    return /* @__PURE__ */ a(s, { className: c, style: { cursor: "pointer", ...n }, role: "presentation", ref: o, ...r, children: t });
  }
);
No.displayName = "MDBTabsItem";
const Mo = ne.forwardRef(
  ({ className: e, color: t, active: n, onOpen: s, onClose: r, children: o, ...c }, i) => {
    const l = E("nav-link", n && "active", t && `bg-${t}`, e);
    return B(() => {
      n ? s == null || s() : r == null || r();
    }, [n]), /* @__PURE__ */ a("a", { className: l, ref: i, ...c, children: o });
  }
);
Mo.displayName = "MDBTabsLink";
const xo = ne.forwardRef(
  ({ className: e, tag: t = "div", children: n, ...s }, r) => {
    const o = E("tab-content", e);
    return /* @__PURE__ */ a(t, { className: o, ref: r, ...s, children: n });
  }
);
xo.displayName = "MDBTabsContent";
const Eo = ne.forwardRef(
  ({ className: e, tag: t = "div", open: n, children: s, ...r }, o) => {
    const [c, i] = N(!1), l = E("tab-pane", "fade", c && "show", n && "active", e);
    return B(() => {
      let d;
      return n ? d = setTimeout(() => {
        i(!0);
      }, 100) : i(!1), () => {
        clearTimeout(d);
      };
    }, [n]), /* @__PURE__ */ a(t, { className: l, role: "tabpanel", ref: o, ...r, children: s });
  }
);
Eo.displayName = "MDBTabsPane";
const kn = gn({
  active: 0
}), Do = ({ imagesCount: e, to: t }) => {
  const { active: n } = He(kn);
  return /* @__PURE__ */ a("ol", { className: "carousel-indicators", children: Array.from(Array(e)).map((s, r) => /* @__PURE__ */ a("li", { "data-mdb-target": r, className: E(n === r && "active"), onClick: () => t(r) }, r)) });
}, To = ({ move: e }) => /* @__PURE__ */ K(be, { children: [
  /* @__PURE__ */ K("a", { role: "button", className: "carousel-control-prev", onClick: () => e("prev"), children: [
    /* @__PURE__ */ a("span", { className: "carousel-control-prev-icon" }),
    /* @__PURE__ */ a("span", { className: "visually-hidden", children: "Previous" })
  ] }),
  /* @__PURE__ */ K("a", { role: "button", className: "carousel-control-next", onClick: () => e("next"), children: [
    /* @__PURE__ */ a("span", { className: "carousel-control-next-icon" }),
    /* @__PURE__ */ a("span", { className: "visually-hidden", children: "Next" })
  ] })
] }), Bo = (e) => {
  const t = getComputedStyle(e), n = getComputedStyle(e == null ? void 0 : e.parentNode);
  return t.display !== "none" && n.display !== "none" && t.visibility !== "hidden";
}, Lo = (e) => Array.from(e == null ? void 0 : e.querySelectorAll(".carousel-item")), So = (e) => e.offsetHeight, Io = (e, t, n = !0) => {
  if (!n) {
    Pn(e);
    return;
  }
  const s = Ao(t);
  t.addEventListener("transitionend", () => Pn(e), { once: !0 }), Ro(t, s);
}, Pn = (e) => {
  typeof e == "function" && e();
}, Ao = (e) => {
  if (!e)
    return 0;
  let { transitionDuration: t, transitionDelay: n } = window.getComputedStyle(e);
  const s = Number.parseFloat(t), r = Number.parseFloat(n);
  return !s && !r ? 0 : (t = t.split(",")[0], n = n.split(",")[0], (Number.parseFloat(t) + Number.parseFloat(n)) * 1e3);
}, $o = (e) => {
  e.dispatchEvent(new Event("transitionend"));
}, Ro = (e, t) => {
  let n = !1;
  const r = t + 5;
  function o() {
    n = !0, e.removeEventListener("transitionend", o);
  }
  e.addEventListener("transitionend", o), setTimeout(() => {
    n || $o(e);
  }, r);
}, fl = ({
  fade: e = !1,
  className: t,
  carouselInnerClassName: n,
  dark: s,
  children: r,
  interval: o = 5e3,
  keyboard: c = !1,
  touch: i = !0,
  showControls: l,
  showIndicators: d,
  onSlide: u,
  ...m
}) => {
  const f = te([]), h = te(null), v = te(0), g = te(!1), [p, y] = N(0), [b, k] = N(0), [M, L] = N({ initialX: 0, initialY: 0 }), [I, T] = N(!1), x = te(null), V = E("carousel", "slide", e && "carousel-fade", s && "carousel-dark", t), Y = E("carousel-inner", n), H = P(
    (w, W) => {
      if (W !== void 0)
        v.current = W, y(W);
      else {
        const le = p === b - 1 ? 0 : p + 1, ue = p === 0 ? b - 1 : p - 1;
        v.current = w === "next" ? le : ue, y(w === "next" ? le : ue);
      }
    },
    [p, b]
  ), A = P(() => {
    h.current && (clearInterval(h.current), h.current = null);
  }, []), J = P(
    (w, W, le) => {
      var he;
      if (!f.current || f.current.length < 2)
        return;
      T(!0);
      const de = f.current[p], re = Boolean(h.current), De = w === "next", pe = De ? "carousel-item-start" : "carousel-item-end", Ne = De ? "carousel-item-next" : "carousel-item-prev";
      if (W.classList.contains("active")) {
        g.current = !1;
        return;
      }
      H(w, le), !(!de || !W) && (g.current = !0, re && A(), (he = x.current) != null && he.classList.contains("slide") ? (W.classList.add(Ne), So(W), de.classList.add(pe), W.classList.add(pe), Io(() => {
        T(!1), W.classList.remove(pe, Ne), W.classList.add("active"), de.classList.remove("active", Ne, pe), g.current = !1;
      }, de, !0)) : (de.classList.remove("active"), W.classList.add("active"), g.current = !1));
    },
    [x, p, H, A]
  ), D = (w) => {
    g.current || (g.current = !0, setTimeout(() => {
      g.current = !1;
    }, w));
  }, Q = P(
    (w) => {
      const W = w === "prev", de = (v.current + (W ? -1 : 1)) % b, re = f.current;
      return de === -1 ? re[b - 1] : re[de];
    },
    [b]
  ), _ = (w) => {
    const W = v.current, le = w > W ? "next" : "prev", ue = f.current;
    return { direction: le, nextElement: ue[w] };
  }, U = (w) => {
    if (g.current || (D(700), w > b - 1 || w < 0))
      return;
    const { direction: W, nextElement: le } = _(w);
    J(W, le, w);
  }, $ = P(
    (w) => {
      if (g.current)
        return;
      D(600);
      const W = Q(w);
      J(w, W);
    },
    [Q, J]
  ), X = P(() => {
    const { visibilityState: w, hidden: W } = document;
    if (w)
      return W || !Bo(x.current) ? void 0 : $("next");
    $("next");
  }, [x, $]), O = P(() => {
    var W, le;
    const w = (le = (W = r == null ? void 0 : r[p]) == null ? void 0 : W.props) == null ? void 0 : le.interval;
    h.current && (clearInterval(h.current), h.current = null), h.current = setInterval(X, w || o);
  }, [X, o, r, p]), C = (w) => {
    i && L({ initialX: w.touches[0].clientX, initialY: w.touches[0].clientY });
  }, q = (w) => {
    g.current = !0;
    const { initialX: W, initialY: le } = M;
    if (!W || !le)
      return;
    const ue = w.touches[0].clientX, de = w.touches[0].clientY, re = W - ue, De = le - de;
    Math.abs(re) > Math.abs(De) && (re > 0 ? $("prev") : $("next")), L({ initialX: 0, initialY: 0 });
  }, F = () => {
    g.current = !1;
  }, j = P(
    (w) => {
      switch (w.key) {
        case "ArrowLeft":
          w.preventDefault(), $("prev");
          break;
        case "ArrowRight":
          w.preventDefault(), $("next");
          break;
      }
    },
    [$]
  );
  return B(() => {
    if (c)
      return window.addEventListener("keydown", j), () => {
        window.removeEventListener("keydown", j);
      };
  }, [j, c]), B(() => {
    const w = x.current, W = Lo(w);
    f.current = W, k(W.length);
  }, [x]), B(() => {
    I && (u == null || u());
  }, [I, u]), B(() => (O(), () => {
    A();
  }), [O, A]), /* @__PURE__ */ a(
    "div",
    {
      onTouchStart: C,
      onTouchMove: q,
      onTouchEnd: F,
      onMouseEnter: A,
      onMouseLeave: O,
      className: V,
      ref: x,
      ...m,
      children: /* @__PURE__ */ a("div", { className: Y, children: /* @__PURE__ */ K(kn.Provider, { value: { active: p }, children: [
        d && /* @__PURE__ */ a(Do, { to: U, imagesCount: b }),
        r,
        l && /* @__PURE__ */ a(To, { move: $ })
      ] }) })
    }
  );
}, ml = ({ className: e, children: t, itemId: n, ...s }) => {
  const { active: r } = He(kn), o = te(!0), c = te(null), i = E("carousel-item", e);
  return B(() => {
    if (o.current && r === n - 1) {
      const l = c.current;
      l == null || l.classList.add("active");
    }
    o.current = !1;
  }, [r, n]), /* @__PURE__ */ a("div", { className: i, ref: c, ...s, children: t });
}, hl = ({ className: e, children: t, ...n }) => {
  const s = E("carousel-caption d-none d-md-block", e);
  return /* @__PURE__ */ a("div", { className: s, ...n, children: t });
}, Ss = ne.createContext({
  activeItem: 0,
  setActiveItem: null,
  alwaysOpen: !1,
  initialActive: 0
}), Ho = ne.forwardRef(
  ({
    alwaysOpen: e,
    borderless: t,
    className: n,
    flush: s,
    active: r,
    initialActive: o = 0,
    tag: c = "div",
    children: i,
    onChange: l,
    ...d
  }, u) => {
    const m = Fe(() => typeof r < "u", [r]), f = E("accordion", s && "accordion-flush", t && "accordion-borderless", n), [h, v] = N(o);
    return /* @__PURE__ */ a(c, { className: f, ref: u, ...d, children: /* @__PURE__ */ a(
      Ss.Provider,
      {
        value: { activeItem: m ? r : h, setActiveItem: v, alwaysOpen: e, initialActive: o, onChange: l },
        children: i
      }
    ) });
  }
);
Ho.displayName = "MDBAccordion";
const Wo = ne.forwardRef(
  ({
    className: e,
    bodyClassName: t,
    bodyStyle: n,
    headerClassName: s,
    collapseId: r,
    headerTitle: o,
    headerStyle: c,
    btnClassName: i,
    tag: l = "div",
    children: d,
    ...u
  }, m) => {
    const { activeItem: f, setActiveItem: h, alwaysOpen: v, onChange: g } = He(Ss), p = Fe(() => Array.isArray(f) ? f.includes(r) : f === r, [f, r]), y = E("accordion-item", e), b = E("accordion-header", s), k = E("accordion-body", t), M = E("accordion-button", !p && "collapsed", i), L = P(
      (I) => {
        let T = I;
        Array.isArray(f) ? f.includes(I) ? T = f.filter((V) => V !== I) : T = v ? [...f, I] : [I] : (T = f === I ? 0 : I, v && (T = [T])), g == null || g(T), h(T);
      },
      [g, f, h, v]
    );
    return /* @__PURE__ */ K(l, { className: y, ref: m, ...u, children: [
      /* @__PURE__ */ a("h2", { className: b, style: c, children: /* @__PURE__ */ a("button", { onClick: () => L(r), className: M, type: "button", children: o }) }),
      /* @__PURE__ */ a(Ds, { id: r.toString(), open: p, children: /* @__PURE__ */ a("div", { className: k, style: n, children: d }) })
    ] });
  }
);
Wo.displayName = "MDBAccordionItem";
const pl = ({
  className: e,
  size: t,
  contrast: n,
  value: s,
  defaultValue: r,
  id: o,
  labelClass: c,
  wrapperClass: i,
  wrapperStyle: l,
  wrapperTag: d = "div",
  label: u,
  onChange: m,
  children: f,
  labelRef: h,
  labelStyle: v,
  inputRef: g,
  onBlur: p,
  readonly: y = !1,
  ...b
}) => {
  var X;
  const k = te(null), M = te(null), L = h || k, I = g || M, [T, x] = N(s || r), [V, Y] = N(0), [H, A] = N(
    s !== void 0 && s.length > 0 || r !== void 0 && r.length > 0
  ), J = E("form-outline", n && "form-white", i), D = E("form-control", H && "active", t && `form-control-${t}`, e), Q = E("form-label", c);
  B(() => {
    var O;
    L.current && ((O = L.current) == null ? void 0 : O.clientWidth) !== 0 && Y(L.current.clientWidth * 0.8 + 8);
  }, [L, (X = L.current) == null ? void 0 : X.clientWidth]);
  const _ = () => {
    L.current && Y(L.current.clientWidth * 0.8 + 8);
  };
  B(() => {
    s !== void 0 && (s.length > 0 ? A(!0) : A(!1));
  }, [s]), B(() => {
    r !== void 0 && (r.length > 0 ? A(!0) : A(!1));
  }, [r]);
  const U = (O) => {
    x(O.currentTarget.value), m && m(O);
  }, $ = P(
    (O) => {
      T !== void 0 && T.length > 0 || s !== void 0 && s.length > 0 ? A(!0) : A(!1), p && p(O);
    },
    [T, s, p]
  );
  return /* @__PURE__ */ K(d, { className: J, style: { ...l }, children: [
    /* @__PURE__ */ a(
      "textarea",
      {
        readOnly: y,
        className: D,
        onBlur: $,
        onChange: U,
        onFocus: _,
        defaultValue: r,
        value: s,
        id: o,
        ref: I,
        ...b
      }
    ),
    u && /* @__PURE__ */ a("label", { className: Q, style: v, htmlFor: o, ref: L, children: u }),
    /* @__PURE__ */ K("div", { className: "form-notch", children: [
      /* @__PURE__ */ a("div", { className: "form-notch-leading" }),
      /* @__PURE__ */ a("div", { className: "form-notch-middle", style: { width: V } }),
      /* @__PURE__ */ a("div", { className: "form-notch-trailing" })
    ] }),
    f
  ] });
}, vl = ({
  children: e,
  invalid: t,
  feedback: n = "Looks good!",
  tooltip: s,
  tag: r = "div",
  ...o
}) => {
  const [c, i] = N(null), l = te(null), d = E(
    t ? `invalid-${s ? "tooltip" : "feedback"}` : `valid-${s ? "tooltip" : "feedback"}`
  );
  return B(() => {
    var m, f;
    const u = (f = (m = l.current) == null ? void 0 : m.querySelector("input, textarea")) == null ? void 0 : f.parentElement;
    u && i(u);
  }, []), /* @__PURE__ */ K(r, { ref: l, ...o, children: [
    c && ws(/* @__PURE__ */ a("div", { className: d, children: n }), c),
    e
  ] });
}, bl = ({ children: e }) => {
  const [t, n] = N(!1);
  return B(() => {
    n(!0);
  }, []), /* @__PURE__ */ a(be, { children: t ? e : null });
}, Is = ne.forwardRef(
  ({ className: e, open: t, tag: n = "div", children: s, ...r }, o) => {
    const c = E("select-dropdown", t && "open", e);
    return /* @__PURE__ */ a(n, { className: c, ...r, ref: o, children: s });
  }
);
Is.displayName = "MDBSelectDropdown";
const As = ne.forwardRef(
  ({ className: e, tag: t = "span", children: n, ...s }, r) => {
    const o = E("select-option-icon-container", e);
    return /* @__PURE__ */ a(t, { className: o, ...s, ref: r, children: n });
  }
);
As.displayName = "MDBSelectIconContainer";
const Xn = ({
  className: e,
  tag: t = "span",
  disabled: n,
  height: s,
  active: r,
  children: o,
  selected: c,
  style: i,
  secondaryText: l,
  text: d,
  revert: u = !1,
  onClick: m,
  multiple: f,
  ...h
}) => {
  const v = E(
    e !== void 0 && (e != null && e.includes("select-no-results")) ? "" : "select-option",
    c && "selected",
    n && "disabled",
    r && "active",
    e
  ), [g, p] = N(s), [y, b] = N(!1);
  B(() => {
    l && s === void 0 ? p(44) : s === void 0 && p(38);
  }, [l, s]);
  const k = P(
    (M) => {
      n || (m && m(M), b(!y));
    },
    [y, n, m]
  );
  return B(() => {
    f && b(!!(c && !n));
  }, [c, n, f]), /* @__PURE__ */ a(
    t,
    {
      className: v,
      style: { height: g, ...i },
      onClick: k,
      ...h,
      role: "option",
      children: u ? /* @__PURE__ */ K(be, { children: [
        o,
        /* @__PURE__ */ K("div", { className: "select-option-text", children: [
          f && /* @__PURE__ */ a(Wt, { label: d, onChange: k, checked: y, disabled: n }),
          !f && d,
          l && /* @__PURE__ */ a("span", { className: "select-option-secondary-text", children: l })
        ] })
      ] }) : /* @__PURE__ */ K(be, { children: [
        /* @__PURE__ */ K("div", { className: "select-option-text", children: [
          f && /* @__PURE__ */ a(Wt, { label: d, onChange: k, checked: y, disabled: n }),
          !f && d,
          l && /* @__PURE__ */ a("span", { className: "select-option-secondary-text", children: l })
        ] }),
        o
      ] })
    }
  );
}, $s = ne.forwardRef(
  ({ className: e, tag: t = "img", children: n, ...s }, r) => {
    const o = E("select-option-icon", e);
    return /* @__PURE__ */ a(t, { className: o, ...s, ref: r, children: n });
  }
);
$s.displayName = "MDBSelectOptionIcon";
const Rs = ne.forwardRef(
  ({ className: e, tag: t = "div", children: n, ...s }, r) => {
    const o = E("select-options-list", e);
    return /* @__PURE__ */ a(t, { className: o, ...s, ref: r, children: n });
  }
);
Rs.displayName = "MDBSelectOptionsList";
const Hs = ne.forwardRef(({ className: e, tag: t = "div", children: n, maxHeight: s, ...r }, o) => {
  const c = E("select-options-wrapper", e);
  return /* @__PURE__ */ a(t, { className: c, style: { maxHeight: s }, ...r, ref: o, children: n });
});
Hs.displayName = "MDBSelectOptionsWrapper";
const gl = ({
  children: e,
  className: t,
  clearBtn: n,
  data: s,
  tag: r = "div",
  tagWrapper: o = "div",
  visibleOptions: c = 5,
  placeholder: i,
  disabled: l,
  search: d,
  getValue: u,
  multiple: m,
  optionSelected: f = "5",
  optionsSelectedLabel: h,
  label: v,
  getData: g,
  selectAllLabel: p = "Select all",
  noResultLabel: y = "No results",
  searchLabel: b = "Search...",
  size: k = "default",
  validation: M = !1,
  validFeedback: L,
  invalidFeedback: I,
  inputClassName: T,
  searchAriaLabel: x = "Search",
  ...V
}) => {
  const [Y, H] = N(!1), [A, J] = N(""), [D, Q] = N(!1), [_, U] = N(!1), [$, X] = N(""), O = te(null), [C, q] = N(null), [F, j] = N(s), [w, W] = N(""), [le, ue] = N(!1), [de, re] = N([]), [De, pe] = N(!1), [Ne, he] = N(s), [fe, ye] = N(), [Le, Me] = N(), [ke, ae] = N(F.findIndex((z) => !z.disabled && z.selected)), Te = te(null), [se, We] = N(!1), Se = te(null), [$e, Ge] = N(0), [nt, st] = N(!1), [tt, Ve] = N(!1), Qe = te(null), { styles: dt, attributes: lt } = wt(fe, Le, {
    placement: "bottom-start"
  }), rt = E("select-wrapper", t), ot = E(
    "select-input",
    i && "placeholder-active",
    le && v && "active",
    Y && "focused",
    k !== "default" && `form-control-${k}`,
    T
  );
  B(() => {
    j(s), he(s);
    const z = s.filter((Z) => Z.selected === !0 && !Z.disabled);
    z.length > 0 && X(z[0].text);
  }, [s]), B(() => {
    const z = [];
    F.forEach((Z) => {
      Z.selected && z.push({ text: Z.text, value: Z.value });
    }), u && z && u(m ? z : z[0]);
  }, [$]), B(() => {
    D && d && setTimeout(() => {
      var z;
      (z = Se.current) == null || z.focus();
    }, 100);
  }, [D, d]);
  const Pe = P(() => {
    fe != null && D && setTimeout(() => {
      var Z;
      const z = (Z = fe.parentNode) == null ? void 0 : Z.parentNode.getBoundingClientRect();
      J(z.width);
    }, 100);
  }, [fe, D]);
  B(() => {
    var z, Z;
    if (!(!L || !I) && fe) {
      if (L) {
        const ie = document.createElement("div");
        ie.classList.add("valid-feedback"), ie.innerHTML = L, fe.setAttribute("required", "true"), (z = fe.parentNode) == null || z.insertBefore(ie, fe.nextSibling);
      }
      if (I) {
        const ie = document.createElement("div");
        ie.classList.add("invalid-feedback"), ie.innerHTML = I, fe.setAttribute("required", "true"), (Z = fe.parentNode) == null || Z.insertBefore(ie, fe.nextSibling);
      }
    }
  }, [L, I, fe]), B(() => {
    Pe();
  }, [Pe]);
  const qe = P(
    (z) => {
      Le && Le !== null && Y && fe && fe !== null && (!Le.contains(z.target) && !fe.contains(z.target) ? (H(!1), ue(!1), d && setTimeout(() => {
        W("");
      }, 100)) : ue(!0));
    },
    [Y, Le, fe, d]
  ), ct = P(() => {
    H(!Y), d && W("");
  }, [Y, d]), S = () => {
    X(""), ue(!1), j(
      s.map((z) => ({ ...z, active: !1, selected: !1 }))
    ), he(
      s.map((z) => ({ ...z, active: !1, selected: !1 }))
    );
  }, ce = () => {
    pe(!De);
  };
  B(() => {
    let z;
    if (se && !D && $e !== void 0)
      if (m)
        H(!0);
      else {
        const Z = s.map((ve, xe) => xe === $e ? { ...ve, selected: !0, active: !0 } : { ...ve, selected: !1, active: !1 });
        $e <= 0 ? X(Z[0].text) : $e >= Z.length - 1 ? X(Z[Z.length - 1].text) : X(Z[$e].text);
        const ie = [];
        for (let ve = 0; ve < s.length; ve++)
          ie.push({
            // eslint-disable-next-line
            // @ts-ignore
            ...s[ve],
            ...Z.find((xe) => xe.text === s[ve].text)
          });
        g && g(ie), he(ie), j(ie);
      }
    return () => {
      clearTimeout(z);
    };
  }, [$e]), B(() => {
    let z, Z;
    return Y ? (Q(!0), v && ue(!0), Z = setTimeout(() => {
      U(!0);
    }, 100)) : (z = setTimeout(() => {
      Q(!1);
    }, 100), v && ue(!1), U(!1)), () => {
      clearTimeout(z), clearTimeout(Z);
    };
  }, [Y, v]), B(() => {
    if (m)
      if (De) {
        const z = F.map((ie) => ({ ...ie, selected: !0, active: !0 }));
        j(z);
        const Z = z.filter((ie) => !ie.disabled).map((ie) => ie.text);
        re(Z), X(`${Z.length} option${Z.length <= 1 ? "" : "s"} selected`);
      } else {
        j(Ne);
        const z = Ne.filter((Z) => !Z.disabled && Z.selected).map((Z) => Z.text);
        re(z), X(`${z.length} option${z.length <= 1 ? "" : "s"} selected`);
      }
  }, [De]), B(() => {
    m && (de.length >= Number(f) ? X(h || `${de.length} option${de.length <= 1 ? "" : "s"} selected`) : X(de.join(", ")));
  }, [de, m, f, h]), B(() => {
    if (m) {
      const z = s.map((ie) => ie.selected === void 0 ? { ...ie, active: !1, selected: !1 } : { ...ie, active: !0 });
      j(z);
      const Z = Ne.filter((ie) => ie.selected === !0 && !ie.disabled).map((ie) => ie.text);
      re(Z), de.length >= Number(f) ? X(`${de.length} option${de.length <= 1 ? "" : "s"} selected`) : X(de.join(", "));
    } else {
      const z = F.map((ie) => ie.selected === void 0 ? { ...ie, active: !1, selected: !1 } : { ...ie, active: !0 }), Z = z.filter((ie) => ie.selected === !0 && !ie.disabled);
      Z.length > 0 && (j(z), X(Z[0].text)), g && g(z);
    }
  }, []), B(() => (D && window.addEventListener("resize", Pe), () => {
    window.removeEventListener("resize", Pe);
  }), [Pe, D]), B(() => (D && window.addEventListener("click", qe), () => {
    window.removeEventListener("click", qe);
  }), [qe, D]);
  const R = P(
    (z, Z, ie = c) => ([...z].slice(0, ie).forEach((ve) => {
      const { height: xe } = getComputedStyle(ve);
      Z.push(parseFloat(xe));
    }), Z),
    [c]
  );
  B(() => {
    var Z;
    let z;
    if (D) {
      const ie = (Z = O.current) == null ? void 0 : Z.children, ve = [];
      z = setTimeout(() => {
        ie !== void 0 && (R(ie, ve), q(ve.reduce((xe, Ce) => xe + Ce)));
      }, 0);
    }
    return () => {
      clearTimeout(z);
    };
  }, [D, c, R]);
  const oe = P(
    ({ disabled: z, className: Z, text: ie, selected: ve }, xe) => {
      if (!(z || Z !== void 0 && Z.includes("select-no-results")))
        if (m)
          F[xe].selected = !F[xe].selected, j(F), he(F), ie !== void 0 && (!ve || ve === void 0) ? re([...de, ie]) : ie !== void 0 && ve && re(de.filter((Ce) => Ce !== ie));
        else {
          ae(xe), X(ie), H(!1);
          const Ce = F.map((G, ee) => (ee !== xe ? (G.selected = !1, G.active = !1) : (G.selected = !0, G.active = !0), G)), Ye = s.map((G) => ({ ...G, active: !1, selected: !1 })), Xe = [];
          for (let G = 0; G < Ye.length; G++)
            Xe.push({
              ...Ye[G],
              ...Ce.find((ee) => ee.text === Ye[G].text)
            });
          j(Xe), he(Xe), g && g(Xe);
        }
    },
    [s, F, g, m, de]
  ), me = P((z, Z, ie) => {
    let ve = 0;
    return ie ? (ve = z - 1, ve < 0 && (ve = 0), Z[ve].disabled && (ve = me(ve, Z, !0))) : (ve = z + 1, ve > Z.length - 1 && (ve = Z.length - 1), Z[ve].disabled && (ve = me(ve, Z, !1))), ve;
  }, []), Ee = P(
    (z) => {
      const { key: Z } = z;
      if (Z !== "Escape" && Z !== "ArrowDown" && Z !== "ArrowUp" && Z !== "Enter")
        return;
      let ie, ve, xe;
      if (z.preventDefault(), Z === "Escape" && (ie = setTimeout(() => {
        Q(!1), d && W("");
      }, 100), H(!1), U(!1)), z.altKey && Z === "ArrowDown" || z.altKey && Z === "ArrowUp") {
        H(!Y), U(!_);
        return;
      }
      if (Z === "ArrowDown") {
        const Ce = D ? F.findIndex((Xe) => Xe.active) : F.findIndex((Xe) => Xe.selected), Ye = me(Ce, F, !1);
        D ? (st(!1), Ve(!0), ae(Ye)) : Ge(Ye);
      }
      if (Z === "ArrowUp") {
        const Ce = D ? F.findIndex((Xe) => Xe.active) : F.findIndex((Xe) => Xe.selected), Ye = me(Ce, F, !0);
        D ? (st(!0), Ve(!1), ae(Ye)) : Ge(Ye);
      }
      if (Z === "Enter")
        if (!D)
          ve = setTimeout(() => {
            Q(!0), H(!0), U(!0);
          }, 100);
        else if (m) {
          const Ce = F.findIndex((Ye) => Ye.active);
          oe(F[Ce], Ce);
        } else {
          xe = setTimeout(() => {
            Q(!1), d && W("");
          }, 100);
          const Ce = F.filter((G) => G.active && !G.disabled)[0], Ye = F.findIndex((G) => G.active && !G.disabled), Xe = Ne.map((G, ee) => ee === Ye ? { ...G, selected: !0 } : { ...G, selected: !1 });
          X(Ce.text), H(!1), U(!1), j(Xe), he(Xe);
        }
      return () => {
        clearTimeout(ie), clearTimeout(ve), clearTimeout(xe);
      };
    },
    [d, F, m, oe, Ne, D, me, _, Y]
  );
  B(() => {
    var ve;
    const z = Qe.current;
    if (O === null)
      return;
    const Z = [], ie = [];
    if (D) {
      const xe = (ve = O.current) == null ? void 0 : ve.children;
      setTimeout(() => {
        if (R(xe, Z, s.length), R(xe, ie, ke), ie.length === 0)
          return;
        const Ce = ie.reduce((Ye, Xe) => Ye + Xe);
        C === null || z === null || Ce > Number(C) && (z.scrollTop = Ce);
      }, 100);
    }
  }, [D, ke]), B(() => {
    var ve;
    const z = Qe.current;
    if (O === null)
      return;
    const Z = [], ie = [];
    if (D) {
      const xe = (ve = O.current) == null ? void 0 : ve.children;
      setTimeout(() => {
        R(xe, Z, s.length), R(xe, ie, ke + 2);
        const Ce = Z.reduce((G, ee) => G + ee), Ye = ie.reduce((G, ee) => G + ee), Xe = F.map((G, ee) => ee === ke ? { ...G, active: !0 } : { ...G, active: !1 });
        j(Xe), !(C === null || z === null) && (tt && (Ye > Number(C) ? z.scrollTop = Ye - C : z.scrollTop = 0), nt && (Ye <= Number(C) ? z.scrollTop = Ye - 38 * 2 : z.scrollTop = Ce));
      }, 100);
    }
  }, [D, s, tt, nt, R, ke, C]), B(() => (se && window.addEventListener("keydown", Ee), () => {
    window.removeEventListener("keydown", Ee);
  }), [se, Ee]), B(() => {
    if (!m)
      return;
    const z = F.filter((ie) => ie.selected && !ie.disabled), Z = F.filter((ie) => !ie.disabled);
    z.length !== Z.length ? pe(!1) : pe(!0);
  }, [F, m]);
  const Ue = () => F.map((z, Z) => /* @__PURE__ */ a(
    Xn,
    {
      onClick: () => oe(z, Z),
      onChange: () => oe(z, Z),
      "data-value": z.value,
      active: z.active,
      className: z.className,
      height: z.height,
      style: z.style,
      selected: z.selected,
      disabled: z.disabled,
      secondaryText: z.secondaryText,
      text: z.text,
      revert: z.revert,
      multiple: m,
      children: z.icon && /* @__PURE__ */ a(As, { children: typeof z.icon == "object" && z.icon.constructor === Object && !ne.isValidElement(z.icon) ? /* @__PURE__ */ a($s, { className: z.icon.className, src: z.icon.src ? z.icon.src : "", children: z.icon.text }) : z.icon })
    },
    z.text + Z
  )), _e = (z) => {
    W(z.target.value);
  };
  return Fe(() => {
    if (D && d) {
      const z = Ne.filter((Z) => Z.text.toLowerCase().includes(w.toLowerCase()));
      z.length === 0 ? j([{ text: y, className: "select-no-results" }]) : j(z);
    }
  }, [D, Ne, d, y, w]), /* @__PURE__ */ K(r, { className: rt, ref: Te, children: [
    /* @__PURE__ */ K(
      gt,
      {
        onFocus: () => We(!0),
        onBlur: () => We(!1),
        value: $,
        className: ot,
        labelClass: E(Y ? "select-input-label-active" : "", "select-label"),
        ref: ye,
        onClick: ct,
        readOnly: !M,
        required: M,
        placeholder: i,
        disabled: l,
        wrapperStyle: { zIndex: 0 },
        label: v,
        "aria-expanded": !!D,
        "aria-disabled": !!l,
        "aria-haspopup": !0,
        role: "listbox",
        ...V,
        children: [
          $ !== void 0 && $.length > 0 && n && /* @__PURE__ */ a("span", { className: "select-clear-btn d-block", role: "button", onClick: S, children: "✕" }),
          /* @__PURE__ */ a("span", { className: "select-arrow", style: { zIndex: -1 } })
        ]
      }
    ),
    D && Qt.createPortal(
      /* @__PURE__ */ a(
        o,
        {
          style: { ...dt.popper, width: A, zIndex: 1070 },
          ...lt.popper,
          ref: Me,
          className: "select-dropdown-container",
          children: /* @__PURE__ */ K(Is, { open: _, children: [
            d && /* @__PURE__ */ a("div", { className: "input-group", children: /* @__PURE__ */ a(
              gt,
              {
                wrapperStyle: { width: "100%" },
                className: "select-filter-input placeholder-active",
                placeholder: b,
                role: "searchbox",
                type: "text",
                onKeyDown: Ee,
                onChange: _e,
                value: w,
                ref: Se,
                "aria-label": x
              }
            ) }),
            /* @__PURE__ */ a(Hs, { ref: Qe, maxHeight: C, children: /* @__PURE__ */ K(Rs, { ref: O, children: [
              m && /* @__PURE__ */ a(
                Xn,
                {
                  onClick: ce,
                  selected: De,
                  height: 38,
                  text: p,
                  multiple: !0
                }
              ),
              Ue(),
              e && /* @__PURE__ */ a("div", { className: "select-custom-content", children: e })
            ] }) })
          ] })
        }
      ),
      document.body
    )
  ] });
};
/*!
 * perfect-scrollbar v1.5.3
 * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
function vt(e) {
  return getComputedStyle(e);
}
function at(e, t) {
  for (var n in t) {
    var s = t[n];
    typeof s == "number" && (s = s + "px"), e.style[n] = s;
  }
  return e;
}
function zt(e) {
  var t = document.createElement("div");
  return t.className = e, t;
}
var On = typeof Element < "u" && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function Nt(e, t) {
  if (!On)
    throw new Error("No element matching method supported");
  return On.call(e, t);
}
function $t(e) {
  e.remove ? e.remove() : e.parentNode && e.parentNode.removeChild(e);
}
function Fn(e, t) {
  return Array.prototype.filter.call(
    e.children,
    function(n) {
      return Nt(n, t);
    }
  );
}
var Ke = {
  main: "ps",
  rtl: "ps__rtl",
  element: {
    thumb: function(e) {
      return "ps__thumb-" + e;
    },
    rail: function(e) {
      return "ps__rail-" + e;
    },
    consuming: "ps__child--consume"
  },
  state: {
    focus: "ps--focus",
    clicking: "ps--clicking",
    active: function(e) {
      return "ps--active-" + e;
    },
    scrolling: function(e) {
      return "ps--scrolling-" + e;
    }
  }
}, Ws = { x: null, y: null };
function Cs(e, t) {
  var n = e.element.classList, s = Ke.state.scrolling(t);
  n.contains(s) ? clearTimeout(Ws[t]) : n.add(s);
}
function Ys(e, t) {
  Ws[t] = setTimeout(
    function() {
      return e.isAlive && e.element.classList.remove(Ke.state.scrolling(t));
    },
    e.settings.scrollingThreshold
  );
}
function Co(e, t) {
  Cs(e, t), Ys(e, t);
}
var Vt = function(t) {
  this.element = t, this.handlers = {};
}, Ps = { isEmpty: { configurable: !0 } };
Vt.prototype.bind = function(t, n) {
  typeof this.handlers[t] > "u" && (this.handlers[t] = []), this.handlers[t].push(n), this.element.addEventListener(t, n, !1);
};
Vt.prototype.unbind = function(t, n) {
  var s = this;
  this.handlers[t] = this.handlers[t].filter(function(r) {
    return n && r !== n ? !0 : (s.element.removeEventListener(t, r, !1), !1);
  });
};
Vt.prototype.unbindAll = function() {
  for (var t in this.handlers)
    this.unbind(t);
};
Ps.isEmpty.get = function() {
  var e = this;
  return Object.keys(this.handlers).every(
    function(t) {
      return e.handlers[t].length === 0;
    }
  );
};
Object.defineProperties(Vt.prototype, Ps);
var Yt = function() {
  this.eventElements = [];
};
Yt.prototype.eventElement = function(t) {
  var n = this.eventElements.filter(function(s) {
    return s.element === t;
  })[0];
  return n || (n = new Vt(t), this.eventElements.push(n)), n;
};
Yt.prototype.bind = function(t, n, s) {
  this.eventElement(t).bind(n, s);
};
Yt.prototype.unbind = function(t, n, s) {
  var r = this.eventElement(t);
  r.unbind(n, s), r.isEmpty && this.eventElements.splice(this.eventElements.indexOf(r), 1);
};
Yt.prototype.unbindAll = function() {
  this.eventElements.forEach(function(t) {
    return t.unbindAll();
  }), this.eventElements = [];
};
Yt.prototype.once = function(t, n, s) {
  var r = this.eventElement(t), o = function(c) {
    r.unbind(n, o), s(c);
  };
  r.bind(n, o);
};
function Ut(e) {
  if (typeof window.CustomEvent == "function")
    return new CustomEvent(e);
  var t = document.createEvent("CustomEvent");
  return t.initCustomEvent(e, !1, !1, void 0), t;
}
function Zt(e, t, n, s, r) {
  s === void 0 && (s = !0), r === void 0 && (r = !1);
  var o;
  if (t === "top")
    o = [
      "contentHeight",
      "containerHeight",
      "scrollTop",
      "y",
      "up",
      "down"
    ];
  else if (t === "left")
    o = [
      "contentWidth",
      "containerWidth",
      "scrollLeft",
      "x",
      "left",
      "right"
    ];
  else
    throw new Error("A proper axis should be provided");
  Yo(e, n, o, s, r);
}
function Yo(e, t, n, s, r) {
  var o = n[0], c = n[1], i = n[2], l = n[3], d = n[4], u = n[5];
  s === void 0 && (s = !0), r === void 0 && (r = !1);
  var m = e.element;
  e.reach[l] = null, m[i] < 1 && (e.reach[l] = "start"), m[i] > e[o] - e[c] - 1 && (e.reach[l] = "end"), t && (m.dispatchEvent(Ut("ps-scroll-" + l)), t < 0 ? m.dispatchEvent(Ut("ps-scroll-" + d)) : t > 0 && m.dispatchEvent(Ut("ps-scroll-" + u)), s && Co(e, l)), e.reach[l] && (t || r) && m.dispatchEvent(Ut("ps-" + l + "-reach-" + e.reach[l]));
}
function Oe(e) {
  return parseInt(e, 10) || 0;
}
function Po(e) {
  return Nt(e, "input,[contenteditable]") || Nt(e, "select,[contenteditable]") || Nt(e, "textarea,[contenteditable]") || Nt(e, "button,[contenteditable]");
}
function Xo(e) {
  var t = vt(e);
  return Oe(t.width) + Oe(t.paddingLeft) + Oe(t.paddingRight) + Oe(t.borderLeftWidth) + Oe(t.borderRightWidth);
}
var At = {
  isWebKit: typeof document < "u" && "WebkitAppearance" in document.documentElement.style,
  supportsTouch: typeof window < "u" && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof navigator < "u" && navigator.msMaxTouchPoints,
  isChrome: typeof navigator < "u" && /Chrome/i.test(navigator && navigator.userAgent)
};
function yt(e) {
  var t = e.element, n = Math.floor(t.scrollTop), s = t.getBoundingClientRect();
  e.containerWidth = Math.round(s.width), e.containerHeight = Math.round(s.height), e.contentWidth = t.scrollWidth, e.contentHeight = t.scrollHeight, t.contains(e.scrollbarXRail) || (Fn(t, Ke.element.rail("x")).forEach(
    function(r) {
      return $t(r);
    }
  ), t.appendChild(e.scrollbarXRail)), t.contains(e.scrollbarYRail) || (Fn(t, Ke.element.rail("y")).forEach(
    function(r) {
      return $t(r);
    }
  ), t.appendChild(e.scrollbarYRail)), !e.settings.suppressScrollX && e.containerWidth + e.settings.scrollXMarginOffset < e.contentWidth ? (e.scrollbarXActive = !0, e.railXWidth = e.containerWidth - e.railXMarginWidth, e.railXRatio = e.containerWidth / e.railXWidth, e.scrollbarXWidth = Vn(
    e,
    Oe(e.railXWidth * e.containerWidth / e.contentWidth)
  ), e.scrollbarXLeft = Oe(
    (e.negativeScrollAdjustment + t.scrollLeft) * (e.railXWidth - e.scrollbarXWidth) / (e.contentWidth - e.containerWidth)
  )) : e.scrollbarXActive = !1, !e.settings.suppressScrollY && e.containerHeight + e.settings.scrollYMarginOffset < e.contentHeight ? (e.scrollbarYActive = !0, e.railYHeight = e.containerHeight - e.railYMarginHeight, e.railYRatio = e.containerHeight / e.railYHeight, e.scrollbarYHeight = Vn(
    e,
    Oe(e.railYHeight * e.containerHeight / e.contentHeight)
  ), e.scrollbarYTop = Oe(
    n * (e.railYHeight - e.scrollbarYHeight) / (e.contentHeight - e.containerHeight)
  )) : e.scrollbarYActive = !1, e.scrollbarXLeft >= e.railXWidth - e.scrollbarXWidth && (e.scrollbarXLeft = e.railXWidth - e.scrollbarXWidth), e.scrollbarYTop >= e.railYHeight - e.scrollbarYHeight && (e.scrollbarYTop = e.railYHeight - e.scrollbarYHeight), Oo(t, e), e.scrollbarXActive ? t.classList.add(Ke.state.active("x")) : (t.classList.remove(Ke.state.active("x")), e.scrollbarXWidth = 0, e.scrollbarXLeft = 0, t.scrollLeft = e.isRtl === !0 ? e.contentWidth : 0), e.scrollbarYActive ? t.classList.add(Ke.state.active("y")) : (t.classList.remove(Ke.state.active("y")), e.scrollbarYHeight = 0, e.scrollbarYTop = 0, t.scrollTop = 0);
}
function Vn(e, t) {
  return e.settings.minScrollbarLength && (t = Math.max(t, e.settings.minScrollbarLength)), e.settings.maxScrollbarLength && (t = Math.min(t, e.settings.maxScrollbarLength)), t;
}
function Oo(e, t) {
  var n = { width: t.railXWidth }, s = Math.floor(e.scrollTop);
  t.isRtl ? n.left = t.negativeScrollAdjustment + e.scrollLeft + t.containerWidth - t.contentWidth : n.left = e.scrollLeft, t.isScrollbarXUsingBottom ? n.bottom = t.scrollbarXBottom - s : n.top = t.scrollbarXTop + s, at(t.scrollbarXRail, n);
  var r = { top: s, height: t.railYHeight };
  t.isScrollbarYUsingRight ? t.isRtl ? r.right = t.contentWidth - (t.negativeScrollAdjustment + e.scrollLeft) - t.scrollbarYRight - t.scrollbarYOuterWidth - 9 : r.right = t.scrollbarYRight - e.scrollLeft : t.isRtl ? r.left = t.negativeScrollAdjustment + e.scrollLeft + t.containerWidth * 2 - t.contentWidth - t.scrollbarYLeft - t.scrollbarYOuterWidth : r.left = t.scrollbarYLeft + e.scrollLeft, at(t.scrollbarYRail, r), at(t.scrollbarX, {
    left: t.scrollbarXLeft,
    width: t.scrollbarXWidth - t.railBorderXWidth
  }), at(t.scrollbarY, {
    top: t.scrollbarYTop,
    height: t.scrollbarYHeight - t.railBorderYWidth
  });
}
function Fo(e) {
  e.element, e.event.bind(e.scrollbarY, "mousedown", function(t) {
    return t.stopPropagation();
  }), e.event.bind(e.scrollbarYRail, "mousedown", function(t) {
    var n = t.pageY - window.pageYOffset - e.scrollbarYRail.getBoundingClientRect().top, s = n > e.scrollbarYTop ? 1 : -1;
    e.element.scrollTop += s * e.containerHeight, yt(e), t.stopPropagation();
  }), e.event.bind(e.scrollbarX, "mousedown", function(t) {
    return t.stopPropagation();
  }), e.event.bind(e.scrollbarXRail, "mousedown", function(t) {
    var n = t.pageX - window.pageXOffset - e.scrollbarXRail.getBoundingClientRect().left, s = n > e.scrollbarXLeft ? 1 : -1;
    e.element.scrollLeft += s * e.containerWidth, yt(e), t.stopPropagation();
  });
}
function Vo(e) {
  jn(e, [
    "containerWidth",
    "contentWidth",
    "pageX",
    "railXWidth",
    "scrollbarX",
    "scrollbarXWidth",
    "scrollLeft",
    "x",
    "scrollbarXRail"
  ]), jn(e, [
    "containerHeight",
    "contentHeight",
    "pageY",
    "railYHeight",
    "scrollbarY",
    "scrollbarYHeight",
    "scrollTop",
    "y",
    "scrollbarYRail"
  ]);
}
function jn(e, t) {
  var n = t[0], s = t[1], r = t[2], o = t[3], c = t[4], i = t[5], l = t[6], d = t[7], u = t[8], m = e.element, f = null, h = null, v = null;
  function g(b) {
    b.touches && b.touches[0] && (b[r] = b.touches[0].pageY), m[l] = f + v * (b[r] - h), Cs(e, d), yt(e), b.stopPropagation(), b.type.startsWith("touch") && b.changedTouches.length > 1 && b.preventDefault();
  }
  function p() {
    Ys(e, d), e[u].classList.remove(Ke.state.clicking), e.event.unbind(e.ownerDocument, "mousemove", g);
  }
  function y(b, k) {
    f = m[l], k && b.touches && (b[r] = b.touches[0].pageY), h = b[r], v = (e[s] - e[n]) / (e[o] - e[i]), k ? e.event.bind(e.ownerDocument, "touchmove", g) : (e.event.bind(e.ownerDocument, "mousemove", g), e.event.once(e.ownerDocument, "mouseup", p), b.preventDefault()), e[u].classList.add(Ke.state.clicking), b.stopPropagation();
  }
  e.event.bind(e[c], "mousedown", function(b) {
    y(b);
  }), e.event.bind(e[c], "touchstart", function(b) {
    y(b, !0);
  });
}
function jo(e) {
  var t = e.element, n = function() {
    return Nt(t, ":hover");
  }, s = function() {
    return Nt(e.scrollbarX, ":focus") || Nt(e.scrollbarY, ":focus");
  };
  function r(o, c) {
    var i = Math.floor(t.scrollTop);
    if (o === 0) {
      if (!e.scrollbarYActive)
        return !1;
      if (i === 0 && c > 0 || i >= e.contentHeight - e.containerHeight && c < 0)
        return !e.settings.wheelPropagation;
    }
    var l = t.scrollLeft;
    if (c === 0) {
      if (!e.scrollbarXActive)
        return !1;
      if (l === 0 && o < 0 || l >= e.contentWidth - e.containerWidth && o > 0)
        return !e.settings.wheelPropagation;
    }
    return !0;
  }
  e.event.bind(e.ownerDocument, "keydown", function(o) {
    if (!(o.isDefaultPrevented && o.isDefaultPrevented() || o.defaultPrevented) && !(!n() && !s())) {
      var c = document.activeElement ? document.activeElement : e.ownerDocument.activeElement;
      if (c) {
        if (c.tagName === "IFRAME")
          c = c.contentDocument.activeElement;
        else
          for (; c.shadowRoot; )
            c = c.shadowRoot.activeElement;
        if (Po(c))
          return;
      }
      var i = 0, l = 0;
      switch (o.which) {
        case 37:
          o.metaKey ? i = -e.contentWidth : o.altKey ? i = -e.containerWidth : i = -30;
          break;
        case 38:
          o.metaKey ? l = e.contentHeight : o.altKey ? l = e.containerHeight : l = 30;
          break;
        case 39:
          o.metaKey ? i = e.contentWidth : o.altKey ? i = e.containerWidth : i = 30;
          break;
        case 40:
          o.metaKey ? l = -e.contentHeight : o.altKey ? l = -e.containerHeight : l = -30;
          break;
        case 32:
          o.shiftKey ? l = e.containerHeight : l = -e.containerHeight;
          break;
        case 33:
          l = e.containerHeight;
          break;
        case 34:
          l = -e.containerHeight;
          break;
        case 36:
          l = e.contentHeight;
          break;
        case 35:
          l = -e.contentHeight;
          break;
        default:
          return;
      }
      e.settings.suppressScrollX && i !== 0 || e.settings.suppressScrollY && l !== 0 || (t.scrollTop -= l, t.scrollLeft += i, yt(e), r(i, l) && o.preventDefault());
    }
  });
}
function Ko(e) {
  var t = e.element;
  function n(c, i) {
    var l = Math.floor(t.scrollTop), d = t.scrollTop === 0, u = l + t.offsetHeight === t.scrollHeight, m = t.scrollLeft === 0, f = t.scrollLeft + t.offsetWidth === t.scrollWidth, h;
    return Math.abs(i) > Math.abs(c) ? h = d || u : h = m || f, h ? !e.settings.wheelPropagation : !0;
  }
  function s(c) {
    var i = c.deltaX, l = -1 * c.deltaY;
    return (typeof i > "u" || typeof l > "u") && (i = -1 * c.wheelDeltaX / 6, l = c.wheelDeltaY / 6), c.deltaMode && c.deltaMode === 1 && (i *= 10, l *= 10), i !== i && l !== l && (i = 0, l = c.wheelDelta), c.shiftKey ? [-l, -i] : [i, l];
  }
  function r(c, i, l) {
    if (!At.isWebKit && t.querySelector("select:focus"))
      return !0;
    if (!t.contains(c))
      return !1;
    for (var d = c; d && d !== t; ) {
      if (d.classList.contains(Ke.element.consuming))
        return !0;
      var u = vt(d);
      if (l && u.overflowY.match(/(scroll|auto)/)) {
        var m = d.scrollHeight - d.clientHeight;
        if (m > 0 && (d.scrollTop > 0 && l < 0 || d.scrollTop < m && l > 0))
          return !0;
      }
      if (i && u.overflowX.match(/(scroll|auto)/)) {
        var f = d.scrollWidth - d.clientWidth;
        if (f > 0 && (d.scrollLeft > 0 && i < 0 || d.scrollLeft < f && i > 0))
          return !0;
      }
      d = d.parentNode;
    }
    return !1;
  }
  function o(c) {
    var i = s(c), l = i[0], d = i[1];
    if (!r(c.target, l, d)) {
      var u = !1;
      e.settings.useBothWheelAxes ? e.scrollbarYActive && !e.scrollbarXActive ? (d ? t.scrollTop -= d * e.settings.wheelSpeed : t.scrollTop += l * e.settings.wheelSpeed, u = !0) : e.scrollbarXActive && !e.scrollbarYActive && (l ? t.scrollLeft += l * e.settings.wheelSpeed : t.scrollLeft -= d * e.settings.wheelSpeed, u = !0) : (t.scrollTop -= d * e.settings.wheelSpeed, t.scrollLeft += l * e.settings.wheelSpeed), yt(e), u = u || n(l, d), u && !c.ctrlKey && (c.stopPropagation(), c.preventDefault());
    }
  }
  typeof window.onwheel < "u" ? e.event.bind(t, "wheel", o) : typeof window.onmousewheel < "u" && e.event.bind(t, "mousewheel", o);
}
function qo(e) {
  if (!At.supportsTouch && !At.supportsIePointer)
    return;
  var t = e.element;
  function n(v, g) {
    var p = Math.floor(t.scrollTop), y = t.scrollLeft, b = Math.abs(v), k = Math.abs(g);
    if (k > b) {
      if (g < 0 && p === e.contentHeight - e.containerHeight || g > 0 && p === 0)
        return window.scrollY === 0 && g > 0 && At.isChrome;
    } else if (b > k && (v < 0 && y === e.contentWidth - e.containerWidth || v > 0 && y === 0))
      return !0;
    return !0;
  }
  function s(v, g) {
    t.scrollTop -= g, t.scrollLeft -= v, yt(e);
  }
  var r = {}, o = 0, c = {}, i = null;
  function l(v) {
    return v.targetTouches ? v.targetTouches[0] : v;
  }
  function d(v) {
    return v.pointerType && v.pointerType === "pen" && v.buttons === 0 ? !1 : !!(v.targetTouches && v.targetTouches.length === 1 || v.pointerType && v.pointerType !== "mouse" && v.pointerType !== v.MSPOINTER_TYPE_MOUSE);
  }
  function u(v) {
    if (d(v)) {
      var g = l(v);
      r.pageX = g.pageX, r.pageY = g.pageY, o = new Date().getTime(), i !== null && clearInterval(i);
    }
  }
  function m(v, g, p) {
    if (!t.contains(v))
      return !1;
    for (var y = v; y && y !== t; ) {
      if (y.classList.contains(Ke.element.consuming))
        return !0;
      var b = vt(y);
      if (p && b.overflowY.match(/(scroll|auto)/)) {
        var k = y.scrollHeight - y.clientHeight;
        if (k > 0 && (y.scrollTop > 0 && p < 0 || y.scrollTop < k && p > 0))
          return !0;
      }
      if (g && b.overflowX.match(/(scroll|auto)/)) {
        var M = y.scrollWidth - y.clientWidth;
        if (M > 0 && (y.scrollLeft > 0 && g < 0 || y.scrollLeft < M && g > 0))
          return !0;
      }
      y = y.parentNode;
    }
    return !1;
  }
  function f(v) {
    if (d(v)) {
      var g = l(v), p = { pageX: g.pageX, pageY: g.pageY }, y = p.pageX - r.pageX, b = p.pageY - r.pageY;
      if (m(v.target, y, b))
        return;
      s(y, b), r = p;
      var k = new Date().getTime(), M = k - o;
      M > 0 && (c.x = y / M, c.y = b / M, o = k), n(y, b) && v.preventDefault();
    }
  }
  function h() {
    e.settings.swipeEasing && (clearInterval(i), i = setInterval(function() {
      if (e.isInitialized) {
        clearInterval(i);
        return;
      }
      if (!c.x && !c.y) {
        clearInterval(i);
        return;
      }
      if (Math.abs(c.x) < 0.01 && Math.abs(c.y) < 0.01) {
        clearInterval(i);
        return;
      }
      if (!e.element) {
        clearInterval(i);
        return;
      }
      s(c.x * 30, c.y * 30), c.x *= 0.8, c.y *= 0.8;
    }, 10));
  }
  At.supportsTouch ? (e.event.bind(t, "touchstart", u), e.event.bind(t, "touchmove", f), e.event.bind(t, "touchend", h)) : At.supportsIePointer && (window.PointerEvent ? (e.event.bind(t, "pointerdown", u), e.event.bind(t, "pointermove", f), e.event.bind(t, "pointerup", h)) : window.MSPointerEvent && (e.event.bind(t, "MSPointerDown", u), e.event.bind(t, "MSPointerMove", f), e.event.bind(t, "MSPointerUp", h)));
}
var _o = function() {
  return {
    handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollingThreshold: 1e3,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: !1,
    suppressScrollY: !1,
    swipeEasing: !0,
    useBothWheelAxes: !1,
    wheelPropagation: !0,
    wheelSpeed: 1
  };
}, zo = {
  "click-rail": Fo,
  "drag-thumb": Vo,
  keyboard: jo,
  wheel: Ko,
  touch: qo
}, jt = function(t, n) {
  var s = this;
  if (n === void 0 && (n = {}), typeof t == "string" && (t = document.querySelector(t)), !t || !t.nodeName)
    throw new Error("no element is specified to initialize PerfectScrollbar");
  this.element = t, t.classList.add(Ke.main), this.settings = _o();
  for (var r in n)
    this.settings[r] = n[r];
  this.containerWidth = null, this.containerHeight = null, this.contentWidth = null, this.contentHeight = null;
  var o = function() {
    return t.classList.add(Ke.state.focus);
  }, c = function() {
    return t.classList.remove(Ke.state.focus);
  };
  this.isRtl = vt(t).direction === "rtl", this.isRtl === !0 && t.classList.add(Ke.rtl), this.isNegativeScroll = function() {
    var d = t.scrollLeft, u = null;
    return t.scrollLeft = -1, u = t.scrollLeft < 0, t.scrollLeft = d, u;
  }(), this.negativeScrollAdjustment = this.isNegativeScroll ? t.scrollWidth - t.clientWidth : 0, this.event = new Yt(), this.ownerDocument = t.ownerDocument || document, this.scrollbarXRail = zt(Ke.element.rail("x")), t.appendChild(this.scrollbarXRail), this.scrollbarX = zt(Ke.element.thumb("x")), this.scrollbarXRail.appendChild(this.scrollbarX), this.scrollbarX.setAttribute("tabindex", 0), this.event.bind(this.scrollbarX, "focus", o), this.event.bind(this.scrollbarX, "blur", c), this.scrollbarXActive = null, this.scrollbarXWidth = null, this.scrollbarXLeft = null;
  var i = vt(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(i.bottom, 10), isNaN(this.scrollbarXBottom) ? (this.isScrollbarXUsingBottom = !1, this.scrollbarXTop = Oe(i.top)) : this.isScrollbarXUsingBottom = !0, this.railBorderXWidth = Oe(i.borderLeftWidth) + Oe(i.borderRightWidth), at(this.scrollbarXRail, { display: "block" }), this.railXMarginWidth = Oe(i.marginLeft) + Oe(i.marginRight), at(this.scrollbarXRail, { display: "" }), this.railXWidth = null, this.railXRatio = null, this.scrollbarYRail = zt(Ke.element.rail("y")), t.appendChild(this.scrollbarYRail), this.scrollbarY = zt(Ke.element.thumb("y")), this.scrollbarYRail.appendChild(this.scrollbarY), this.scrollbarY.setAttribute("tabindex", 0), this.event.bind(this.scrollbarY, "focus", o), this.event.bind(this.scrollbarY, "blur", c), this.scrollbarYActive = null, this.scrollbarYHeight = null, this.scrollbarYTop = null;
  var l = vt(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(l.right, 10), isNaN(this.scrollbarYRight) ? (this.isScrollbarYUsingRight = !1, this.scrollbarYLeft = Oe(l.left)) : this.isScrollbarYUsingRight = !0, this.scrollbarYOuterWidth = this.isRtl ? Xo(this.scrollbarY) : null, this.railBorderYWidth = Oe(l.borderTopWidth) + Oe(l.borderBottomWidth), at(this.scrollbarYRail, { display: "block" }), this.railYMarginHeight = Oe(l.marginTop) + Oe(l.marginBottom), at(this.scrollbarYRail, { display: "" }), this.railYHeight = null, this.railYRatio = null, this.reach = {
    x: t.scrollLeft <= 0 ? "start" : t.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
    y: t.scrollTop <= 0 ? "start" : t.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
  }, this.isAlive = !0, this.settings.handlers.forEach(function(d) {
    return zo[d](s);
  }), this.lastScrollTop = Math.floor(t.scrollTop), this.lastScrollLeft = t.scrollLeft, this.event.bind(this.element, "scroll", function(d) {
    return s.onScroll(d);
  }), yt(this);
};
jt.prototype.update = function() {
  this.isAlive && (this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0, at(this.scrollbarXRail, { display: "block" }), at(this.scrollbarYRail, { display: "block" }), this.railXMarginWidth = Oe(vt(this.scrollbarXRail).marginLeft) + Oe(vt(this.scrollbarXRail).marginRight), this.railYMarginHeight = Oe(vt(this.scrollbarYRail).marginTop) + Oe(vt(this.scrollbarYRail).marginBottom), at(this.scrollbarXRail, { display: "none" }), at(this.scrollbarYRail, { display: "none" }), yt(this), Zt(this, "top", 0, !1, !0), Zt(this, "left", 0, !1, !0), at(this.scrollbarXRail, { display: "" }), at(this.scrollbarYRail, { display: "" }));
};
jt.prototype.onScroll = function(t) {
  this.isAlive && (yt(this), Zt(this, "top", this.element.scrollTop - this.lastScrollTop), Zt(
    this,
    "left",
    this.element.scrollLeft - this.lastScrollLeft
  ), this.lastScrollTop = Math.floor(this.element.scrollTop), this.lastScrollLeft = this.element.scrollLeft);
};
jt.prototype.destroy = function() {
  this.isAlive && (this.event.unbindAll(), $t(this.scrollbarX), $t(this.scrollbarY), $t(this.scrollbarXRail), $t(this.scrollbarYRail), this.removePsClasses(), this.element = null, this.scrollbarX = null, this.scrollbarY = null, this.scrollbarXRail = null, this.scrollbarYRail = null, this.isAlive = !1);
};
jt.prototype.removePsClasses = function() {
  this.element.className = this.element.className.split(" ").filter(function(t) {
    return !t.match(/^ps([-_].+|)$/);
  }).join(" ");
};
const Xs = ({
  className: e,
  sidenav: t,
  tag: n = "div",
  handlers: s = ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
  wheelSpeed: r = 1,
  wheelPropagation: o = !0,
  swipeEasing: c = !0,
  minScrollbarLength: i,
  maxScrollbarLength: l,
  scrollingThreshold: d = 1e3,
  useBothWheelAxes: u = !1,
  suppressScrollX: m = !1,
  suppressScrollY: f = !1,
  scrollXMarginOffset: h = 0,
  scrollYMarginOffset: v = 0,
  scrollBarRef: g,
  onScrollY: p,
  onScrollX: y,
  onScrollUp: b,
  onScrollDown: k,
  onScrollLeft: M,
  onScrollRight: L,
  onYReachStart: I,
  onYReachEnd: T,
  onXReachStart: x,
  onXReachEnd: V,
  children: Y,
  options: H,
  // prop considered to be removed in major release
  ...A
}) => {
  const J = E(t && "sidenav-menu", e), D = te(null), Q = te(null);
  return B(() => {
    let _ = null;
    const U = [], $ = {
      handlers: s,
      wheelSpeed: r,
      wheelPropagation: o,
      swipeEasing: c,
      minScrollbarLength: i,
      maxScrollbarLength: l,
      scrollingThreshold: d,
      useBothWheelAxes: u,
      suppressScrollX: m,
      suppressScrollY: f,
      scrollXMarginOffset: h,
      scrollYMarginOffset: v,
      ...H
    };
    if (!D.current)
      return;
    _ = D.current, Q.current = new jt(_, $);
    const X = {
      "ps-scroll-y": p,
      "ps-scroll-x": y,
      "ps-scroll-up": b,
      "ps-scroll-down": k,
      "ps-scroll-left": M,
      "ps-scroll-right": L,
      "ps-y-reach-start": I,
      "ps-y-reach-end": T,
      "ps-x-reach-start": x,
      "ps-x-reach-end": V
    };
    return Object.keys(X).forEach((O) => {
      const C = X[O];
      if (typeof C == "function" && _) {
        const q = () => C(_);
        U.push({ eventName: O, handler: q }), _.addEventListener(O, q);
      }
    }), g && g(Q.current), () => {
      var O;
      U.forEach((C) => {
        _ == null || _.removeEventListener(C.eventName, C.handler);
      }), (O = Q.current) == null || O.destroy(), Q.current = null;
    };
  }, [
    s,
    r,
    o,
    c,
    i,
    l,
    d,
    u,
    m,
    f,
    h,
    v,
    g,
    p,
    y,
    b,
    k,
    M,
    L,
    I,
    T,
    x,
    V,
    H
  ]), /* @__PURE__ */ a(n, { className: J, ref: D, ...A, children: Y });
}, Os = ne.createContext({
  color: "primary"
}), Pt = (e) => {
  const [t] = e.touches;
  return {
    x: t.clientX,
    y: t.clientY
  };
}, on = ({ x: e, y: t }) => ({
  x: {
    direction: e < 0 ? "left" : "right",
    value: Math.abs(e)
  },
  y: {
    direction: t < 0 ? "up" : "down",
    value: Math.abs(t)
  }
}), Kn = ({ x: e, y: t }, { x: n, y: s }) => ({
  x: e - n,
  y: t - s
}), Uo = ({ x1: e, x2: t, y1: n, y2: s }) => Math.sqrt((t - e) ** 2 + (s - n) ** 2), Go = (e) => {
  let t = null;
  const n = Number.MIN_VALUE;
  for (const s of e)
    s.clientX > n && (t = s);
  return t;
}, Qo = (e, t, n, s) => {
  const o = Math.atan2(s - t, n - e) * (180 / Math.PI);
  return Math.round(o + 360) % 360;
}, Jo = ({ x1: e, x2: t, y1: n, y2: s }) => ({
  x: e + (t - e) / 2,
  y: n + (s - n) / 2
}), qn = (e) => {
  const [t, n] = e, s = {
    x1: t.clientX,
    x2: n.clientX,
    y1: t.clientY,
    y2: n.clientY
  };
  return [Uo(s), Jo(s)];
}, _n = (e, t) => typeof e == "number" && typeof t == "number" && !isNaN(e) && !isNaN(t), Zo = ({
  tag: e = "div",
  children: t,
  touchRef: n,
  type: s,
  threshold: r = 10,
  allDirections: o = !1,
  onSwipe: c,
  onSwipeLeft: i,
  onSwipeRight: l,
  onSwipeUp: d,
  onSwipeDown: u,
  onPan: m,
  onPanLeft: f,
  onPanRight: h,
  onPanUp: v,
  onPanDown: g,
  onPinch: p,
  onRotate: y,
  onTap: b,
  onPress: k,
  pointers: M = 1,
  interval: L = 500,
  taps: I = 1,
  duration: T = 250,
  preventSwipeScroll: x = !0,
  ...V
}) => {
  const Y = te(null), H = n || Y, [A, J] = N(null), [D, Q] = N(null), [_, U] = N(null), [$, X] = N(null), [O, C] = N({ x: 0, y: 0 }), [q, F] = N(null), [j, w] = N(0), [W, le] = N(0), [ue, de] = N(0), [re, De] = N(0), [pe, Ne] = N(0), [he, fe] = N({ x: 0, y: 0 }), [ye, Le] = N(0), [Me, ke] = N(null), ae = te();
  B(() => {
    s === "tap" && (ye === 1 && (ae.current = window.setTimeout(() => {
      Le(0);
    }, L)), ye === I && (window.clearTimeout(ae.current), Le(0), b && b(Me)));
  }, [ye, L, I, b, Me, s]);
  const Te = P(
    (R) => {
      R.touches.length === M && (Le(ye + 1), ke(R));
    },
    [M, ye]
  ), se = P(() => {
  }, []), We = P(() => {
  }, []), Se = P(
    (R) => {
      R.touches.length === M && (ae.current = window.setTimeout(() => {
        k && k(R, T);
      }, T));
    },
    [T, M, k]
  ), $e = P(() => {
  }, []), Ge = P(() => {
    window.clearTimeout(ae.current);
  }, []), nt = P((R) => {
    J(Pt(R));
  }, []), st = P(
    (R) => {
      if (R === "left")
        return i;
      if (R === "right")
        return l;
      if (R === "up")
        return d;
      if (R === "down")
        return u;
    },
    [u, i, l, d]
  ), tt = P(
    (R) => {
      if (R.type === "touchmove" && x && R.preventDefault(), !A)
        return;
      const oe = Pt(R), me = {
        x: oe.x - A.x,
        y: oe.y - A.y
      }, Ee = on(me), { x: Ue, y: _e } = Ee;
      if (o) {
        if (r && _e.value < r && Ue.value < r)
          return;
        const Z = _e.value > Ue.value ? _e.direction : Ue.direction;
        c && c(R, { direction: Z }), J(null);
        return;
      }
      const z = l || i ? "x" : "y";
      if (r && Ee[z].value > r) {
        const Z = st(Ee[z].direction);
        Z && Z(R), J(null);
      }
    },
    [
      o,
      c,
      A,
      r,
      l,
      i,
      st,
      x
    ]
  ), Ve = P(() => {
    J(null);
  }, []), Qe = P((R) => {
    Q(Pt(R)), U(R);
  }, []), dt = P(
    (R) => {
      if (R === "left")
        return f;
      if (R === "right")
        return h;
      if (R === "up")
        return v;
      if (R === "down")
        return g;
    },
    [g, f, h, v]
  ), lt = P(
    (R) => {
      R.type === "touchmove" && R.preventDefault();
      const oe = Pt(R), me = Pt(_), Ee = Kn(oe, D), Ue = Kn(oe, me), _e = on(Ee), z = on(Ue), { x: Z, y: ie } = _e;
      r && o && (ie.value > r || Z.value > r) && m && m(R);
      const ve = f || h ? "x" : "y";
      if (r && _e[ve].value > r) {
        const xe = dt(z[ve].direction);
        xe && xe(R);
      }
      U(R);
    },
    [o, _, D, r, m, f, h, dt]
  ), rt = P((R) => {
    R.type === "touchend" && R.preventDefault(), Q(null), U(null);
  }, []), ot = P(
    (R) => {
      if (R.touches.length !== M)
        return;
      R.type === "touchstart" && R.preventDefault();
      const [oe, me] = qn(R.touches);
      X(oe), Q(oe), C(me);
    },
    [M]
  ), Pe = P(
    (R) => {
      R.touches.length === M && (R.type === "touchmove" && R.preventDefault(), X(qn(R.touches)[0]), typeof D == "number" && typeof $ == "number" && F($ / D), _n(D, $) && typeof O == "object" && (r && O.x > r || r && O.y > r) && (Q($), p && p(R, { ratio: q, origin: O })));
    },
    [M, D, $, r, p, O, q]
  ), qe = P(() => {
    _n(D, $) && Q(null);
  }, [D, $]), ct = P(
    (R) => {
      if (R.type === "touchstart" && R.preventDefault(), R.touches.length === 1 && M === 1) {
        const { left: oe, top: me, width: Ee, height: Ue } = R.target.element.getBoundingClientRect();
        fe({ x: oe + Ee / 2, y: me + Ue / 2 });
      } else if (R.touches.length === 2 && M === 2) {
        const [oe, me] = R.touches, Ee = {
          x1: me.clientX,
          x2: oe.clientX,
          y1: me.clientY,
          y2: oe.clientY
        };
        fe({
          x: (Ee.x1 + Ee.x2) / 2,
          y: (Ee.y1 + Ee.y2) / 2
        });
      } else
        return;
    },
    [M]
  ), S = P(
    (R) => {
      R.type === "touchmove" && R.preventDefault();
      let oe;
      if (R.touches.length === 1 && M === 1)
        oe = R.touches[0];
      else if (R.touches.length === 2 && M === 2)
        oe = Go(R.touches);
      else
        return;
      w(Qo(he.x, he.y, oe.clientX, oe.clientY)), ue ? (Ne(j - W), De(re + pe)) : (le(j), de(j), De(0), Ne(0)), le(j), y && y(R, {
        currentAngle: j,
        distance: re,
        change: pe
      });
    },
    [pe, j, W, he, y, re, ue, M]
  ), ce = P((R) => {
    R.type === "touchend" && R.preventDefault(), w(0), de(0), le(0), Ne(0), De(0);
  }, []);
  return B(() => {
    const R = H.current;
    return s === "tap" && (R.addEventListener("touchstart", Te), R.addEventListener("touchmove", se), R.addEventListener("touchend", We)), s === "press" && (R.addEventListener("touchstart", Se), R.addEventListener("touchmove", $e), R.addEventListener("touchend", Ge)), s === "swipe" && (R.addEventListener("touchstart", nt), R.addEventListener("touchmove", tt), R.addEventListener("touchend", Ve)), s === "pan" && (R.addEventListener("touchstart", Qe), R.addEventListener("touchmove", lt), R.addEventListener("touchend", rt)), s === "pinch" && (R.addEventListener("touchstart", ot), R.addEventListener("touchmove", Pe), R.addEventListener("touchend", qe)), s === "rotate" && (R.addEventListener("touchstart", ct), R.addEventListener("touchmove", S), R.addEventListener("touchend", ce)), () => {
      s === "tap" && (R.removeEventListener("touchstart", Te), R.removeEventListener("touchmove", se), R.removeEventListener("touchend", We)), s === "press" && (R.removeEventListener("touchstart", Se), R.removeEventListener("touchmove", $e), R.removeEventListener("touchend", Ge)), s === "swipe" && (R.removeEventListener("touchstart", nt), R.removeEventListener("touchmove", tt), R.removeEventListener("touchend", Ve)), s === "pan" && (R.removeEventListener("touchstart", Qe), R.removeEventListener("touchmove", lt), R.removeEventListener("touchend", rt)), s === "pinch" && (R.removeEventListener("touchstart", ot), R.removeEventListener("touchmove", Pe), R.removeEventListener("touchend", qe)), s === "rotate" && (R.removeEventListener("touchstart", ct), R.removeEventListener("touchmove", S), R.removeEventListener("touchend", ce));
    };
  }, [
    H,
    Te,
    se,
    We,
    Se,
    $e,
    Ge,
    nt,
    tt,
    Ve,
    Qe,
    lt,
    rt,
    ot,
    Pe,
    qe,
    ct,
    S,
    ce,
    s
  ]), /* @__PURE__ */ a(e, { ref: H, ...V, children: t });
}, yl = ({
  className: e,
  open: t = !0,
  getOpenState: n,
  children: s,
  color: r = "primary",
  backdrop: o = !0,
  slim: c,
  slimCollapsed: i = !0,
  small: l = !1,
  constant: d = !1,
  bgColor: u,
  right: m,
  relative: f,
  absolute: h,
  light: v,
  mode: g = "over",
  contentRef: p,
  closeOnEsc: y = !0,
  onOpen: b,
  onClose: k,
  onExpand: M,
  onCollapse: L,
  nonInvasive: I = !0,
  ...T
}) => {
  const [x, V] = N(t), [Y, H] = N(t), [A, J] = N(0), [D, Q] = N(i), _ = E(
    "sidenav",
    r && `sidenav-${r}`,
    u && `bg-${u}`,
    x ? "sidenav-shown" : "sidenav-hidden",
    f && "sidenav-relative",
    h && "sidenav-absolute",
    v && "sidenav-theme-light",
    m && "sidenav-right",
    c && "sidenav-slim",
    c && D && "sidenav-slim-collapsed",
    l && "sidenav-sm",
    e
  ), U = E("sidenav-content", x ? m ? "right-side-shown" : "side-shown" : "side-hidden"), $ = E("sidenav-content", x ? m ? "right-push-shown" : "push-shown" : "push-hidden"), X = te(null);
  B(() => {
    if (!x)
      return;
    const F = () => {
      const w = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - w);
    };
    if (window.innerWidth > document.documentElement.clientWidth && window.innerWidth >= 576 && !I) {
      const w = F();
      document.body.classList.add("modal-open"), document.body.style.overflow = "hidden", document.body.style.paddingRight = `${w}px`;
    } else
      document.body.classList.remove("modal-open"), document.body.style.overflow = "", document.body.style.paddingRight = "";
    return () => {
      document.body.classList.remove("modal-open"), document.body.style.overflow = "", document.body.style.paddingRight = "";
    };
  }, [I, x]);
  const O = P(
    (F) => {
      var j;
      !d && o && g === "over" && F.target !== X.current && !((j = X.current) != null && j.contains(F.target)) && (V(!1), n && n(!1));
    },
    [X, n, d, o, g]
  ), C = P(
    (F) => {
      y && F.key === "Escape" && (V(!1), n && n(!1));
    },
    [n, y]
  ), q = P(() => {
    var F;
    J(f || h ? (F = X.current) == null ? void 0 : F.offsetHeight : window.innerHeight);
  }, [h, f]);
  return B(() => {
    var F;
    J((F = X.current) == null ? void 0 : F.offsetHeight);
  }, []), B(() => {
    p && (g === "push" ? p.className = $ : g === "side" ? p.className = U : p.className = "sidenav-content");
  }, [g, p, U, $]), B(() => (x && (document.addEventListener("click", O), document.addEventListener("keydown", C), window.addEventListener("resize", q)), () => {
    document.removeEventListener("click", O), document.removeEventListener("keydown", C), window.removeEventListener("resize", q);
  }), [O, C, q, x]), B(() => {
    c && (Q(i), i ? L == null || L() : M == null || M());
  }, [i, c]), B(() => {
    V(t), n && n(t);
  }, [t, n]), B(() => {
    let F, j;
    return x ? (H(!0), F = setTimeout(() => {
      V(!0), b == null || b();
    }, 4)) : (V(!1), j = setTimeout(() => {
      H(!1), k == null || k();
    }, 300)), () => {
      clearTimeout(F), clearTimeout(j);
    };
  }, [x]), /* @__PURE__ */ K(Os.Provider, { value: { color: r }, children: [
    /* @__PURE__ */ a(
      Zo,
      {
        type: "swipe",
        onSwipeLeft: () => {
          c && x && !D && (Q(!0), M == null || M());
        },
        onSwipeRight: () => {
          c && x && D && (Q(!1), L == null || L());
        },
        tag: "nav",
        className: _,
        touchRef: X,
        ...T,
        children: /* @__PURE__ */ a(Xs, { suppressScrollX: !0, style: { height: A }, children: s })
      }
    ),
    o && g === "over" && (Y || x) && /* @__PURE__ */ a(
      "div",
      {
        className: "sidenav-backdrop",
        style: {
          transition: "opacity 0.3s ease-out 0s",
          position: h ? "absolute" : "fixed",
          width: "100%",
          height: "100%",
          opacity: x && Y ? 1 : 0
        }
      }
    )
  ] });
}, ec = ne.forwardRef(
  ({ className: e, children: t, ...n }, s) => {
    const r = E("sidenav-menu", e);
    return /* @__PURE__ */ a("ul", { className: r, ref: s, ...n, children: t });
  }
);
ec.displayName = "MDBSideNavMenu";
const tc = ne.forwardRef(
  ({ className: e, children: t, ...n }, s) => {
    const r = E("sidenav-item", e);
    return /* @__PURE__ */ a("li", { className: r, ref: s, ...n, children: t });
  }
);
tc.displayName = "MDBSideNavItem";
const nc = ne.forwardRef(
  ({ className: e, icon: t, iconClasses: n, iconAngle: s = 180, shouldBeExpanded: r, children: o, active: c, tag: i = "a", ...l }, d) => {
    const { color: u } = He(Os), m = E("sidenav-link", c && "active", e), f = E("rotate-icon", n), [h, v] = N(r ? s : 0);
    return B(() => {
      v(r ? s : 0);
    }, [r, s]), /* @__PURE__ */ K(
      yn,
      {
        rippleTag: i,
        onKeyDown: (g) => {
          g.key === "Enter" && g.target.click();
        },
        tabIndex: 1,
        rippleColor: u,
        className: m,
        ref: d,
        ...l,
        children: [
          o,
          t && /* @__PURE__ */ a(it, { icon: t, style: { transform: `rotate(${h}deg)` }, className: f })
        ]
      }
    );
  }
);
nc.displayName = "MDBSideNavLink";
const wl = ({ className: e, children: t, open: n, collapseRef: s, ...r }) => {
  const o = te(null), c = s || o, i = E("sidenav-collapse", e);
  return B(() => {
    var u;
    const l = (u = c == null ? void 0 : c.current) == null ? void 0 : u.querySelectorAll(".sidenav-link"), d = n ? "1" : "-1";
    l == null || l.forEach((m) => {
      m.setAttribute("tabindex", d);
    });
  }, [n, c]), /* @__PURE__ */ a(Ds, { tag: "ul", open: n, className: i, collapseRef: c, ...r, children: t });
}, Fs = ne.forwardRef(
  ({ className: e, centered: t, children: n, size: s, scrollable: r, tag: o = "div", ...c }, i) => {
    const l = E(
      "modal-dialog",
      r && "modal-dialog-scrollable",
      t && "modal-dialog-centered",
      s && `modal-${s}`,
      e
    );
    return /* @__PURE__ */ a(o, { className: l, ...c, ref: i, children: n });
  }
);
Fs.displayName = "MDBModalDialog";
const sc = ne.forwardRef(
  ({ className: e, side: t, frame: n, position: s, children: r, tag: o = "div", ...c }, i) => {
    const l = E(t && "modal-side", n && "modal-frame", s && `modal-${s}`, e);
    return /* @__PURE__ */ a(Fs, { className: l, ...c, tag: o, ref: i, children: r });
  }
);
sc.displayName = "MDBModalDialog";
const rc = ({
  animation: e = "slide-right",
  animationRef: t,
  className: n,
  children: s,
  delay: r,
  infinite: o,
  duration: c = 500,
  enableTarget: i = !1,
  target: l = !1,
  repeatOnScroll: d,
  reset: u,
  setTarget: m,
  start: f = "onClick",
  style: h,
  tag: v = "div",
  onEnd: g,
  animate: p,
  ...y
}) => {
  const [b, k] = N(f === "onLoad"), M = Fe(() => p === void 0 ? b : p, [p, b]), [L, I] = N(!1), T = te(!0), x = E(M && "animation", M && e, n), V = te(null), Y = t || V, H = () => {
    k((J) => !J);
  }, A = P(() => {
    if (Y.current) {
      const D = Y.current.getBoundingClientRect().top + document.body.scrollTop, Q = Y.current.offsetHeight, _ = window.innerHeight, U = D <= _ && D + Q >= 0;
      U && T.current ? (T.current = !1, r ? setTimeout(() => {
        k(!0), I(!0);
      }, r) : (k(!0), I(!0))) : !U && d && (I(!1), T.current = !0);
    }
  }, [Y, d, r]);
  return B(() => (f === "onScroll" && window.addEventListener("scroll", A), () => {
    window.removeEventListener("scroll", A);
  }), [A, f]), B(() => {
    f === "onLoad" && k(!0);
  }, [f]), B(() => {
    if (M && !o && u) {
      const J = setTimeout(() => {
        k(!1), g == null || g();
      }, c);
      return () => clearTimeout(J);
    }
  }, [M, c, o, u, g]), /* @__PURE__ */ K(be, { children: [
    f === "onClick" && /* @__PURE__ */ a(
      v,
      {
        onClick: H,
        className: x,
        ref: Y,
        ...y,
        style: {
          ...h,
          animationDuration: `${c}ms`,
          animationIterationCount: o ? "infinite" : null,
          animationDelay: r ? `${r}ms` : null
        },
        children: s
      }
    ),
    f === "onHover" && /* @__PURE__ */ a(
      v,
      {
        onMouseEnter: H,
        className: x,
        ref: Y,
        ...y,
        style: {
          ...h,
          animationDuration: `${c}ms`,
          animationIterationCount: o ? "infinite" : null,
          animationDelay: r ? `${r}ms` : null
        },
        children: s
      }
    ),
    (f === "onLoad" || f === "manually") && /* @__PURE__ */ a(
      v,
      {
        className: x,
        ref: Y,
        ...y,
        style: {
          ...h,
          animationDuration: `${c}ms`,
          animationIterationCount: o ? "infinite" : null,
          animationDelay: r ? `${r}ms` : null
        },
        children: s
      }
    ),
    f === "onScroll" && /* @__PURE__ */ a(
      v,
      {
        className: x,
        ref: Y,
        ...y,
        style: {
          ...h,
          animationDuration: `${c}ms`,
          visibility: L ? "visible" : "hidden",
          animationIterationCount: o ? "infinite" : null
        },
        children: s
      }
    )
  ] });
}, nn = ne.createContext({
  onDatetimepickerModeSwitch: () => null,
  isInDatetimepicker: !1,
  setInputValue: null,
  setActiveHour: null,
  setActiveMinute: null,
  setPeriod: null,
  setMode: null,
  setHandAnimation: null,
  setMinuteAngle: null,
  setHourAngle: null,
  submitLabel: "",
  clearLabel: "",
  cancelLabel: "",
  activeHour: 12,
  activeMinute: 12,
  format: "12h",
  period: "",
  defaultValue: "",
  minHour: 0,
  maxHour: 23,
  minPeriod: "",
  maxPeriod: "",
  mode: "hours",
  handAnimation: !1,
  maxMinute: 59,
  minMinute: 0,
  minuteAngle: 360,
  hourAngle: 360,
  inline: !1,
  increment: !1,
  onChange: () => null,
  onOpen: () => null,
  onClose: () => null,
  onCloseHandler: () => null,
  amLabel: "AM",
  pmLabel: "PM",
  switchHoursToMinutesOnClick: !0,
  headId: "",
  bodyId: ""
}), Jt = (e) => {
  const t = e.split(":"), n = t[0], s = t[1].split(" ")[1], r = t[1].split(" ")[0];
  return {
    hour: parseInt(n),
    minute: parseInt(r),
    defaultPeriod: s
  };
}, zn = (e, t) => (t === "24h" ? /^([01]\d|2[0-3])(:[0-5]\d)$/ : /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/).test(e), bt = (e, t, n, s, r, o) => {
  let c = !1;
  return t && (r !== "" ? e > t && s === r && (c = !0) : e > t && (c = !0)), n && (o !== "" ? e < n && s === o && (c = !0) : e < n && (c = !0)), c;
}, cn = (e, t, n, s, r, o, c, i, l) => bt(s, r, o, c, i, l) && (n === t || n === e), oc = (e, t, n) => {
  t.split(" ").forEach((r) => {
    e.addEventListener(r, n);
  });
}, cc = (e, t, n) => {
  t.split(" ").forEach((r) => {
    e.removeEventListener(r, n);
  });
}, Vs = (e, t) => {
  const n = t.x - e.x, s = t.y - e.y;
  return Math.sqrt(n * n + s * s);
}, ic = (e, t) => {
  const n = 2 * Math.atan2(t.y - e.y - Vs(e, t), t.x - e.x);
  return Math.abs(n * 180 / Math.PI);
}, Un = (e) => ({
  radius: (e - 32) / 2 - 4
}), lc = (e) => {
  const t = new Date();
  let n = t.getHours();
  const s = t.getMinutes();
  if (e === "24h")
    return {
      hours: n,
      minutes: s,
      period: ""
    };
  const r = n >= 12 ? "PM" : "AM";
  return n = n % 12, n = n || 12, {
    hours: n,
    minutes: s,
    period: r
  };
}, ln = (e, t) => {
  const n = e.getMinutes();
  let s = e.getHours(), r;
  s === 24 && (s = 0);
  const o = s >= 12 ? "PM" : "AM";
  return t == "24h" ? r = s < 10 ? `0${s}:${n}` : `${s}:${n}` : t == "12h" && (r = `${(s + 24) % 12 || 12}:${n} ${o}`), r;
}, fn = ne.forwardRef(
  ({ ...e }, t) => {
    const {
      activeHour: n,
      format: s,
      period: r,
      setPeriod: o,
      mode: c,
      setMode: i,
      activeMinute: l,
      setHandAnimation: d,
      inline: u,
      setActiveHour: m,
      setActiveMinute: f,
      maxHour: h,
      maxMinute: v,
      minHour: g,
      minMinute: p,
      maxPeriod: y,
      minPeriod: b,
      setInputValue: k,
      increment: M,
      submitLabel: L,
      onChange: I,
      onCloseHandler: T,
      amLabel: x,
      pmLabel: V,
      headId: Y,
      show: H,
      onDatetimepickerModeSwitch: A,
      isInDatetimepicker: J
    } = He(nn), D = ($) => {
      i($), d(!0);
    }, Q = () => {
      if (bt(n, h, g, r, y, b) || bt(l, v, p, r, y, b) || !H)
        return;
      T == null || T();
      const $ = n === 24 ? "00" : n < 10 ? `0${n}` : n, X = l < 10 ? `0${l}` : l, O = `${$}:${X} ${r}`.trim();
      k(O), I == null || I(O);
    }, _ = ($, X) => {
      const O = s === "12h" ? 12 : 24;
      if (X.type === "click")
        return m($ ? (C) => C === O ? 1 : C + 1 : (C) => C === 1 ? O : C - 1);
      if (X.type === "mousedown") {
        const C = setTimeout(() => {
          const F = setInterval(() => {
            m($ ? (w) => w === O ? 1 : w + 1 : (w) => w === 1 ? O : w - 1);
          }, 100), j = () => {
            clearInterval(F), document.removeEventListener("mouseup", j);
          };
          document.addEventListener("mouseup", j);
        }, 300), q = () => {
          clearTimeout(C), document.removeEventListener("mouseup", q);
        };
        document.addEventListener("mouseup", q);
      }
    }, U = ($, X) => {
      const O = M ? 55 : 59, C = M ? 5 : 1;
      if (X.type === "click")
        return f($ ? (q) => q >= O ? 0 : q + C : (q) => q - C < 0 ? O : q - C);
      if (X.type === "mousedown") {
        const q = setTimeout(() => {
          const j = setInterval(() => {
            f($ ? (W) => W >= O ? 0 : W + C : (W) => W - C < 0 ? O : W - C);
          }, 100), w = () => {
            clearInterval(j), document.removeEventListener("mouseup", w);
          };
          document.addEventListener("mouseup", w);
        }, 300), F = () => {
          clearTimeout(q), document.removeEventListener("mouseup", F);
        };
        document.addEventListener("mouseup", F);
      }
    };
    return u ? /* @__PURE__ */ a(
      "div",
      {
        id: Y,
        className: "timepicker-head d-flex flex-row align-items-center justify-content-center timepicker-head-inline",
        style: { paddingRight: "0px" },
        ref: t,
        ...e,
        children: /* @__PURE__ */ K("div", { className: "timepicker-head-content d-flex w-100 justify-content-evenly align-items-center", children: [
          /* @__PURE__ */ K("div", { className: "timepicker-current-wrapper", children: [
            /* @__PURE__ */ K("span", { className: "position-relative h-100 timepicker-inline-hour-icons", children: [
              /* @__PURE__ */ a(
                it,
                {
                  fas: !0,
                  icon: "chevron-up",
                  style: { display: "flex" },
                  className: "position-absolute text-white timepicker-icon-up timepicker-icon-inline-hour",
                  onClick: ($) => _(!0, $),
                  onMouseDown: ($) => _(!0, $)
                }
              ),
              /* @__PURE__ */ a(
                Ae,
                {
                  type: "button",
                  color: "none",
                  onClick: () => {
                    D("hours");
                  },
                  className: `timepicker-current timepicker-current-inline timepicker-hour ${c === "hours" && "active"}`,
                  tabIndex: 0,
                  style: { pointerEvents: c === "hours" ? "none" : void 0 },
                  onFocus: () => {
                    D("hours");
                  },
                  children: n === 24 ? "00" : n < 10 ? `0${n}` : n
                }
              ),
              /* @__PURE__ */ a(
                it,
                {
                  fas: !0,
                  icon: "chevron-down",
                  style: { display: "flex" },
                  className: "position-absolute text-white timepicker-icon-down timepicker-icon-inline-hour",
                  onClick: ($) => _(!1, $),
                  onMouseDown: ($) => _(!1, $)
                }
              )
            ] }),
            /* @__PURE__ */ a(Ae, { color: "none", className: "timepicker-dot timepicker-current-inline", disabled: !0, children: ":" }),
            /* @__PURE__ */ K("span", { className: "position-relative h-100 timepicker-inline-minutes-icons", children: [
              /* @__PURE__ */ a(
                it,
                {
                  fas: !0,
                  icon: "chevron-up",
                  style: { display: "flex" },
                  className: "position-absolute text-white timepicker-icon-up timepicker-icon-inline-minute",
                  onClick: ($) => U(!0, $),
                  onMouseDown: ($) => U(!0, $)
                }
              ),
              /* @__PURE__ */ a(
                Ae,
                {
                  onClick: () => {
                    D("minutes");
                  },
                  type: "button",
                  color: "none",
                  className: `timepicker-current timepicker-current-inline timepicker-minute ${c === "minutes" && "active"}`,
                  tabIndex: 0,
                  style: { pointerEvents: c === "minutes" ? "none" : void 0 },
                  onFocus: () => {
                    D("minutes");
                  },
                  children: l < 10 ? `0${l}` : l
                }
              ),
              /* @__PURE__ */ a(
                it,
                {
                  fas: !0,
                  icon: "chevron-down",
                  style: { display: "flex" },
                  className: "position-absolute text-white timepicker-icon-down timepicker-icon-inline-minute",
                  onClick: ($) => U(!1, $),
                  onMouseDown: ($) => U(!1, $)
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ K("div", { className: "d-flex justify-content-center timepicker-mode-wrapper", children: [
            s === "12h" && /* @__PURE__ */ K(be, { children: [
              /* @__PURE__ */ a(
                Ae,
                {
                  onClick: () => o("AM"),
                  type: "button",
                  color: "none",
                  className: `timepicker-hour-mode timepicker-am me-2 ms-4 ${r.toLowerCase() === "am" && "active"}`,
                  tabIndex: 0,
                  children: x
                }
              ),
              /* @__PURE__ */ a(
                Ae,
                {
                  onClick: () => o("PM"),
                  type: "button",
                  color: "none",
                  className: `timepicker-hour-mode timepicker-pm ${r.toLowerCase() === "pm" && "active"}`,
                  tabIndex: 0,
                  children: V
                }
              )
            ] }),
            /* @__PURE__ */ a(
              Ae,
              {
                type: "button",
                color: "none",
                className: "timepicker-button timepicker-submit timepicker-submit-inline py-1 px-2 mb-0",
                tabIndex: 0,
                onClick: Q,
                children: L
              }
            )
          ] })
        ] })
      }
    ) : /* @__PURE__ */ K(be, { children: [
      /* @__PURE__ */ a(
        "div",
        {
          id: Y,
          className: "timepicker-head d-flex flex-row align-items-center justify-content-center",
          style: { paddingRight: "0px" },
          ref: t,
          ...e,
          children: /* @__PURE__ */ K(
            "div",
            {
              className: "timepicker-head-content d-flex w-100 justify-content-evenly",
              style: { paddingRight: s === "24h" ? "50px" : "" },
              children: [
                /* @__PURE__ */ K("div", { className: "timepicker-current-wrapper", children: [
                  /* @__PURE__ */ a("span", { className: "position-relative h-100", children: /* @__PURE__ */ a(
                    Ae,
                    {
                      type: "button",
                      color: "none",
                      onClick: () => {
                        D("hours");
                      },
                      className: `timepicker-current timepicker-hour ${c === "hours" && "active"}`,
                      tabIndex: 0,
                      style: { pointerEvents: c === "hours" ? "none" : void 0 },
                      children: n === 24 ? "00" : n < 10 ? `0${n}` : n
                    }
                  ) }),
                  /* @__PURE__ */ a(Ae, { color: "none", className: "timepicker-dot", disabled: !0, children: ":" }),
                  /* @__PURE__ */ a("span", { className: "position-relative h-100", children: /* @__PURE__ */ a(
                    Ae,
                    {
                      onClick: () => {
                        D("minutes");
                      },
                      type: "button",
                      color: "none",
                      className: `timepicker-current timepicker-minute ${c === "minutes" && "active"}`,
                      tabIndex: 0,
                      style: { pointerEvents: c === "minutes" ? "none" : void 0 },
                      children: l < 10 ? `0${l}` : l
                    }
                  ) })
                ] }),
                s === "12h" && /* @__PURE__ */ K("div", { className: "d-flex flex-column justify-content-center timepicker-mode-wrapper", children: [
                  /* @__PURE__ */ a(
                    Ae,
                    {
                      onClick: () => o("AM"),
                      type: "button",
                      color: "none",
                      className: `timepicker-hour-mode timepicker-am ${r.toLowerCase() === "am" && "active"}`,
                      tabIndex: 0,
                      children: x
                    }
                  ),
                  /* @__PURE__ */ a(
                    Ae,
                    {
                      onClick: () => o("PM"),
                      type: "button",
                      color: "none",
                      className: `timepicker-hour-mode timepicker-pm ${r.toLowerCase() === "pm" && "active"}`,
                      tabIndex: 0,
                      children: V
                    }
                  )
                ] })
              ]
            }
          )
        }
      ),
      J && /* @__PURE__ */ K("div", { className: "buttons-container", children: [
        /* @__PURE__ */ a("button", { type: "button", className: "datepicker-button-toggle", onClick: A, children: /* @__PURE__ */ a("i", { className: "far fa-calendar datepicker-toggle-icon" }) }),
        /* @__PURE__ */ a("button", { type: "button", className: "timepicker-button-toggle", children: /* @__PURE__ */ a("i", { className: "far fa-clock fa-sm timepicker-icon" }) })
      ] })
    ] });
  }
);
fn.displayName = "MDBTimePickerHeader";
const an = {
  hours: [
    {
      value: 1,
      left: "169px",
      bottom: "209.263px",
      angle: 30,
      id: `hour-1-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 2,
      left: "209.263px",
      bottom: "169px",
      angle: 60,
      id: `hour-2-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 3,
      left: "224px",
      bottom: "114px",
      angle: 90,
      id: `hour-3-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 4,
      left: "209.263px",
      bottom: "59px",
      angle: 120,
      id: `hour-4-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 5,
      left: "169px",
      bottom: "18.7372px",
      angle: 150,
      id: `hour-5-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 6,
      left: "114px",
      bottom: "4px",
      angle: 180,
      id: `hour-6-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 7,
      left: "59px",
      bottom: "18.7372px",
      angle: 210,
      id: `hour-7-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 8,
      left: "18.7372px",
      bottom: "59px",
      angle: 240,
      id: `hour-8-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 9,
      left: "4px",
      bottom: "114px",
      angle: 270,
      id: `hour-9-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 10,
      left: "18.7372px",
      bottom: "169px",
      angle: 300,
      id: `hour-10-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 11,
      left: "59px",
      bottom: "209.263px",
      angle: 330,
      id: `hour-11-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 12,
      left: "114px",
      bottom: "224px",
      angle: 360,
      id: `hour-12-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 13,
      left: "94px",
      bottom: "115.962px",
      angle: 30,
      id: `hour-13-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 14,
      left: "115.962px",
      bottom: "94px",
      angle: 60,
      id: `hour-14-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 15,
      left: "124px",
      bottom: "64px",
      angle: 90,
      id: `hour-15-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 16,
      left: "115.962px",
      bottom: "34px",
      angle: 120,
      id: `hour-16-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 17,
      left: "94px",
      bottom: "12.0385px",
      angle: 150,
      id: `hour-17-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 18,
      left: "64px",
      bottom: "4px",
      angle: 180,
      id: `hour-18-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 19,
      left: "34px",
      bottom: "12.0385px",
      angle: 210,
      id: `hour-19-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 20,
      left: "12.0385px",
      bottom: "34px",
      angle: 240,
      id: `hour-20-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 21,
      left: "4px",
      bottom: "64px",
      angle: 270,
      id: `hour-21-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 22,
      left: "12.0385px",
      bottom: "94px",
      angle: 300,
      id: `hour-22-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 23,
      left: "34px",
      bottom: "115.962px",
      angle: 330,
      id: `hour-23-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 24,
      left: "64px",
      bottom: "124px",
      angle: 360,
      id: `hour-0-${Math.floor(Math.random() * 1001)}`
    }
  ],
  //   ---------------------------------------------------------------------- MINUTES --------------------------------------------------------------------------
  minutes: [
    {
      value: 0,
      left: "114px",
      bottom: "224px",
      angle: 360,
      id: `minute-0-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 5,
      left: "169px",
      bottom: "209.263px",
      angle: 30,
      id: `minute-5-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 10,
      left: "209.263px",
      bottom: "169px",
      angle: 60,
      id: `minute-10-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 15,
      left: "224px",
      bottom: "114px",
      angle: 90,
      id: `minute-15-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 20,
      left: "209.263px",
      bottom: "59px",
      angle: 120,
      id: `minute-20-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 25,
      left: "169px",
      bottom: "18.7372px",
      angle: 150,
      id: `minute-25-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 30,
      left: "114px",
      bottom: "4px",
      angle: 180,
      id: `minute-30-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 35,
      left: "59px",
      bottom: "18.7372px",
      angle: 210,
      id: `minute-35-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 40,
      left: "18.7372px",
      bottom: "59px",
      angle: 240,
      id: `minute-40-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 45,
      left: "4px",
      bottom: "114px",
      angle: 270,
      id: `minute-45-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 50,
      left: "18.7372px",
      bottom: "169px",
      angle: 300,
      id: `minute-50-${Math.floor(Math.random() * 1001)}`
    },
    {
      value: 55,
      left: "59px",
      bottom: "209.263px",
      angle: 330,
      id: `minute-55-${Math.floor(Math.random() * 1001)}`
    }
  ]
}, js = ne.forwardRef(
  ({ ...e }, t) => {
    const n = te(null), s = te(null), [r, o] = N(!1), [c, i] = N(0), [l, d] = N(0), {
      setActiveHour: u,
      format: m,
      activeHour: f,
      minHour: h,
      maxHour: v,
      minPeriod: g,
      maxPeriod: p,
      period: y,
      mode: b,
      setMode: k,
      activeMinute: M,
      setActiveMinute: L,
      setHandAnimation: I,
      handAnimation: T,
      maxMinute: x,
      minMinute: V,
      hourAngle: Y,
      setHourAngle: H,
      minuteAngle: A,
      setMinuteAngle: J,
      increment: D,
      switchHoursToMinutesOnClick: Q,
      bodyId: _
    } = He(nn), U = m === "24h" ? an.hours : an.hours.filter((w) => w.value < 13 && w.value !== 0), $ = an.minutes, [X, O] = N("calc(40% + 1px)"), C = P(ic, []), q = (w) => {
      w.preventDefault(), o(!0);
    }, F = (w) => {
      w.preventDefault(), o(!1), b === "hours" && (Q && k("minutes"), I(!0));
    }, j = P(
      (w) => {
        var he;
        const { width: W, top: le, left: ue } = (he = n.current) == null ? void 0 : he.getBoundingClientRect(), { clientX: de, clientY: re } = "touches" in w ? w.touches[0] : w, De = { x: W / 2, y: -W / 2 }, pe = { x: de - ue, y: le - re }, Ne = Math.round(C(De, pe) + 360) % 360;
        if (b === "hours") {
          const fe = 30 * Math.round(Ne / 30);
          let ye = fe / 30;
          if (m === "24h") {
            const { radius: Le } = Un(c), { radius: Me } = Un(l);
            Vs(De, pe) < (Le + Me) / 2 - 16 && (ye += 12);
          }
          bt(ye, v, h, y, p, g) || (u(ye), H(fe));
        } else if (Ne === 0)
          cn(h, v, f, 0, x, V, y, p, g) || (L(0), J(360));
        else {
          const fe = D ? 30 : 6, ye = fe * Math.round(Ne / fe);
          cn(
            h,
            v,
            f,
            ye / 6,
            x,
            V,
            y,
            p,
            g
          ) || (L(ye / 6 === 60 ? 0 : ye / 6), J(ye));
        }
      },
      [
        C,
        f,
        x,
        V,
        p,
        g,
        b,
        y,
        L,
        v,
        h,
        u,
        l,
        c,
        m,
        H,
        J,
        D
      ]
    );
    return B(() => {
      n.current && i(n.current.offsetWidth), s.current && d(s.current.offsetWidth);
    }, []), B(() => (r && oc(document, "mouseup mousemove mouseleave mouseover touchstart touchmove touchend", j), () => {
      cc(document, "mouseup mousemove mouseleave mouseover touchstart touchmove touchend", j);
    }), [r, j]), B(() => {
      const w = U.find((W) => W.value === f);
      w !== void 0 && (w.value > 12 || w.value === 24 ? O("21.5%") : O("calc(40% + 1px)"));
    }, [U, f]), /* @__PURE__ */ a(
      "div",
      {
        id: _,
        className: "timepicker-clock-wrapper d-flex justify-content-center flex-column align-items-center",
        ref: t,
        ...e,
        children: /* @__PURE__ */ K(
          "div",
          {
            onMouseDown: (w) => q(w),
            onMouseUp: (w) => F(w),
            ref: n,
            className: "timepicker-clock timepicker-clock-animation",
            children: [
              /* @__PURE__ */ a("span", { className: "timepicker-middle-dot position-absolute" }),
              /* @__PURE__ */ a(
                "div",
                {
                  className: `timepicker-hand-pointer position-absolute ${T && "timepicker-transform"}`,
                  style: {
                    transform: `rotateZ(${b === "hours" ? Y : A}deg)`,
                    height: b === "hours" ? X : "calc(40% + 1px)"
                  },
                  children: /* @__PURE__ */ a("div", { className: "timepicker-circle position-absolute", style: { backgroundColor: "rgb(25, 118, 210)" } })
                }
              ),
              b === "hours" && m === "24h" && /* @__PURE__ */ a("div", { ref: s, className: "timepicker-clock-inner", children: U.map((w) => {
                if (w.value > 12 || w.value === 0)
                  return /* @__PURE__ */ a(
                    "span",
                    {
                      id: w.id,
                      className: `timepicker-time-tips-inner ${bt(w.value, v, h, y, p, g) && "disabled"} ${w.value === f && "active"}`,
                      style: { left: w.left, bottom: w.bottom },
                      children: /* @__PURE__ */ a("span", { className: "timepicker-tips-inner-element", children: w.value === 24 ? "00" : w.value })
                    },
                    w.id
                  );
              }) }),
              b === "hours" && U.map((w) => {
                if (m === "24h") {
                  if (w.value < 13 && w.value !== 0)
                    return /* @__PURE__ */ a(
                      "span",
                      {
                        id: w.id,
                        className: `timepicker-time-tips-hours ${bt(w.value, v, h, y, p, g) && "disabled"} ${w.value === f && "active"}`,
                        style: { left: w.left, bottom: w.bottom },
                        children: /* @__PURE__ */ a("span", { className: "timepicker-tips-element", children: w.value })
                      },
                      w.id
                    );
                } else
                  return /* @__PURE__ */ a(
                    "span",
                    {
                      id: w.id,
                      className: `timepicker-time-tips-hours ${bt(w.value, v, h, y, p, g) && "disabled"} ${w.value === f && "active"}`,
                      style: { left: w.left, bottom: w.bottom },
                      children: /* @__PURE__ */ a("span", { className: "timepicker-tips-element", children: w.value })
                    },
                    w.id
                  );
              }),
              b === "minutes" && $.map((w) => /* @__PURE__ */ a(
                "span",
                {
                  id: w.id,
                  className: `timepicker-time-tips-minutes ${cn(
                    h,
                    v,
                    f,
                    w.value,
                    x,
                    V,
                    y,
                    p,
                    g
                  ) && "disabled"} ${M === w.value && "active"}`,
                  style: { left: w.left, bottom: w.bottom },
                  children: /* @__PURE__ */ a("span", { className: "timepicker-tips-element", children: w.value < 10 ? `0${w.value}` : w.value })
                },
                w.id
              ))
            ]
          }
        )
      }
    );
  }
);
js.displayName = "MDBTimePickerClock";
const Ks = ne.forwardRef(
  ({ ...e }, t) => {
    const {
      setInputValue: n,
      cancelLabel: s,
      submitLabel: r,
      clearLabel: o,
      activeHour: c,
      period: i,
      activeMinute: l,
      maxHour: d,
      maxMinute: u,
      minHour: m,
      minMinute: f,
      maxPeriod: h,
      minPeriod: v,
      defaultValue: g,
      setActiveHour: p,
      setActiveMinute: y,
      setPeriod: b,
      format: k,
      setHourAngle: M,
      setMinuteAngle: L,
      onChange: I,
      onCloseHandler: T,
      setMode: x
    } = He(nn);
    return /* @__PURE__ */ a("div", { className: "timepicker-footer", ref: t, ...e, children: /* @__PURE__ */ K("div", { className: "w-100 d-flex justify-content-between", children: [
      /* @__PURE__ */ a(
        Ae,
        {
          onClick: () => {
            if (g !== "" && g !== void 0) {
              const { hour: H, minute: A, defaultPeriod: J } = Jt(g);
              k === "24h" ? (p(H === 0 ? 24 : H), H === 0 ? M(360) : H > 12 ? M((H - 12) * 30) : M(H * 30)) : (p(H), M(H * 30), b(J)), y(A), L(A * 6), n(g), I == null || I(g);
            } else
              p(12), M(360), y(0), L(360), n(""), I == null || I(""), b(k === "24h" ? "" : "AM");
            x("hours");
          },
          type: "button",
          color: "none",
          className: "timepicker-button timepicker-clear",
          tabIndex: 0,
          children: o
        }
      ),
      /* @__PURE__ */ a(
        Ae,
        {
          onClick: () => T == null ? void 0 : T(),
          type: "button",
          color: "none",
          className: "timepicker-button timepicker-cancel",
          tabIndex: 0,
          children: s
        }
      ),
      /* @__PURE__ */ a(
        Ae,
        {
          onClick: () => {
            if (bt(c, d, m, i, h, v) || bt(l, u, f, i, h, v))
              return;
            T == null || T();
            const H = c === 24 ? "00" : c < 10 ? `0${c}` : c, A = l < 10 ? `0${l}` : l, J = `${H}:${A} ${i}`.trim();
            n(J), I == null || I(J);
          },
          type: "button",
          color: "none",
          className: "timepicker-button timepicker-submit",
          tabIndex: 0,
          children: r
        }
      )
    ] }) });
  }
);
Ks.displayName = "MDBTimePickerFooter";
const ac = ({ isOpen: e, inline: t }) => {
  B(() => {
    if (t)
      return;
    const n = window.innerWidth > document.documentElement.clientWidth && window.innerWidth >= 576, r = `${(() => window.innerWidth - document.documentElement.clientWidth)()}px`;
    return e && n ? (document.body.style.overflow = "hidden", document.body.style.paddingRight = r) : (document.body.style.overflow = "", document.body.style.paddingRight = ""), () => {
      document.body.style.overflow = "", document.body.style.paddingRight = "";
    };
  }, [e, t]);
}, uc = ({
  className: e,
  isOpen: t,
  wrapperRef: n,
  inline: s,
  referenceElement: r,
  onOpened: o,
  onClosed: c
}) => {
  const [i, l] = N(null), d = E("timepicker-modal", !s && "position-fixed", e), u = E(
    "timepicker-wrapper",
    "animation",
    "h-100",
    "d-flex",
    "align-items-center",
    "justify-content-center",
    "flex-column",
    s ? "timepicker-wrapper-inline" : "position-fixed",
    "fade",
    t && "show"
  ), { styles: m, attributes: f } = wt(r, i, {
    placement: "bottom-start"
  }), h = (v) => {
    v.opacity === 0 ? c() : o();
  };
  return ac({ isOpen: t, inline: s }), /* @__PURE__ */ a(be, { children: /* @__PURE__ */ a(pt, { children: /* @__PURE__ */ a(Ft, { children: t && (s ? /* @__PURE__ */ a(
    Mt.div,
    {
      className: d,
      style: m.popper,
      ...f.popper,
      role: "dialog",
      ref: l,
      tabIndex: -1,
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      onAnimationComplete: (v) => h(v),
      children: /* @__PURE__ */ a("div", { ref: n, className: u, children: /* @__PURE__ */ a(
        "div",
        {
          className: "d-flex align-items-center justify-content-center flex-column shadow timepicker-container",
          style: { overflowY: "inherit" },
          children: /* @__PURE__ */ a("div", { className: "d-flex flex-column timepicker-elements justify-content-around timepicker-elements-inline", children: /* @__PURE__ */ a(fn, {}) })
        }
      ) })
    }
  ) : /* @__PURE__ */ a(
    Mt.div,
    {
      className: d,
      role: "dialog",
      tabIndex: -1,
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 0.3 },
      onAnimationComplete: (v) => h(v),
      children: /* @__PURE__ */ a("div", { ref: n, className: u, children: /* @__PURE__ */ K("div", { className: "d-flex align-items-center justify-content-center flex-column shadow timepicker-container", children: [
        /* @__PURE__ */ K("div", { className: "d-flex flex-column timepicker-elements justify-content-around", children: [
          /* @__PURE__ */ a(fn, {}),
          /* @__PURE__ */ a(js, {})
        ] }),
        /* @__PURE__ */ a(Ks, {})
      ] }) })
    }
  )) }) }) });
}, Gn = (e, t, n, s, r) => {
  const o = n ? 55 : 59, c = n ? 5 : 1;
  let i;
  r ? i = s >= o ? 0 : s + c : i = s <= 0 ? o : s - c, e(i), t(i * 6);
}, Gt = (e, t, n, s, r, o) => {
  if (o && e === "24h") {
    let l = t;
    o === "isLeft" && (l = t <= 12 ? t + 12 : t), o === "isRight" && (l = t > 12 ? t - 12 : t), n(l), s(l * 30);
    return;
  }
  const c = e === "12h" ? 12 : 24;
  let i = t === 1 ? c : t - 1;
  r ? i = t === c ? 1 : t + 1 : i = t === 1 ? c : t - 1, n(i), s(i * 30);
}, Qn = (e, t, n) => {
  const s = n == null ? void 0 : n.querySelectorAll('[tabindex="0"]');
  s && s[t] && (s[t].focus(), t === s.length - 1 ? e(0) : e(t + 1));
}, dc = (e, t, n, s, r, o) => {
  var c;
  !t && e.target === n && o && (o == null || o()), t && e.target !== n && !(n != null && n.contains(e.target)) && e.target !== (s == null ? void 0 : s.parentNode) && !((c = s == null ? void 0 : s.parentNode) != null && c.contains(e.target)) && r && (o == null || o());
}, Jn = "ArrowLeft", Zn = "ArrowUp", es = "ArrowRight", ts = "ArrowDown", ns = "Enter", ss = "Escape", rs = "Tab", qs = Lt(
  ({
    isInDatetimepicker: e,
    onDatetimepickerModeSwitch: t,
    datetimepickerRef: n,
    className: s,
    defaultValue: r,
    value: o,
    minHour: c,
    maxHour: i,
    maxTime: l,
    minTime: d,
    noIcon: u = !1,
    inputID: m,
    justInput: f = !1,
    inputClasses: h,
    inputLabel: v,
    invalidLabel: g,
    clearLabel: p,
    submitLabel: y,
    cancelLabel: b,
    format: k = "12h",
    timePickerClasses: M,
    customIcon: L = "far fa-clock",
    customIconSize: I = "sm",
    btnIcon: T = !0,
    inline: x = !1,
    increment: V = !1,
    onChange: Y,
    inputStyle: H,
    onOpen: A,
    onOpened: J,
    onClose: D,
    onClosed: Q,
    disableFuture: _,
    disablePast: U,
    disabled: $ = !1,
    amLabel: X = "AM",
    pmLabel: O = "PM",
    switchHoursToMinutesOnClick: C = !0,
    headId: q = "",
    bodyId: F = "",
    open: j,
    style: w,
    ...W
  }, le) => {
    const ue = Fe(() => r instanceof Date ? ln(r, k) : r, []), de = Fe(() => o instanceof Date ? ln(o, k) : o, [o, k]), [re, De] = N(!1), [pe, Ne] = N(!1), he = Et(pe, j), [fe, ye] = N(de || ue || ""), [Le, Me] = N(!1), [ke, ae] = N(12), [Te, se] = N(0), [We, Se] = N(k === "24h" ? "" : "AM"), [$e, Ge] = N(i || 24), [nt, st] = N(c || 1), [tt, Ve] = N(59), [Qe, dt] = N(0), [lt, rt] = N(""), [ot, Pe] = N(""), [qe, ct] = N("hours"), [S, ce] = N(!1), [R, oe] = N(360), [me, Ee] = N(360), [Ue, _e] = N(null), [z, Z] = N(0);
    r instanceof Date && (r = ln(r, k));
    const ie = ar(), ve = m ?? ie, xe = {
      input: v ?? "Select a time",
      invalid: g ?? "Invalid Time Format",
      clear: p ?? "Clear",
      submit: y ?? "Ok",
      cancel: b ?? "Cancel"
    }, Ce = E("timepicker", s), Ye = E("timepicker-input", Le && "is-invalid", h), Xe = te(null), G = te(null), ee = te(null), we = te(null);
    xt(le, () => we.current, [we]);
    const Be = (Re) => {
      ye(Re.target.value), Y == null || Y(Re.target.value);
    }, je = (Re) => {
      f && (Re.target.blur(), A == null || A());
    }, ft = P(() => {
      Ne(!1), D == null || D();
    }, [D]), Tt = P(() => {
      Ne(!0), A == null || A();
    }, [A]), ze = P(() => {
      De(!1), Q == null || Q(), ct("hours"), Z(0);
    }, [Q]), sn = P(() => {
      De(!0), J == null || J();
    }, [J]), qt = P(
      (Re) => {
        re && dc(Re, x, ee.current, we.current, he, ft);
      },
      [ee, x, we, he, ft, re]
    ), rn = P(
      (Re) => {
        var Rn, Hn;
        const { key: mt } = Re, Je = document.activeElement, or = Je === ((Rn = ee.current) == null ? void 0 : Rn.querySelector(".timepicker-hour")), cr = Je === ((Hn = ee.current) == null ? void 0 : Hn.querySelector(".timepicker-minute")), ir = Je == null ? void 0 : Je.closest('.timepicker-modal [tabindex="0"]');
        if (![ts, Zn, ss, rs, ns, Jn, es].includes(mt))
          return;
        x && !ir && Qn(Z, 0, ee.current), Re.preventDefault();
        const _t = !x && qe === "hours" || x && or, $n = !x && qe === "minutes" || x && cr;
        switch (mt) {
          case ss:
            return D == null ? void 0 : D();
          case Zn:
            if (_t)
              return Gt(k, ke, ae, oe, !0);
            if ($n)
              return Gn(se, Ee, V, Te, !0);
            break;
          case ts:
            if (_t)
              return Gt(k, ke, ae, oe, !1);
            if ($n)
              return Gn(se, Ee, V, Te, !1);
            break;
          case Jn:
            if (_t && !x)
              return Gt(k, ke, ae, oe, !1, "isLeft");
            break;
          case es:
            if (_t && !x)
              return Gt(k, ke, ae, oe, !0, "isRight");
            break;
          case rs:
            Qn(Z, z, ee.current);
            break;
          case ns:
            Je.click();
            break;
        }
      },
      [ke, k, qe, Te, V, x, z, D]
    );
    return B(() => {
      if (!U && !_)
        return;
      const { hours: Re, minutes: mt, period: Je } = lc(k);
      if (U)
        return st(Re), dt(mt), rt(Je);
      if (_)
        return Ge(Re), Ve(mt), Pe(Je);
    }, [_, U, k]), B(() => (he && re && (document.addEventListener("click", qt), document.addEventListener("keydown", rn)), () => {
      document.removeEventListener("click", qt), document.removeEventListener("keydown", rn);
    }), [he, re, qt, rn]), B(() => {
      if (l) {
        const { hour: Re, minute: mt, defaultPeriod: Je } = Jt(l);
        Ge(Re), Ve(mt), Je !== void 0 && Pe(Je);
      }
      if (d) {
        const { hour: Re, minute: mt, defaultPeriod: Je } = Jt(d);
        st(Re), dt(mt), Je !== void 0 && rt(Je);
      }
    }, [l, d]), B(() => {
      typeof o == "string" && o && zn(o, k) && ye(o);
    }, [o, k]), B(() => {
      if (zn(fe, k) || fe === "") {
        if (Me(!1), fe !== "") {
          const { hour: Re, minute: mt, defaultPeriod: Je } = Jt(fe);
          k === "24h" ? (ae(Re === 0 ? 24 : Re), Re === 0 ? oe(360) : Re > 12 ? oe((Re - 12) * 30) : oe(Re * 30)) : (ae(Re), oe(Re * 30), Se(Je)), se(mt), Ee(mt * 6);
        }
      } else
        Me(!0);
    }, [fe, k]), B(() => {
      let Re;
      return S && (Re = setTimeout(() => {
        ce(!1);
      }, 400)), () => {
        clearTimeout(Re);
      };
    }, [S]), /* @__PURE__ */ a(be, { children: /* @__PURE__ */ a(
      nn.Provider,
      {
        value: {
          isInDatetimepicker: e,
          onDatetimepickerModeSwitch: t,
          show: he,
          setInputValue: ye,
          submitLabel: xe.submit,
          clearLabel: xe.clear,
          cancelLabel: xe.cancel,
          activeHour: ke,
          activeMinute: Te,
          setActiveHour: ae,
          setActiveMinute: se,
          format: k,
          period: We,
          setPeriod: Se,
          defaultValue: r,
          maxHour: $e,
          minHour: nt,
          maxPeriod: ot,
          minPeriod: lt,
          mode: qe,
          setMode: ct,
          setHandAnimation: ce,
          handAnimation: S,
          minMinute: Qe,
          maxMinute: tt,
          hourAngle: R,
          setHourAngle: oe,
          minuteAngle: me,
          setMinuteAngle: Ee,
          inline: x,
          increment: V,
          onChange: Y,
          onOpen: A,
          onClose: D,
          onCloseHandler: ft,
          amLabel: X,
          pmLabel: O,
          switchHoursToMinutesOnClick: C,
          headId: q,
          bodyId: F
        },
        children: /* @__PURE__ */ K(be, { children: [
          /* @__PURE__ */ a(
            "div",
            {
              className: Ce,
              ref: x ? _e : Xe,
              style: { ...w, height: "fit-content" },
              ...W,
              children: !e && /* @__PURE__ */ a(
                gt,
                {
                  onFocus: je,
                  ref: we,
                  labelRef: G,
                  className: Ye,
                  label: xe.input,
                  id: ve,
                  value: fe,
                  onChange: Be,
                  wrapperClass: "timepicker",
                  style: H,
                  disabled: $,
                  onClick: () => {
                    f && Tt();
                  },
                  children: !f && !u && (T ? /* @__PURE__ */ a(
                    Ae,
                    {
                      className: "timepicker-toggle-button",
                      onClick: Tt,
                      color: "none",
                      tabIndex: 0,
                      type: "button",
                      disabled: $,
                      style: { pointerEvents: $ ? "none" : "auto" },
                      children: /* @__PURE__ */ a("i", { className: `${L} ${I} timepicker-icon` })
                    }
                  ) : /* @__PURE__ */ a(
                    "i",
                    {
                      onClick: Tt,
                      className: `${L} ${I} timepicker-icon timepicker-toggle-button`
                    }
                  ))
                }
              )
            }
          ),
          /* @__PURE__ */ a(
            uc,
            {
              isOpen: he,
              wrapperRef: ee,
              referenceElement: n || Ue,
              inline: x,
              className: M,
              onClosed: ze,
              onOpened: sn
            }
          )
        ] })
      }
    ) });
  }
);
qs.displayName = "MDBTimepicker";
const fc = ({
  className: e,
  dropdown: t,
  children: n,
  styles: s,
  attributes: r,
  setPopperElement: o,
  style: c,
  onClosed: i,
  onOpened: l
}) => {
  const d = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.3 }
  }, u = E("datepicker-dropdown-container", e), m = E("datepicker-modal-container", e), f = (h) => {
    h.opacity === 0 ? i == null || i() : l == null || l();
  };
  return /* @__PURE__ */ a(be, { children: t ? /* @__PURE__ */ a(
    Mt.div,
    {
      style: { position: "absolute", zIndex: 1065, ...s.popper },
      ...r.popper,
      ref: o,
      className: u,
      tabIndex: -1,
      ...d,
      onAnimationComplete: (h) => f(h),
      children: n
    }
  ) : /* @__PURE__ */ a(
    Mt.div,
    {
      ...d,
      className: m,
      style: c,
      onAnimationComplete: (h) => f(h),
      children: n
    }
  ) });
}, Ze = {
  closeOnEsc: !0,
  title: "Select date",
  okBtnText: "Ok",
  clearBtnText: "Clear",
  cancelBtnText: "Cancel",
  customIcon: "far fa-calendar",
  customHeader: "",
  inputLabel: "Select a date",
  monthsFull: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  views: "days",
  format: "dd/mm/yyyy",
  weekdaysFull: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  weekdaysNarrow: ["S", "M", "T", "W", "T", "F", "S"],
  startDay: 0
};
function et(e) {
  return e.getDate();
}
function os(e) {
  return e.getDay();
}
function Ie(e) {
  return e.getMonth();
}
function ge(e) {
  return e.getFullYear();
}
function mc(e, t, n) {
  const s = n, r = s > 0 ? 7 - s : 0, c = new Date(e, t).getDay() + r;
  return c >= 7 ? c - 7 : c;
}
function hc(e) {
  return e.getDate() === Ot(e);
}
function mn(e) {
  return hc(e) ? Ot(new Date(ge(e), Ie(e) + 1, 1)) : et(e);
}
function Ot(e) {
  return pc(e).getDate();
}
function pc(e) {
  return Bt(e.getFullYear(), e.getMonth() + 1, 0);
}
function Rt() {
  return new Date();
}
function ht(e, t) {
  return ut(e, t * 12);
}
function ut(e, t) {
  const n = Bt(e.getFullYear(), e.getMonth() + t, e.getDate()), s = et(e), r = et(n);
  return s !== r && n.setDate(0), n;
}
function It(e, t) {
  return Bt(e.getFullYear(), e.getMonth(), e.getDate() + t);
}
function Bt(e, t, n) {
  const s = new Date(e, t, n);
  return e >= 0 && e < 100 && s.setFullYear(s.getFullYear() - 1900), s;
}
function hn(e) {
  return !Number.isNaN(e.getTime());
}
function cs(e, t) {
  return ge(e) - ge(t) || Ie(e) - Ie(t) || et(e) - et(t);
}
function kt(e, t) {
  return e.setHours(0, 0, 0, 0), t.setHours(0, 0, 0, 0), e.getTime() === t.getTime();
}
function is(e) {
  return parseInt(e, 10) < 10 ? `0${e}` : e;
}
function pn(e, t) {
  const s = ge(e) - _s(0, null, null);
  return vc(s, t);
}
function vc(e, t) {
  return (e % t + t) % t;
}
function _s(e, t, n) {
  let s = 0;
  return n ? s = ge(n) - e + 1 : t && (s = ge(t)), s;
}
function Ht(e, t, n, s) {
  const r = t && cs(e, t) <= 0, o = n && cs(e, n) >= 0, c = s && s(e) === !1;
  return Boolean(r || o || c);
}
function vn(e, t, n, s, r, o) {
  const c = s && ge(s), i = s && Ie(s), l = n && ge(n), d = n && Ie(n), u = new Date().getFullYear(), m = new Date().getMonth();
  if (o && u === t && e < m || r && u === t && e > m || o && u > t || r && u < t)
    return !0;
  const f = i && c ? t > c || t === c && e > i : !1, h = d && l ? t < l || t === l && e < d : !1;
  return f || h;
}
function bn(e, t, n, s, r) {
  const o = new Date().getFullYear();
  if (r && e < o || s && e > o)
    return !0;
  const c = t && ge(t), i = n && ge(n), l = i ? e > i : !1, d = c ? e < c : !1;
  return l || d;
}
function bc(e) {
  return e.match(/[^(dmy)]{1,}/g);
}
function gc(e, t) {
  return t.findIndex((n) => n === e);
}
function ls(e, t, n, s, r) {
  return r ? zs(e, r, t, n, s, r) : !1;
}
function as(e, t, n, s, r) {
  return s ? zs(e, s, t, n, s, r) : !1;
}
function zs(e, t, n, s, r, o) {
  if (n === "days")
    return ge(e) === ge(t) && Ie(e) === Ie(t);
  if (n === "months")
    return ge(e) === ge(t);
  if (n === "years") {
    const c = _s(s, r, o);
    return Math.floor((ge(e) - c) / s) === Math.floor((ge(t) - c) / s);
  }
  return !1;
}
function en(e, t, n, s) {
  let r;
  if (t) {
    const o = bc(t);
    if (o) {
      o[0] !== o[1] ? r = o[0] + o[1] : r = o[0];
      const c = new RegExp(`[${r}]`), i = e.split(c), l = t == null ? void 0 : t.split(c), d = (t == null ? void 0 : t.indexOf("mmm")) !== -1, u = [];
      l == null || l.forEach((p, y) => {
        p.indexOf("yy") !== -1 && (u[0] = { value: i[y], format: p }), p.indexOf("m") !== -1 && (u[1] = { value: i[y], format: p }), p.indexOf("d") !== -1 && p.length <= 2 && (u[2] = { value: i[y], format: p });
      });
      let m;
      (t == null ? void 0 : t.indexOf("mmmm")) !== -1 ? m = n : m = s;
      const f = Number(u[0].value), h = d ? gc(u[1].value, m) : Number(u[1].value) - 1, v = Number(u[2].value);
      return Bt(f, h, v);
    }
  }
}
function us(e, t, n, s, r, o) {
  const c = et(e), i = is(et(e).toString()), l = n[os(e)], d = s[os(e)], u = Ie(e), m = is((Ie(e) + 1).toString()), f = r[Ie(e)], h = o[Ie(e)], v = ge(e).toString().length === 2 ? ge(e) : ge(e).toString().slice(2, 4), g = ge(e), p = t.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
  let y = "";
  return p.forEach((b) => {
    switch (b) {
      case "dddd":
        b = b.replace(b, d);
        break;
      case "ddd":
        b = b.replace(b, l);
        break;
      case "dd":
        b = b.replace(b, i);
        break;
      case "d":
        b = b.replace(b, c.toString());
        break;
      case "mmmm":
        b = b.replace(b, h);
        break;
      case "mmm":
        b = b.replace(b, f);
        break;
      case "mm":
        b = b.replace(b, m);
        break;
      case "m":
        b = b.replace(b, u.toString());
        break;
      case "yyyy":
        b = b.replace(b, g.toString());
        break;
      case "yy":
        b = b.replace(b, v.toString());
        break;
    }
    y += b;
  }), y;
}
const Us = (e, t) => {
  if (!t)
    return !1;
  const n = new Date();
  return n.setHours(0, 0, 0, 0) === e.setHours(0, 0, 0, 0) ? !1 : e < n;
}, Gs = (e, t) => {
  if (!t)
    return !1;
  const n = new Date();
  return e > n;
}, Dt = ne.createContext({
  view: "days",
  setView: null,
  activeDate: new Date(),
  setActiveDate: null,
  selectedDate: new Date(),
  setSelectedDate: null,
  weekdaysShort: [],
  monthsShort: [],
  monthsFull: [],
  min: void 0,
  max: void 0,
  weekdaysFull: [],
  yearScope: [],
  tabCount: 0,
  inline: !1,
  disableFuture: !1,
  disablePast: !1
}), yc = ({
  clearBtnText: e = "Clear",
  cancelBtnText: t = "Cancel",
  okBtnText: n = "Ok",
  setValue: s,
  selectDate: r,
  onClose: o
}) => {
  const { setActiveDate: c, setSelectedDate: i, selectedDate: l, isInDatetimepicker: d, onDatetimepickerModeSwitch: u } = He(Dt), m = (f) => {
    f.currentTarget.blur(), c(new Date()), i(void 0), s("");
  };
  return /* @__PURE__ */ K("div", { className: "datepicker-footer", children: [
    /* @__PURE__ */ a("button", { tabIndex: 0, onClick: (f) => m(f), className: "datepicker-footer-btn datepicker-clear-btn", children: e }),
    /* @__PURE__ */ a("button", { tabIndex: 0, onClick: () => o == null ? void 0 : o(), className: "datepicker-footer-btn datepicker-cancel-btn", children: t }),
    /* @__PURE__ */ a(
      "button",
      {
        tabIndex: 0,
        onClick: () => {
          r(l), d && (u == null || u()), o == null || o();
        },
        className: "datepicker-footer-btn datepicker-ok-btn",
        children: n
      }
    )
  ] });
}, wc = (e, t, n) => {
  const s = document.createElement("button"), r = document.createElement("div");
  s.id = `datepicker-toggle-${Math.floor(Math.random() * 10001)}`, s.tabIndex = 0, s.type = "button", s.style.pointerEvents = "auto";
  const o = document.createElement("i");
  o.className = `${e} fa-${t} datepicker-icon`, n && s.appendChild(o);
  const c = n ? s : o;
  return c.classList.add("datepicker-toggle-button"), {
    div: r,
    selector: c
  };
}, kc = (e, t, n, s, r, o) => {
  const c = [], i = Ie(e), l = Ie(ut(e, -1)), d = Ie(ut(e, 1)), u = ge(e), m = mc(u, i, o), f = Ot(e), h = Ot(ut(e, -1)), v = 7;
  let g = 1, p = !1;
  for (let y = 1; y < v; y++) {
    const b = [];
    if (y === 1) {
      const k = h - m + 1;
      for (let L = k; L <= h; L++) {
        const I = Bt(u, l, L);
        b.push({
          date: I,
          currentMonth: p,
          isSelected: t && kt(I, t),
          isToday: kt(I, Rt()),
          dayNumber: et(I),
          disabled: Ht(I, n, s, r)
        });
      }
      p = !0;
      const M = v - b.length;
      for (let L = 0; L < M; L++) {
        const I = Bt(u, i, g);
        b.push({
          date: I,
          currentMonth: p,
          isSelected: t && kt(I, t),
          isToday: kt(I, Rt()),
          dayNumber: et(I),
          disabled: Ht(I, n, s, r)
        }), g++;
      }
    } else
      for (let k = 1; k < 8; k++) {
        g > f && (g = 1, p = !1);
        const M = Bt(u, p ? i : d, g);
        b.push({
          date: M,
          currentMonth: p,
          isSelected: t && kt(M, t),
          isToday: kt(M, Rt()),
          dayNumber: et(M),
          disabled: Ht(M, n, s, r)
        }), g++;
      }
    c.push(b);
  }
  return c;
}, Nc = (e) => {
  const t = [], n = e[0];
  let s = [];
  for (let r = 0; r < 24; r++)
    if (s.push(n + r), s.length === 4) {
      const o = s;
      t.push(o), s = [];
    }
  return t;
}, Mc = (e) => {
  const t = [];
  let n = [];
  return e.forEach((s) => {
    if (n.push(s), n.length === 4) {
      const r = n;
      t.push(r), n = [];
    }
  }), t;
}, xc = ({
  filter: e,
  startWeekdays: t,
  startDay: n,
  inlineDayClick: s,
  selectOnClick: r,
  selectDate: o,
  onClose: c
}) => {
  const { min: i, max: l, setActiveDate: d, setSelectedDate: u, activeDate: m, selectedDate: f, tabCount: h, disableFuture: v, disablePast: g } = He(Dt), p = (y) => {
    !Ht(y, i, l, e) && (d(y), u(y), s(y), r && (o(y), c == null || c()));
  };
  return /* @__PURE__ */ K("table", { className: "datepicker-table", children: [
    /* @__PURE__ */ a("thead", { children: /* @__PURE__ */ a("tr", { children: t.map((y, b) => /* @__PURE__ */ a("th", { className: "datepicker-day-heading", scope: "col", children: y }, b)) }) }),
    /* @__PURE__ */ a("tbody", { className: "datepicker-table-body", children: kc(m, f, i, l, e, n).map((y, b) => /* @__PURE__ */ a("tr", { children: y.map((k, M) => /* @__PURE__ */ a(
      "td",
      {
        onClick: () => p(k.date),
        tabIndex: kt(k.date, m) ? 0 : void 0,
        className: E(
          "datepicker-cell",
          "datepicker-small-cell",
          "datepicker-day-cell",
          k.isToday && "current",
          k.isSelected && "selected",
          k.disabled && "disabled",
          h === 3 && kt(k.date, m) && "focused",
          Ie(m) !== Ie(k.date) && "disabled",
          Gs(k.date, v) && "disabled",
          Us(k.date, g) && "disabled"
        ),
        children: /* @__PURE__ */ a(
          "div",
          {
            className: "datepicker-cell-content datepicker-small-cell-content",
            style: { display: k.currentMonth ? "block" : "none" },
            children: k.dayNumber
          }
        )
      },
      M
    )) }, b)) })
  ] });
}, Ec = () => {
  const {
    yearScope: e,
    setView: t,
    setActiveDate: n,
    activeDate: s,
    selectedDate: r,
    tabCount: o,
    min: c,
    max: i,
    disableFuture: l,
    disablePast: d
  } = He(Dt);
  return /* @__PURE__ */ a("table", { className: "datepicker-table", children: /* @__PURE__ */ a("tbody", { className: "datepicker-table-body", children: Nc(e).map((u, m) => /* @__PURE__ */ a("tr", { children: u.map((f) => /* @__PURE__ */ a(
    "td",
    {
      onClick: () => {
        n(new Date(f, Ie(s), et(s))), t("months");
      },
      tabIndex: f === ge(s) ? 0 : void 0,
      className: E(
        "datepicker-cell",
        "datepicker-large-cell",
        "datepicker-year-cell",
        r && f === ge(r) && "selected",
        o === 3 && f === ge(s) && "focused",
        bn(f, c, i, l, d) && "disabled",
        ge(Rt()) === f && "current"
      ),
      children: /* @__PURE__ */ a("div", { className: "datepicker-cell-content datepicker-large-cell-content", children: f })
    },
    f
  )) }, m)) }) });
}, Dc = () => {
  const {
    monthsShort: e,
    setActiveDate: t,
    setView: n,
    activeDate: s,
    selectedDate: r,
    tabCount: o,
    min: c,
    max: i,
    disableFuture: l,
    disablePast: d
  } = He(Dt);
  return /* @__PURE__ */ a("table", { className: "datepicker-table", children: /* @__PURE__ */ a("tbody", { className: "datepicker-table-body", children: Mc(e).map((u, m) => /* @__PURE__ */ a("tr", { children: u.map((f) => /* @__PURE__ */ a(
    "td",
    {
      onClick: () => {
        t(new Date(ge(s), e.indexOf(f), mn(s))), n("days");
      },
      tabIndex: e.indexOf(f) === Ie(s) ? 0 : void 0,
      className: E(
        "datepicker-cell",
        "datepicker-large-cell",
        "datepicker-month-cell",
        r && e.indexOf(f) === Ie(r) && ge(s) === ge(r) && "selected",
        o === 3 && e.indexOf(f) === Ie(s) && "focused",
        Ie(Rt()) === e.indexOf(f) && ge(Rt()) === ge(s) && "current",
        vn(
          e.indexOf(f),
          ge(s),
          c,
          i,
          l,
          d
        ) && "disabled"
      ),
      children: /* @__PURE__ */ a("div", { className: "datepicker-cell-content datepicker-large-cell-content", children: f })
    },
    e.indexOf(f)
  )) }, m)) }) });
}, Tc = ({ title: e, customHeader: t }) => {
  const { weekdaysShort: n, monthsShort: s, selectedDate: r, isInDatetimepicker: o, onDatetimepickerModeSwitch: c } = He(Dt), i = r || new Date();
  return /* @__PURE__ */ K("div", { className: "datepicker-header", children: [
    /* @__PURE__ */ a("div", { className: "datepicker-title", children: /* @__PURE__ */ a("span", { className: "datepicker-title-text", children: e }) }),
    /* @__PURE__ */ K("div", { className: "datepicker-date", children: [
      !t && /* @__PURE__ */ K("span", { className: "datepicker-date-text", children: [
        n[i.getDay()],
        ", ",
        s[i.getMonth()],
        " ",
        i.getDate()
      ] }),
      t && t
    ] }),
    o && /* @__PURE__ */ K("div", { className: "buttons-container", children: [
      /* @__PURE__ */ a("button", { type: "button", className: "datepicker-button-toggle", children: /* @__PURE__ */ a("i", { className: "far fa-calendar datepicker-toggle-icon" }) }),
      /* @__PURE__ */ a("button", { type: "button", className: "timepicker-button-toggle", onClick: c, children: /* @__PURE__ */ a("i", { className: "far fa-clock fa-sm timepicker-icon" }) })
    ] })
  ] });
}, Bc = () => {
  const { view: e, setView: t, activeDate: n, setActiveDate: s, monthsFull: r, min: o, max: c, yearScope: i } = He(Dt), l = (d) => {
    if (e === "days") {
      const u = d ? new Date(ge(n), Ie(n) + 1, mn(n)) : new Date(ge(n), Ie(n) - 1, mn(n));
      d ? !ls(ut(u, -1), "days", 1, o, c) && s(u) : !as(ut(u, 1), "days", 1, o, c) && s(u);
    } else if (e === "years") {
      const u = d ? new Date(ge(n) + 24, Ie(n), et(n)) : new Date(ge(n) - 24, Ie(n), et(n));
      d ? c ? i[0] + 24 < ge(c) && s(u) : s(u) : o ? i[1] - 24 > ge(o) && s(u) : s(u);
    } else if (e === "months") {
      const u = d ? new Date(ge(n) + 1, Ie(n), et(n)) : new Date(ge(n) - 1, Ie(n), et(n));
      d ? !ls(ht(u, -1), "months", 1, o, c) && s(u) : !as(ht(u, 1), "months", 1, o, c) && s(u);
    }
  };
  return /* @__PURE__ */ K("div", { className: "datepicker-date-controls", children: [
    e === "days" && /* @__PURE__ */ K("button", { tabIndex: 0, className: "datepicker-view-change-button", onClick: () => t("years"), children: [
      r[n.getMonth()],
      " ",
      n.getFullYear()
    ] }),
    e === "years" && /* @__PURE__ */ K("button", { tabIndex: 0, className: "datepicker-view-change-button", onClick: () => t("days"), children: [
      i[0],
      " - ",
      i[1]
    ] }),
    e === "months" && /* @__PURE__ */ a("button", { tabIndex: 0, className: "datepicker-view-change-button", onClick: () => t("days"), children: ge(n) }),
    /* @__PURE__ */ K("div", { className: "datepicker-arrow-controls", children: [
      /* @__PURE__ */ a("button", { tabIndex: 0, className: "datepicker-previous-button", onClick: () => l(!1) }),
      /* @__PURE__ */ a("button", { tabIndex: 0, className: "datepicker-next-button", onClick: () => l(!0) })
    ] })
  ] });
}, Lc = ({
  labelText: e,
  inline: t,
  setReferenceElement: n,
  inputClasses: s,
  value: r,
  style: o,
  inputStyle: c,
  icon: i,
  input: l,
  inputId: d,
  inputToggle: u,
  setDatepickerValue: m,
  format: f,
  onOpenHandler: h,
  ...v
}) => {
  const { monthsFull: g, monthsShort: p, setSelectedDate: y, setActiveDate: b } = He(Dt), k = E(r ? "active" : "", s), M = te(null);
  return B(() => {
    var Y;
    if (u)
      return;
    const T = (Y = M.current) == null ? void 0 : Y.parentNode, { div: x, selector: V } = wc(i, "sm", !0);
    return T == null || T.insertBefore(x, M.current), T == null || T.insertBefore(V, M.current), V.addEventListener("click", () => h == null ? void 0 : h()), () => {
      V.removeEventListener("click", () => h == null ? void 0 : h()), T == null || T.removeChild(V);
    };
  }, [i, h, u]), /* @__PURE__ */ a(
    gt,
    {
      className: k,
      label: e,
      id: d,
      ref: t ? n : l,
      labelRef: M,
      wrapperClass: "datepicker",
      value: r,
      onChange: (T) => {
        const x = en(T.target.value, f, g, p);
        m(T.target.value), x && hn(x) ? (b(x), y(x)) : (b(new Date()), y(void 0));
      },
      style: c,
      wrapperStyle: o,
      onClick: () => {
        u && (h == null || h());
      },
      ...v
    }
  );
}, Nn = "ArrowLeft", Mn = "ArrowUp", xn = "ArrowRight", En = "ArrowDown", Dn = "Home", Tn = "End", Bn = "PageUp", Ln = "PageDown", Sn = "Enter", In = " ", Sc = (e, t, n, s, r, o, c, i, l, d) => {
  switch (e) {
    case Nn:
      t((u) => It(u, -1));
      break;
    case xn:
      t((u) => It(u, 1));
      break;
    case Mn:
      t((u) => It(u, -7));
      break;
    case En:
      t((u) => It(u, 7));
      break;
    case Dn:
      t((u) => It(u, 1 - et(u)));
      break;
    case Tn:
      t((u) => It(u, Ot(u) - et(u)));
      break;
    case Bn:
      t((u) => ut(u, -1));
      break;
    case Ln:
      t((u) => ut(u, 1));
      break;
    case Sn:
      if (Ht(n, s, r, c) || Us(n, d) || Gs(n, l))
        return;
      i(n), o(n);
      break;
    case In:
      if (!c || c(n)) {
        if (Ht(n, s, r, c))
          return;
        i(n), o(n);
      }
      break;
    default:
      return;
  }
}, Ic = (e, t, n, s, r, o, c, i, l) => {
  switch (e) {
    case Nn:
      n((m) => ht(m, -1));
      break;
    case xn:
      n((m) => ht(m, 1));
      break;
    case Mn:
      n((m) => ht(m, -4));
      break;
    case En:
      n((m) => ht(m, 4));
      break;
    case Dn:
      n((m) => ht(m, -pn(m, 24)));
      break;
    case Tn:
      n((m) => ht(m, 24 - pn(m, 24) - 1));
      break;
    case Bn:
      n((m) => ht(m, -24));
      break;
    case Ln:
      n((m) => ht(m, 24));
      break;
    case Sn:
      !bn(ge(t), s, r, i, l) && o("months");
      break;
    case In:
      !bn(ge(t), s, r, i, l) && c(t);
      return;
    default:
      return;
  }
}, Ac = (e, t, n, s, r, o, c, i, l, d) => {
  switch (e) {
    case Nn:
      n((u) => ut(u, -1));
      break;
    case xn:
      n((u) => ut(u, 1));
      break;
    case Mn:
      n((u) => ut(u, -4));
      break;
    case En:
      n((u) => ut(u, 4));
      break;
    case Dn:
      n((u) => ut(u, -Ie(u)));
      break;
    case Tn:
      n((u) => ut(u, 11 - Ie(u)));
      break;
    case Bn:
      n((u) => ht(u, -1));
      break;
    case Ln:
      n((u) => ht(u, 1));
      break;
    case Sn:
      !vn(Ie(t), ge(t), s, r, l, d) && o("days");
      break;
    case In:
      !vn(Ie(t), ge(t), s, r, l, d) && c(t);
      return;
    default:
      return;
  }
}, $c = ({
  closeOnEsc: e,
  isOpen: t,
  activeDate: n,
  setActiveDate: s,
  min: r,
  max: o,
  view: c,
  setView: i,
  setSelectedDate: l,
  filter: d,
  setInlineDate: u,
  disableFuture: m,
  disablePast: f,
  onClose: h
}) => {
  const [v, g] = N(3), p = te(null), y = P(
    (b) => {
      var M, L, I;
      if (e && b.key === "Escape" && (h == null || h()), b.preventDefault(), !b.shiftKey && b.key === "Tab") {
        const T = (M = p.current) == null ? void 0 : M.querySelectorAll('[tabindex="0"]');
        T && (v === T.length - 1 ? g(0) : g(v + 1));
      } else if (b.key === "Enter")
        v !== 3 && document.activeElement && document.activeElement.click();
      else if (b.shiftKey && b.key === "Tab") {
        const T = (L = p.current) == null ? void 0 : L.querySelectorAll('[tabindex="0"]');
        T && g(v === 0 ? T.length - 1 : v - 1);
      }
      ((I = p.current) == null ? void 0 : I.querySelector(".focused")) && v !== 4 && (c === "days" ? Sc(
        b.key,
        s,
        n,
        r,
        o,
        l,
        d,
        u,
        m,
        f
      ) : c === "years" ? Ic(
        b.key,
        n,
        s,
        r,
        o,
        i,
        l,
        m,
        f
      ) : c === "months" && Ac(
        b.key,
        n,
        s,
        r,
        o,
        i,
        l,
        d,
        m,
        f
      ));
    },
    [
      n,
      c,
      d,
      o,
      r,
      e,
      v,
      i,
      s,
      l,
      u,
      m,
      f,
      h
    ]
  );
  return B(() => {
    var k, M;
    const b = (k = p.current) == null ? void 0 : k.querySelectorAll('[tabindex="0"]');
    if (b) {
      const L = b[v];
      if (L.tagName !== "TD") {
        L.focus();
        const I = (M = p.current) == null ? void 0 : M.querySelector(".focused");
        I == null || I.classList.remove("focused");
      } else
        b[v - 1].blur(), L.classList.add("focused");
    }
  }, [v]), B(() => {
    t || g(3);
  }, [t]), B(() => {
    g(3);
  }, [c]), B(() => {
    if (t)
      return document.addEventListener("keydown", y), () => {
        document.removeEventListener("keydown", y);
      };
  }, [y, t]), { tabCount: v, modalRef: p };
}, Rc = ({ isOpen: e, inline: t }) => {
  B(() => {
    const n = window.innerWidth > document.documentElement.clientWidth && window.innerWidth >= 576;
    if (!t)
      return e && n ? (document.body.style.overflow = "hidden", document.body.style.paddingRight = "17px") : (document.body.style.overflow = "", document.body.style.paddingRight = ""), () => {
        document.body.style.overflow = "", document.body.style.paddingRight = "";
      };
  }, [e, t]);
}, Hc = ({
  isOpened: e,
  isOpen: t,
  inline: n,
  popperElement: s,
  referenceElement: r,
  backdropRef: o,
  onCloseHandler: c
}) => {
  const i = P(
    (l) => {
      var d;
      n ? !(s != null && s.contains(l.target)) && !((d = r == null ? void 0 : r.parentNode) != null && d.contains(l.target)) && !l.target.classList.contains("datepicker-view-change-button") && !l.target.classList.contains("datepicker-large-cell-content") && t && c() : l.target === o.current && t && c();
    },
    [s, r, o, n, t, c]
  );
  B(() => (e && document.addEventListener("click", i), () => {
    document.removeEventListener("click", i);
  }), [e, i]);
}, Qs = Lt(
  ({
    datetimepickerRef: e,
    isInDatetimepicker: t,
    onDatetimepickerModeSwitch: n,
    closeOnEsc: s = Ze.closeOnEsc,
    customHeader: r,
    title: o = Ze.title,
    weekdaysNarrow: c = Ze.weekdaysNarrow,
    monthsFull: i = Ze.monthsFull,
    monthsShort: l = Ze.monthsShort,
    weekdaysFull: d = Ze.weekdaysFull,
    weekdaysShort: u = Ze.weekdaysShort,
    disableFuture: m,
    disablePast: f,
    filter: h,
    inline: v,
    className: g,
    min: p,
    max: y,
    format: b = Ze.format,
    okBtnText: k = Ze.okBtnText,
    clearBtnText: M = Ze.clearBtnText,
    cancelBtnText: L = Ze.cancelBtnText,
    inputToggle: I,
    customIcon: T = Ze.customIcon,
    inputId: x,
    inputLabel: V = Ze.inputLabel,
    inputStyle: Y,
    startDay: H = Ze.startDay,
    views: A = Ze.views,
    style: J,
    defaultValue: D = "",
    onChange: Q,
    onClose: _,
    onClosed: U,
    onOpen: $,
    onOpened: X,
    getFormattedDateValues: O,
    value: C,
    wrapperClass: q,
    selectOnClick: F = !1,
    open: j,
    disablePortal: w,
    ...W
  }, le) => {
    const [ue, de] = N(!1), [re, De] = N(!1), pe = Et(re, j), [Ne, he] = N(new Date()), [fe, ye] = N(new Date()), [Le, Me] = N(A), [ke, ae] = N(C || D), [Te, se] = N(), [We, Se] = N(), [$e, Ge] = N(c), [nt, st] = N([0, 0]), tt = te(null), Ve = te(null), Qe = te(D && !0), { styles: dt, attributes: lt } = wt(e || We, Te, {
      placement: "bottom-start",
      modifiers: [ks]
    });
    xt(le, () => v ? We : Ve.current, [
      v,
      We
    ]);
    const rt = (oe) => {
      if (!v)
        return;
      if (v) {
        const Ee = us(oe, b, u, d, l, i);
        ae(Ee), t && (n == null || n()), Pe();
      }
    }, ot = (oe) => {
      const me = oe && us(oe, b, u, d, l, i);
      me && ae(me);
    }, Pe = P(() => {
      De(!1), _ == null || _();
    }, [_]), qe = P(() => {
      De(!0), $ == null || $();
    }, [$]), ct = P(() => {
      de(!1), U == null || U();
    }, [U]), S = P(() => {
      de(!0), X == null || X();
    }, [X]), { tabCount: ce, modalRef: R } = $c({
      closeOnEsc: s,
      isOpen: pe,
      activeDate: Ne,
      setActiveDate: he,
      min: p,
      max: y,
      view: Le,
      setView: Me,
      setSelectedDate: ye,
      filter: h,
      setInlineDate: rt,
      disableFuture: m,
      disablePast: f
    });
    return Rc({ isOpen: pe, inline: v }), Hc({
      isOpened: ue,
      isOpen: pe,
      inline: v,
      referenceElement: We,
      popperElement: Te,
      backdropRef: tt,
      onCloseHandler: Pe
    }), B(() => {
      const oe = ge(Ne), me = pn(Ne, 24), Ee = oe - me;
      st([Ee, Ee + 23]);
    }, [Ne]), B(() => {
      const oe = c.slice(H).concat(c.slice(0, H));
      Ge(oe);
    }, [c, H]), B(() => {
      if (!pe)
        return;
      const oe = v ? We : Ve.current, me = oe == null ? void 0 : oe.parentNode, Ee = me == null ? void 0 : me.querySelector("button");
      Ee ? Ee.blur() : oe == null || oe.blur();
    }, [pe, Ve, We, v, $]), B(() => {
      j && !pe && !ue && ($ == null || $(), De(!0));
    }, [j, pe, ue, $]), B(() => {
      if (!Qe.current)
        return;
      const me = en(ke, b, i, l);
      me && hn(me) && (he(me), ye(me)), Qe.current = !1;
    }, [D, ke, b, i, l]), B(() => {
      const oe = C && en(C, b, i, l);
      oe && hn(oe) && (he(oe), ye(oe), ae(C)), C === "" && (he(new Date()), ye(void 0), ae(C));
    }, [C, b, i, l]), B(() => {
      pe || (Me(A), ke || (he(new Date()), ye(void 0)));
    }, [pe, A, ke]), B(() => {
      Q == null || Q(ke, Ne);
    }, [ke]), B(() => {
      const oe = fe || new Date(), me = String(oe.getDate()), Ee = u[oe.getDay()], Ue = d[oe.getDay()], _e = l[oe.getMonth()], z = i[oe.getMonth()], Z = String(oe.getFullYear()), ie = Z.slice(-2);
      O == null || O({ dayNumber: me, weekdayShort: Ee, weekdayFull: Ue, monthShort: _e, monthFull: z, yearFull: Z, yearShort: ie });
    }, [fe]), /* @__PURE__ */ a(
      Dt.Provider,
      {
        value: {
          isInDatetimepicker: t,
          onDatetimepickerModeSwitch: n,
          view: Le,
          setView: Me,
          activeDate: Ne,
          setActiveDate: he,
          selectedDate: fe,
          setSelectedDate: ye,
          weekdaysShort: u,
          monthsShort: l,
          monthsFull: i,
          min: p,
          max: y,
          weekdaysFull: d,
          yearScope: nt,
          tabCount: ce,
          isOpen: pe,
          disablePast: f,
          disableFuture: m
        },
        children: /* @__PURE__ */ K(be, { children: [
          !t && /* @__PURE__ */ a(
            Lc,
            {
              inputClasses: g,
              labelText: V,
              inline: v,
              setReferenceElement: Se,
              value: ke,
              setDatepickerValue: ae,
              style: J,
              inputStyle: Y,
              format: b,
              icon: T,
              input: Ve,
              inputToggle: I,
              onOpenHandler: qe,
              ...W
            }
          ),
          /* @__PURE__ */ a(pt, { disablePortal: w, children: /* @__PURE__ */ a(Ft, { children: pe && /* @__PURE__ */ K(be, { children: [
            /* @__PURE__ */ K(
              fc,
              {
                className: q,
                dropdown: v,
                styles: dt,
                attributes: lt,
                setPopperElement: se,
                onClosed: ct,
                onOpened: S,
                children: [
                  !v && /* @__PURE__ */ a(Tc, { title: o, customHeader: r, onClose: Pe }),
                  /* @__PURE__ */ K("div", { className: "datepicker-main", ref: R, children: [
                    /* @__PURE__ */ a(Bc, {}),
                    /* @__PURE__ */ K("div", { className: "datepicker-view", children: [
                      Le === "days" && /* @__PURE__ */ a(
                        xc,
                        {
                          startWeekdays: $e,
                          startDay: H,
                          filter: h,
                          inlineDayClick: rt,
                          selectDate: ot,
                          selectOnClick: F,
                          onClose: Pe
                        }
                      ),
                      Le === "years" && /* @__PURE__ */ a(Ec, {}),
                      Le === "months" && /* @__PURE__ */ a(Dc, {})
                    ] }),
                    !v && /* @__PURE__ */ a(
                      yc,
                      {
                        okBtnText: k,
                        clearBtnText: M,
                        cancelBtnText: L,
                        setValue: ae,
                        selectDate: ot,
                        onClose: Pe
                      }
                    )
                  ] })
                ]
              },
              "datepicker-modal-container"
            ),
            !v && /* @__PURE__ */ a(
              Mt.div,
              {
                className: "datepicker-backdrop",
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                exit: { opacity: 0 },
                transition: { duration: 0.3 },
                ref: tt
              }
            )
          ] }) }) })
        ] })
      }
    );
  }
);
Qs.displayName = "MDBDatepicker";
const Wc = (e) => {
  const t = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9] [APap][mM]$/, n = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;
  return e.match(t) || e.match(n);
}, Cc = (e) => e && Object.prototype.toString.call(e) === "[object Date]" && !isNaN(e.getTime()), ds = 300, Yc = Lt(
  ({
    className: e,
    label: t = "Select Date and Time",
    labelStyle: n,
    labelClass: s,
    labelRef: r,
    inputClass: o = "",
    inputRef: c,
    inline: i,
    disabled: l,
    defaultTime: d = "",
    defaultDate: u = "",
    value: m,
    invalidLabel: f,
    inputToggle: h = !1,
    timepickerOptions: v,
    datepickerOptions: g,
    showFormat: p,
    dateFormat: y = "dd/mm/yyyy",
    timeFormat: b = "12h",
    appendValidationInfo: k = !0,
    onChange: M,
    onOpen: L,
    onClose: I,
    onDatepickerOpen: T,
    onDatepickerClose: x,
    onTimepickerOpen: V,
    onTimepickerClose: Y,
    ...H
  }, A) => {
    const J = te(!1), [D, Q] = N(!1), [_, U] = N(!1), [$, X] = N(u), [O, C] = N(d), [q, F] = N(""), j = te(), w = $ ? q.split(",")[0] : null, W = O ? q.split(", ")[1] : null, le = E("form-outline", "datetimepicker", e), ue = () => {
      const Me = w && en(w, y, Ze.monthsFull, Ze.monthsShort);
      return q && !w && !W || w && !Cc(Me) || W && !Wc(W) ? o + " is-invalid" : o;
    }, de = P((Me) => {
      X(Me);
    }, []), re = P((Me) => {
      C(Me);
    }, []), De = P(() => {
      U(!1), J.current = !1, x == null || x();
    }, [x]), pe = P(() => {
      Y == null || Y(), Q(!1), J.current = !1;
    }, [Y]), Ne = P(() => {
      T == null || T();
    }, [T]), he = P(() => {
      V == null || V();
    }, [V]), fe = () => {
      U(!0), L == null || L(), J.current = !0;
    }, ye = P(() => {
      _ ? (U(!1), setTimeout(() => {
        Q(!0);
      }, ds)) : D && (Q(!1), setTimeout(() => {
        U(!0);
      }, ds));
    }, [_, D]);
    B(() => {
      !O || !$ || (M == null || M(`${$}, ${O}`), !m && F(`${$}, ${O}`));
    }, [O, $, M, m]), B(() => {
      m && (F(m), M == null || M(m));
    }, [m, M]), B(() => {
      !_ && !D && !J.current && (I == null || I());
    }, [_, D, I]);
    const Le = (Me) => {
      F(Me);
      const [ke, ae] = Me.split(", ");
      X(ke || ""), C(ae || "");
    };
    return /* @__PURE__ */ K(be, { children: [
      /* @__PURE__ */ K("div", { className: le, ref: j, ...H, children: [
        /* @__PURE__ */ a(
          gt,
          {
            label: t,
            labelStyle: n,
            labelClass: s,
            ref: c || A,
            labelRef: r,
            placeholder: p ? `${y}, ${b}` : void 0,
            value: m || q,
            onChange: (Me) => {
              Le(Me.target.value), M == null || M(Me.target.value);
            },
            className: k ? ue() : o,
            disabled: l,
            onClick: () => {
              h && fe();
            },
            children: f && /* @__PURE__ */ a("div", { className: "invalid-feedback", children: f })
          }
        ),
        !h && /* @__PURE__ */ a(
          "button",
          {
            type: "button",
            className: "datetimepicker-toggle-button",
            onClick: fe,
            disabled: l,
            style: { pointerEvents: l ? "none" : "initial" },
            children: /* @__PURE__ */ a("i", { className: "far fa-calendar datepicker-toggle-icon" })
          }
        )
      ] }),
      /* @__PURE__ */ a(
        Qs,
        {
          ...g,
          inline: i,
          onChange: de,
          format: y,
          datetimepickerRef: j.current,
          defaultValue: u,
          value: $,
          onClose: De,
          onOpen: Ne,
          isInDatetimepicker: !0,
          open: _,
          onDatetimepickerModeSwitch: ye
        }
      ),
      /* @__PURE__ */ a(
        qs,
        {
          ...v,
          inline: i,
          onChange: re,
          format: b,
          datetimepickerRef: j.current,
          defaultValue: d,
          value: O,
          onClose: pe,
          onOpen: he,
          isInDatetimepicker: !0,
          open: D,
          onDatetimepickerModeSwitch: ye
        }
      )
    ] });
  }
);
Yc.displayName = "MDBDateTimepicker";
const Pc = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
}, kl = ({
  className: e,
  alertRef: t,
  position: n,
  delay: s = 1e3,
  autohide: r,
  width: o = "unset",
  containerRef: c,
  appendToBody: i,
  color: l,
  children: d,
  defaultOpen: u = !1,
  open: m,
  onClose: f,
  onClosed: h,
  onOpen: v,
  onOpened: g,
  dismissBtn: p = !1,
  animationVariants: y = {},
  initialAnimation: b = !1,
  style: k,
  ...M
}) => {
  const [L, I] = N(u), T = Et(L, m), x = te(null), V = t || x, Y = E(
    "alert",
    "fade",
    n && !c && "alert-fixed",
    p && "alert-dismissible",
    n && `alert-${n}`,
    c && "alert-absolute",
    l ? `alert-${l}` : "alert-primary",
    T && "show",
    e
  );
  B(() => {
    c != null && c.current.classList.add("parent-alert-relative");
  }, [c]), B(() => {
    T && (v == null || v());
  }, [T, v]), B(() => {
    let A;
    return r && T && (A = setTimeout(() => {
      f == null || f(), I(!1);
    }, s)), () => {
      clearTimeout(A);
    };
  }, [r, T, s, f]);
  const H = /* @__PURE__ */ a(Ft, { initial: b, children: T && /* @__PURE__ */ K(
    Mt.div,
    {
      ...M,
      variants: { ...Pc, ...y },
      initial: "closed",
      animate: "open",
      exit: "closed",
      onAnimationComplete: (A) => {
        A === "open" ? g == null || g() : h == null || h();
      },
      className: Y,
      ref: V,
      style: {
        ...k,
        width: o === "unset" ? o : `${o}px`
      },
      children: [
        d,
        p && /* @__PURE__ */ a(
          "button",
          {
            type: "button",
            className: "btn-close",
            "aria-label": "Close",
            onClick: () => {
              f == null || f(), I(!1);
            }
          }
        )
      ]
    }
  ) });
  return /* @__PURE__ */ a(pt, { disablePortal: !i, children: H });
}, Js = ne.forwardRef(
  ({ className: e, color: t, children: n, ...s }, r) => {
    const o = E(
      "toast-header",
      t && `bg-${t}`,
      t && t !== "light" && "text-white",
      e
    );
    return /* @__PURE__ */ a("div", { className: o, ref: r, ...s, children: n });
  }
);
Js.displayName = "MDBToastHeader";
const Zs = ne.forwardRef(
  ({ className: e, children: t, color: n, ...s }, r) => {
    const o = E("toast-body", n && n !== "light" && "text-white", e);
    return /* @__PURE__ */ a("div", { className: o, ref: r, ...s, children: t });
  }
);
Zs.displayName = "MDBToastBody";
const er = ne.forwardRef(
  ({ className: e, white: t, children: n, ...s }, r) => {
    const o = E("btn-close", t && "btn-close-white", e);
    return /* @__PURE__ */ a(Ae, { className: o, color: "none", ref: r, ...s, children: n });
  }
);
er.displayName = "MDBToastClose";
const Xc = {
  open: {
    opacity: 1
  },
  closed: {
    opacity: 0
  }
}, Nl = ({
  className: e,
  position: t,
  delay: n = 1e3,
  autohide: s,
  width: r = "width",
  onOpen: o,
  onOpened: c,
  onClose: i,
  onClosed: l,
  containerRef: d,
  toastRef: u,
  appendToBody: m,
  color: f,
  defaultOpen: h = !1,
  open: v,
  bodyContent: g,
  headerContent: p,
  bodyClasses: y,
  headerClasses: b,
  closeBtnClasses: k,
  initialAnimation: M = !1,
  animationVariants: L,
  style: I,
  ...T
}) => {
  const [x, V] = N(h), Y = Et(x, v), H = te(null), A = u || H, J = E(
    "toast",
    "fade",
    t && !d && "toast-fixed",
    t && `toast-${t}`,
    d && "toast-absolute",
    f && `bg-${f}`,
    Y && "show",
    e
  ), D = P(() => {
    V(!1), Y && (i == null || i());
  }, [Y, i]);
  B(() => {
    d != null && d.current.classList.add("parent-toast-relative");
  }, [d]), B(() => {
    let _;
    return s && Y && (_ = setTimeout(() => {
      D();
    }, n)), () => {
      clearTimeout(_);
    };
  }, [s, Y, n, D]);
  const Q = /* @__PURE__ */ a(Ft, { initial: M, children: Y && /* @__PURE__ */ K(
    Mt.div,
    {
      ...T,
      variants: { ...Xc, ...L },
      initial: "closed",
      animate: "open",
      exit: "closed",
      onAnimationComplete: (_) => {
        _ === "open" ? c == null || c() : l == null || l();
      },
      className: J,
      ref: A,
      style: { ...I, width: r === "unset" ? r : `${r}px` },
      children: [
        p && /* @__PURE__ */ K(Js, { className: b, color: f, children: [
          p,
          /* @__PURE__ */ a(
            er,
            {
              onClick: D,
              className: k,
              white: !!(f && f !== "light")
            }
          )
        ] }),
        /* @__PURE__ */ a(Zs, { className: y, color: f, children: g })
      ]
    }
  ) });
  return /* @__PURE__ */ a(pt, { disablePortal: !m, children: Q });
}, Oc = 0, Fc = ({
  selectedElements: e,
  optionHeight: t,
  data: n,
  multiple: s,
  selectAll: r,
  handleSelectAll: o,
  handleOptionClick: c,
  selectAllLabel: i,
  selectData: l,
  activeElementIndex: d,
  noResults: u,
  search: m
}) => {
  const f = Fe(() => l.filter((y) => y.optgroup).map((y) => y.optgroup), [l]), h = Fe(() => {
    let p = 0;
    return l.map((b) => (b.optgroup && p++, { ...b, groupIndex: p }));
  }, [l]), v = Fe(() => l.filter((p) => !p.optgroup && !p.hidden).length === 0, [l]), g = (p) => h.map((y) => {
    if (!y.optgroup && p === y.groupIndex)
      return /* @__PURE__ */ K(
        "div",
        {
          className: E(
            "select-option",
            e.includes(y.elementPosition) && "selected",
            y.disabled && "disabled",
            y.hidden && "d-none",
            d === y.elementPosition && "active"
          ),
          role: "option",
          style: { height: t },
          onClick: () => c(y),
          children: [
            /* @__PURE__ */ K("span", { className: "select-option-text", children: [
              s && /* @__PURE__ */ a(
                Wt,
                {
                  disabled: y.disabled,
                  disableWrapper: !0,
                  checked: e.includes(y.elementPosition),
                  readOnly: !0
                }
              ),
              y.text,
              y.secondaryText && /* @__PURE__ */ a("span", { className: "select-option-secondary-text", children: y.secondaryText })
            ] }),
            y.icon && /* @__PURE__ */ a("span", { className: "select-option-icon-container", children: /* @__PURE__ */ a("img", { className: "select-option-icon rounded-circle", src: y.icon }) })
          ]
        },
        y.elementPosition
      );
  });
  return /* @__PURE__ */ K(be, { children: [
    /* @__PURE__ */ K("div", { className: "select-options-list", children: [
      s && r && !v && /* @__PURE__ */ a(
        "div",
        {
          className: E(
            "select-option",
            e.length === n.filter((p) => !p.disabled).length && "selected",
            d === -1 && "active"
          ),
          role: "option",
          onClick: o,
          style: { height: t },
          children: /* @__PURE__ */ K("span", { className: "select-option-text", children: [
            /* @__PURE__ */ a(
              Wt,
              {
                disableWrapper: !0,
                checked: n.filter((p) => !p.disabled && !p.optgroup).length === e.length,
                readOnly: !0
              }
            ),
            i
          ] })
        }
      ),
      g(Oc),
      !v && (f == null ? void 0 : f.map((p, y) => {
        const b = g(y + 1).filter((k) => k !== void 0);
        if (b.length !== 0)
          return /* @__PURE__ */ K("div", { className: "select-option-group", children: [
            /* @__PURE__ */ a("label", { className: "select-option-group-label", style: { height: t }, children: p }),
            b
          ] }, `select-option-group ${p} ${y}`);
      }))
    ] }),
    m && v && /* @__PURE__ */ a("div", { className: "select-no-results", style: { height: t }, children: u })
  ] });
}, un = "ArrowUp", dn = "ArrowDown", fs = "Enter", ms = "Escape", hs = "Tab", Vc = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++) {
    const s = e[n], r = t[n], o = Object.keys(s), c = Object.keys(r);
    if (o.length !== c.length || !o.every((i) => c.includes(i)) || !o.every((i) => s[i] === r[i]))
      return !1;
  }
  return !0;
}, jc = (e) => e.map((t, n) => ({ ...t, elementPosition: n })), Kc = {
  open: {
    opacity: 1,
    transform: "scaleY(1)",
    transition: {
      duration: 0.2
    }
  },
  closed: {
    opacity: 0,
    transform: "scaleY(0.8)",
    transition: {
      duration: 0.2
    }
  }
}, Xt = -1, tr = Lt(
  ({
    data: e,
    className: t,
    inputClassName: n,
    optionHeight: s = 38,
    visibleOptions: r = 5,
    disabled: o,
    placeholder: c,
    label: i,
    clearBtn: l,
    children: d,
    multiple: u,
    displayedLabels: m = 5,
    optionsSelectedLabel: f = "options selected",
    selectAll: h = !0,
    selectAllLabel: v = "Select all",
    size: g,
    openRef: p,
    contrast: y = !1,
    open: b,
    onOpen: k,
    onOpened: M,
    onClose: L,
    onClosed: I,
    onValueChange: T,
    onChange: x,
    search: V = !1,
    searchLabel: Y = "Search...",
    searchFn: H,
    autoSelect: A = !1,
    noResultsText: J = "No results",
    validation: D = !1,
    validFeedback: Q = "Valid",
    invalidFeedback: _ = "Invalid",
    preventFirstSelection: U = !1,
    value: $,
    animationVariants: X,
    disablePortal: O,
    ...C
  }, q) => {
    const [F, j] = N(!1), w = Et(F, b), [W, le] = N(!0), [ue, de] = N(null), [re, De] = N(), [pe, Ne] = N();
    xt(q, () => re, [re]);
    const [he, fe] = N(""), [ye, Le] = N(""), [Me, ke] = N(() => h ? Xt : e.findIndex((G) => !G.disabled)), [ae, Te] = N([]), [se, We] = N([]), [Se, $e] = N(se), [Ge, nt] = N(""), [st, tt] = N(0), [Ve, Qe] = N(!1), dt = E("select-wrapper", t), lt = E("select-input", c && "placeholder-active", w && "focused", n), rt = E(w || ue && i ? "active" : "", i && "select-label"), ot = E("select-dropdown", w && "open"), { styles: Pe, attributes: qe } = wt(re, pe, {
      placement: "bottom-start"
    }), ct = te(null), S = te(null), ce = te(null), R = Fe(
      () => u && h ? r + 1 : r,
      [h, r, u]
    );
    B(() => {
      if (!ye)
        return $e(se);
      if (H && ye) {
        const G = H(ye, se);
        return $e(G || []);
      }
      $e(() => se.filter(
        (G) => {
          var ee;
          return ((ee = G.text) == null ? void 0 : ee.toLocaleLowerCase().includes(ye.toLocaleLowerCase())) || G.optgroup;
        }
      ));
    }, [ye, se, H, he]), B(() => {
      w && ye && ke(-1);
    }, [w, ye]), B(() => {
      if (!D)
        return;
      const G = ae.every((ft) => se[ft].value), ee = ae.every((ft) => !se[ft].disabled), we = ae.length > 0;
      !u && (!we || !G || !ee) || u && (!we || !ee) ? re == null || re.setCustomValidity(_) : re == null || re.setCustomValidity("");
    }, [D, _, ae, re, se, he, u]);
    const oe = (G) => {
      if (se.length === 0)
        return;
      const ee = S.current, we = ee.offsetHeight, Be = ee.scrollTop, je = se.filter((ze) => ze.hidden && ze.elementPosition < G).length, ft = u && h ? G + 1 : G;
      if (G > (u && h ? -2 : -1)) {
        const ze = (ft - je) * s, sn = ze + s > Be + we;
        ze < Be ? ee.scrollTop = ze : sn ? ee.scrollTop = ze - we + s : ee.scrollTop = Be;
      }
    }, me = () => {
      const G = (we) => Se.findIndex((Be) => Be.elementPosition == we);
      let ee = Me;
      for (; ee < se.length - 1; ) {
        ee++;
        const we = G(ee) != -1, Be = se[ee].disabled || se[ee].hidden || se[ee].optgroup, je = Se[G(ee - 1)] === Se[Se.length - 1];
        if (ee === se.length && (!we || Be) || je)
          return Me;
        if (we && !Be)
          break;
      }
      return ee;
    }, Ee = () => {
      let G = Me;
      for (; G >= 0; ) {
        G -= 1;
        const ee = Se.findIndex((Be) => Be.elementPosition == G) != -1, we = G >= 0 && (se[G].disabled || se[G].hidden || se[G].optgroup);
        if (G <= 0 && (!ee || we))
          return u && h ? G = -1 : Me;
        if (ee && !we)
          break;
      }
      return G;
    }, Ue = (G) => {
      const { key: ee } = G;
      if ([un, dn, fs, hs, ms].includes(ee)) {
        if (ee === hs)
          return A && Ce(Se[Me]), re == null || re.focus(), j(!1);
        if (G.preventDefault(), G.altKey && (ee === dn || ee === un))
          return w ? L == null || L() : k == null || k(), j(!w);
        if (ee === dn) {
          const we = me();
          return w ? (oe(we), ke(we)) : u ? j(!0) : Te([we]);
        }
        if (ee === un) {
          const we = Ee();
          return w ? (oe(we), ke(we)) : u ? j(!0) : Te([we]);
        }
        if (ee === fs) {
          const we = Se.findIndex((Be) => Be.elementPosition == Me);
          return w ? Me === Xt ? ie() : Ce(Se[we]) : (k == null || k(), j(!0));
        }
        if (ee === ms)
          return j(!1), re == null ? void 0 : re.focus();
      }
    }, _e = P(() => {
      j((G) => !G);
    }, []), z = P(
      (G) => {
        if (p && p.current === G.target)
          return;
        const ee = pe && pe !== null, we = re && re !== null, Be = !(pe != null && pe.contains(G.target)) && !(re != null && re.contains(G.target)), je = G.target === ce.current;
        ee && w && we && Be && !je && (j(!1), L == null || L());
      },
      [pe, re, w, L, p]
    );
    B(() => {
      const G = jc(e);
      Vc(G, se) || We(G);
    }, [e, se]);
    const Z = P(() => {
      w && nt(`${re == null ? void 0 : re.offsetWidth}px`);
    }, [re, w]), ie = () => {
      if (!u || !h)
        return;
      if (ae.length === e.filter((ee) => !ee.disabled && !ee.optgroup).length)
        return Te([]), T == null || T([]), x == null || x([]), xe([]);
      const G = se == null ? void 0 : se.filter((ee) => !ee.disabled && !ee.optgroup).map((ee) => ee.elementPosition);
      return Te(G), T == null || T(e.filter((ee) => !ee.disabled)), x == null || x(e.filter((ee) => !ee.disabled)), xe(G);
    }, ve = P(() => {
      if (se.length === 0)
        return;
      let G = ae[0];
      const ee = G === void 0, we = G >= se.length;
      if (Ve && !u) {
        if (ee && U || !Ve || u || we)
          return;
        ee && (G = 0);
        const Be = se[G].value, je = String(se[G].text);
        je ? (de(Be ? null : je), fe(Be ? je : "")) : (de(null), fe(Be ? " " : ""));
      }
    }, [u, Ve, ae, se, U]), xe = P(
      (G) => {
        const ee = m === -1 || G.length > m;
        if (G.length <= 0 && (de(null), fe("")), ee)
          return de(null), fe(`${G.length} ${f}`);
        const we = G.map((ze) => se[ze].text || "").filter((ze) => ze !== ""), Be = G.map((ze) => se[ze].value || "").filter((ze) => ze !== ""), je = we.findIndex((ze) => ze !== "") === -1, ft = Be.length > 0, Tt = we.join(", ");
        je ? (de(null), fe(ft ? " " : "")) : ft ? (fe(Tt), de(null)) : (fe(""), de(Tt));
      },
      [m, f, se]
    );
    B(() => {
      ve();
    }, [ae, ve]);
    const Ce = (G) => {
      if (!G || G.disabled)
        return;
      const { elementPosition: ee } = G;
      if (u) {
        const Be = ae.includes(ee) ? ae.filter((je) => je !== ee) : [...ae, ee];
        return Te(Be), T == null || T(Be.map((je) => e[je])), x == null || x(Be.map((je) => e[je])), xe(Be);
      }
      return Te([ee]), j(!1), T == null || T(e[ee]), x == null || x(e[ee]), L == null || L(), re == null ? void 0 : re.focus();
    };
    B(() => {
      Qe(!0);
    }, []), B(() => {
      if (u) {
        const ee = se.filter((we) => we.defaultSelected).map((we) => we.elementPosition);
        return xe(ee), Te(ee);
      }
      let G = se.findIndex((ee) => ee.defaultSelected);
      G === Xt && !U && (G = se.findIndex((ee) => !ee.disabled && !ee.hidden)), G !== Xt && Te([G]);
    }, [se, xe, u, U]), B(() => {
      if (w && V && ae.length === 0)
        return ke(Xt);
      w || (ae.length > 0 ? ke(Math.max(...ae)) : ke(0));
    }, [Se, w, V, ae]), B(() => {
      tt(R * s);
    }, [R, s]), B(() => {
      Z();
    }, [Z]), B(() => (w && (window.addEventListener("click", z), window.addEventListener("resize", Z)), () => {
      window.removeEventListener("click", z), window.removeEventListener("resize", Z);
    }), [z, Z, w]), B(() => {
      if (p) {
        const G = p.current;
        return G == null || G.addEventListener("click", _e), () => {
          G == null || G.removeEventListener("click", _e);
        };
      }
    }, [p, _e]), B(() => {
      if (!$)
        return;
      const G = Array.isArray($) ? $ : [$], ee = se.filter((Be) => Be.value && G.includes(Be.value)).map((Be) => Be.elementPosition);
      if (ee.toString() === ae.toString())
        return;
      const we = u ? ee.map((Be) => se[Be]) : se[ee[0]];
      T == null || T(we), x == null || x(we), Te(ee), u ? xe(ee) : ve();
    }, [$, se, u, T, x, ae, ve, xe]);
    const Ye = P(() => {
      o || (re == null || re.focus(), w ? L == null || L() : k == null || k(), j(!w));
    }, [o, w, k, L, re]), Xe = P(
      (G) => {
        var ee;
        G === "open" && (le(!1), M == null || M(), V && ((ee = ct.current) == null || ee.focus())), G === "closed" && (le(!0), I == null || I(), V && Le(""));
      },
      [M, I, V]
    );
    return /* @__PURE__ */ a("div", { className: dt, ...C, children: /* @__PURE__ */ K(be, { children: [
      /* @__PURE__ */ K(
        gt,
        {
          ref: De,
          onClick: Ye,
          onKeyDown: Ue,
          className: lt,
          value: he,
          readonly: !D,
          required: D,
          disabled: o,
          placeholder: ue ? void 0 : c,
          label: i,
          labelClass: rt,
          size: g,
          contrast: y,
          children: [
            D && /* @__PURE__ */ K(be, { children: [
              /* @__PURE__ */ a("div", { className: "invalid-feedback", children: _ }),
              /* @__PURE__ */ a("div", { className: "valid-feedback", children: Q })
            ] }),
            ue && /* @__PURE__ */ a("div", { className: "form-label select-fake-value active", children: ue }),
            l && (he.length > 0 || ue) && /* @__PURE__ */ a(
              "span",
              {
                tabIndex: 0,
                className: `select-clear-btn d-block ${o ? "pe-none" : ""}`,
                role: "button",
                onClick: () => {
                  fe(""), Te([]), T == null || T(u ? [] : {}), x == null || x(u ? [] : {});
                },
                children: "✕"
              }
            ),
            /* @__PURE__ */ a(
              "span",
              {
                className: `select-arrow ${o ? "pe-none" : ""}`,
                ref: ce,
                onClick: Ye,
                style: { cursor: "pointer" }
              }
            )
          ]
        }
      ),
      (e == null ? void 0 : e.length) > 0 && (w || !W) && /* @__PURE__ */ a(pt, { disablePortal: O, children: /* @__PURE__ */ a(
        "div",
        {
          style: { ...Pe.popper, width: Ge, zIndex: 1070 },
          ...qe.popper,
          ref: Ne,
          className: "select-dropdown-container",
          children: /* @__PURE__ */ a(Ft, { children: w && /* @__PURE__ */ K(
            Mt.div,
            {
              variants: { ...Kc, ...X },
              initial: "closed",
              animate: "open",
              exit: "closed",
              tabIndex: 0,
              className: ot,
              onAnimationStart: () => {
                le(!1);
              },
              onAnimationComplete: Xe,
              children: [
                V && /* @__PURE__ */ a("div", { className: "input-group", children: /* @__PURE__ */ a(
                  "input",
                  {
                    onKeyDown: Ue,
                    onChange: (G) => Le(G.target.value),
                    ref: ct,
                    type: "text",
                    className: "form-control select-filter-input",
                    role: "searchbox",
                    placeholder: Y
                  }
                ) }),
                /* @__PURE__ */ a(
                  "div",
                  {
                    className: "select-options-wrapper",
                    ref: S,
                    style: { maxHeight: `${st}px` },
                    children: /* @__PURE__ */ a(
                      Fc,
                      {
                        data: e,
                        selectData: Se,
                        selectedElements: ae,
                        optionHeight: s,
                        visibleOptions: R,
                        handleOptionClick: Ce,
                        handleSelectAll: ie,
                        selectAll: h,
                        selectAllLabel: v,
                        multiple: u,
                        activeElementIndex: Me,
                        noResults: J,
                        search: V
                      }
                    )
                  }
                ),
                d && /* @__PURE__ */ a("div", { className: "select-custom-content", children: d })
              ]
            }
          ) })
        }
      ) })
    ] }) });
  }
);
tr.displayName = "MDBSelectV2";
const Kt = gn({
  isLoading: !1,
  activePage: 0,
  setActivePage: null,
  sort: { column: "", option: "" },
  fixedHeader: !1,
  handleSort: null
}), qc = ({
  fullPagination: e,
  rowsText: t = "Rows per page:",
  selectValue: n,
  setSelectValue: s,
  activeDataLength: r,
  entriesOptions: o = [10, 25, 50, 200],
  fullDataLength: c,
  allText: i = "All",
  ofText: l = "of"
}) => {
  const { isLoading: d, activePage: u, setActivePage: m } = He(Kt), f = u === 0 || d, h = r <= n * (u + 1) || d, v = u === Math.floor(r / n), g = o.map((b) => ({
    text: b.toString(),
    value: b,
    defaultSelected: n === b
  }));
  g.push({
    text: i,
    value: c,
    defaultSelected: n === c
  });
  const p = (b) => {
    b instanceof Array || (s(b.value), m(0));
  }, y = `${u * n + 1} - ${(u + 1) * n > r ? r : (u + 1) * n} ${l} ${r}`;
  return /* @__PURE__ */ K("div", { className: "datatable-pagination", children: [
    /* @__PURE__ */ K("div", { className: "datatable-select-wrapper", children: [
      /* @__PURE__ */ a("p", { className: "datatable-select-text", children: t }),
      /* @__PURE__ */ a(tr, { onValueChange: p, data: g, disabled: d })
    ] }),
    /* @__PURE__ */ a("div", { className: "datatable-pagination-nav", children: y }),
    /* @__PURE__ */ K("div", { className: "datatable-pagination-buttons", children: [
      e && /* @__PURE__ */ a(
        Ae,
        {
          disabled: f,
          onClick: () => m(0),
          className: "datatable-pagination-button datatable-pagination-start",
          color: "link",
          children: /* @__PURE__ */ a(it, { icon: "angle-double-left" })
        }
      ),
      /* @__PURE__ */ a(
        Ae,
        {
          disabled: f,
          onClick: () => m(u - 1),
          className: "datatable-pagination-button datatable-pagination-left",
          color: "link",
          children: /* @__PURE__ */ a(it, { icon: "chevron-left" })
        }
      ),
      /* @__PURE__ */ a(
        Ae,
        {
          disabled: h,
          onClick: () => m(u + 1),
          className: "datatable-pagination-button datatable-pagination-right",
          color: "link",
          children: /* @__PURE__ */ a(it, { icon: "chevron-right" })
        }
      ),
      e && /* @__PURE__ */ a(
        Ae,
        {
          disabled: v,
          onClick: () => m(Math.floor(r / n)),
          className: "datatable-pagination-button datatable-pagination-end",
          color: "link",
          children: /* @__PURE__ */ a(it, { icon: "angle-double-right" })
        }
      )
    ] })
  ] });
}, ps = (e, t, n) => {
  const s = (r) => r.toString().toLowerCase().includes(t.toLowerCase());
  return e.filter((r) => {
    if (n && typeof n == "string")
      return s(r[n]);
    let o = Object.values(r);
    return n && Array.isArray(n) && (o = Object.keys(r).filter((c) => n.includes(c)).map((c) => r[c])), o.filter((c) => s(c)).length > 0;
  });
}, _c = (e, t, n) => Object.assign([], e).sort((r, o) => {
  const c = typeof r[t] == "string" ? r[t].toLowerCase() : r[t], i = typeof o[t] == "string" ? o[t].toLowerCase() : o[t];
  return c < i ? n === "desc" ? 1 : -1 : c > i ? n === "desc" ? -1 : 1 : 0;
}), nr = (e) => e.every((t) => typeof t == "string"), An = (e) => !e.every((t) => typeof t == "string"), zc = (e) => Array.isArray(e), vs = (e) => !Array.isArray(e), Uc = ({
  search: e,
  advancedSearch: t,
  searchValue: n,
  setSearchValue: s,
  searchInputProps: r,
  label: o = "Search",
  setAdvancedSearchValue: c
}) => /* @__PURE__ */ K(be, { children: [
  e && /* @__PURE__ */ a(
    gt,
    {
      value: n,
      onChange: (i) => s(i.target.value),
      label: o,
      className: "mb-4",
      ...r
    }
  ),
  t && /* @__PURE__ */ K(Bs, { className: "mb-4", children: [
    /* @__PURE__ */ a(
      "input",
      {
        className: "form-control",
        value: n,
        onChange: (i) => s(i.target.value),
        ...r
      }
    ),
    /* @__PURE__ */ a(
      Ae,
      {
        className: "datatable-advanced-search",
        onClick: () => c(t(n)),
        children: /* @__PURE__ */ a(it, { icon: "search" })
      }
    )
  ] })
] }), Gc = ({ dataColumns: e }) => {
  const { sort: t, fixedHeader: n, handleSort: s } = He(Kt), [r, o] = N("rotate(0deg)"), c = (i) => E("datatable-sort-icon", `${i === t.column && "active"}`);
  return B(() => {
    const i = t.option === "desc" ? "rotate(180deg)" : "rotate(0deg)";
    o(i);
  }, [t.option]), /* @__PURE__ */ a(be, { children: e.map((i, l) => /* @__PURE__ */ K(
    "th",
    {
      className: n ? "fixed-cell" : "",
      style: { cursor: "pointer" },
      scope: "row",
      onClick: () => s(i),
      children: [
        /* @__PURE__ */ a(
          it,
          {
            fas: !0,
            icon: "arrow-up",
            className: c(i),
            style: { transform: i === t.column ? r : "rotate(0deg)" }
          }
        ),
        i
      ]
    },
    l
  )) });
}, Qc = ({ dataColumns: e }) => {
  const [t, n] = N("rotate(0deg)"), { sort: s, fixedHeader: r, handleSort: o, isLoading: c } = He(Kt), i = (l) => E("datatable-sort-icon", `${l === s.column && "active"}`);
  return B(() => {
    const l = s.option === "desc" ? "rotate(180deg)" : "rotate(0deg)";
    n(l);
  }, [s.option]), /* @__PURE__ */ a(be, { children: e.map((l, d) => {
    const { fixedValue: u, fixed: m, label: f } = l, h = l.sort !== !1 && !c, p = { ...{ cursor: E(h && "pointer") }, ...{
      left: m === "left" ? u || 0 : void 0,
      right: m === "right" ? u || 0 : void 0
    } }, y = E((r || m) && "fixed-cell");
    return /* @__PURE__ */ K(
      "th",
      {
        className: y,
        style: p,
        scope: "row",
        onClick: () => h && o(f),
        children: [
          h && /* @__PURE__ */ a(
            it,
            {
              fas: !0,
              icon: "arrow-up",
              className: i(f),
              style: { transform: s.column === f ? t : "rotate(0deg)" }
            }
          ),
          f
        ]
      },
      d
    );
  }) });
}, Jc = ({ row: e, dataColumns: t, format: n, editable: s }) => /* @__PURE__ */ a(be, { children: t.map((r, o) => {
  const { field: c, fixed: i, width: l, fixedValue: d, columnSelector: u } = r, m = e[c], f = Number(m), h = n == null ? void 0 : n(c, f ? Number(m) : String(m)), g = { ...{
    minWidth: l,
    maxWidth: l,
    left: i === "left" && (d || 0),
    right: i === "right" && (d || 0)
  }, ...h }, p = E(i && "fixed-cell", u && `mdb-datatable-${u}`);
  return /* @__PURE__ */ a("td", { contentEditable: s, className: p, style: g, children: m }, o);
}) }), Zc = ({ row: e, editable: t }) => /* @__PURE__ */ a(be, { children: e.map((n, s) => /* @__PURE__ */ a("td", { contentEditable: t, children: n }, s)) }), ei = ({
  activeData: e,
  dataRows: t,
  isOnThePage: n,
  noFoundMessage: s,
  dataColumns: r,
  onRowClick: o,
  selectable: c,
  handleRowSelect: i,
  selectedRows: l,
  format: d,
  editable: u
}) => {
  const { isLoading: m } = He(Kt), f = e.length, h = r.length, v = (g, p) => {
    g.target.nodeName !== "INPUT" && (o == null || o(p));
  };
  return /* @__PURE__ */ K(eo, { className: "datatable-body", children: [
    e.map((g, p) => {
      const y = t.indexOf(g), b = l.includes(y), k = E(
        b && "active",
        vs(g) && g.rowSelector && `mdb-datatable-${g.rowSelector}`
      );
      if (n(p))
        return /* @__PURE__ */ K(
          "tr",
          {
            onClick: (M) => v(M, g),
            className: k,
            style: { cursor: o && "pointer" },
            children: [
              c && /* @__PURE__ */ a("td", { children: /* @__PURE__ */ a(Wt, { checked: b, onChange: () => i(y) }) }),
              zc(g) && /* @__PURE__ */ a(Zc, { editable: u, row: g }),
              vs(g) && An(r) && /* @__PURE__ */ a(Jc, { editable: u, row: g, dataColumns: r, format: d })
            ]
          },
          p
        );
    }),
    !f && !m && /* @__PURE__ */ a("tr", { className: "datatable-results-info", children: /* @__PURE__ */ a("td", { colSpan: h, className: "text-center", children: s }) })
  ] });
}, ti = ({
  dataColumns: e,
  dataRows: t,
  sort: n,
  searchValue: s,
  advancedSearch: r,
  advancedSearchValue: o
}) => {
  const [c, i] = N(t);
  return B(() => {
    const { column: l, option: d } = n, { phrase: u, columns: m } = o;
    let f;
    if (l) {
      let h, v = 0;
      An(e) && (h = e.find((g) => g.label === l)), nr(e) && (v = e.indexOf(l)), f = _c(t, h ? h.field : v, d);
    }
    s && !r && (f = ps(f || t, s, void 0)), u && (f = ps(f || t, u, m)), i(f || t);
  }, [n, t, e, s, r, o]), c;
}, ni = ne.forwardRef(
  ({
    advancedSearch: e,
    allText: t,
    className: n,
    bordered: s,
    borderless: r,
    borderColor: o = "",
    color: c = "",
    dark: i,
    entries: l = 10,
    editable: d,
    entriesOptions: u,
    fixedHeader: m,
    fullPagination: f,
    hover: h,
    format: v,
    loaderClass: g = "bg-primary",
    isLoading: p,
    loadingMessage: y = "Loading results...",
    maxWidth: b = "",
    maxHeight: k = "",
    multi: M,
    noFoundMessage: L = "No matching results found",
    pagination: I = !0,
    selectable: T,
    sortField: x = "",
    searchInputProps: V,
    sortOrder: Y = "asc",
    sm: H,
    striped: A,
    rowsText: J,
    data: D = {
      columns: [],
      rows: []
    },
    search: Q,
    onSelectRow: _,
    onRowClick: U,
    searchLabel: $,
    ofText: X,
    ...O
  }, C) => {
    const [q, F] = N(0), [j, w] = N(l), [W, le] = N({ column: "", option: "" }), [ue, de] = N([]), [re, De] = N(""), [pe, Ne] = N({
      phrase: "",
      columns: ""
    }), he = ti({
      dataColumns: D.columns,
      dataRows: D.rows,
      sort: W,
      searchValue: re,
      advancedSearch: e,
      advancedSearchValue: pe
    }), fe = E(
      "datatable",
      h && "datatable-hover",
      c && `bg-${c}`,
      i && "datatable-dark",
      s && "datatable-bordered",
      r && "datatable-borderless",
      o && `border-${o}`,
      A && "datatable-striped",
      H && "datatable-sm",
      p && "datatable-loading",
      n
    ), ye = (ae) => q * j <= ae && ae < (q + 1) * j, Le = (ae) => {
      const { column: Te, option: se } = W;
      le(Te === ae ? se === "asc" ? { ...W, option: "desc" } : { column: "", option: "" } : { column: ae, option: "asc" });
    }, Me = (ae) => {
      const se = ae.currentTarget.checked, We = se ? Array.from({ length: D.rows.length }, ($e, Ge) => Ge) : [], Se = We.map(($e) => he[$e]);
      _ == null || _(Se, We, se), de(We);
    }, ke = (ae) => {
      const Te = ue.includes(ae);
      let se;
      M ? Te ? se = ue.filter(($e) => $e !== ae) : se = [...ue, ae] : Te ? se = [] : se = [ae];
      const We = se.map(($e) => he[$e]), Se = se.length === D.rows.length;
      _ == null || _(We, se, Se), de(se);
    };
    return B(() => {
      x && le({ column: x, option: Y });
    }, [x, Y]), B(() => {
      F(0);
    }, [re]), /* @__PURE__ */ K(
      Kt.Provider,
      {
        value: {
          isLoading: p,
          activePage: q,
          setActivePage: F,
          sort: W,
          fixedHeader: m,
          handleSort: Le
        },
        children: [
          /* @__PURE__ */ a(
            Uc,
            {
              search: Q,
              advancedSearch: e,
              searchValue: re,
              setSearchValue: De,
              searchInputProps: V,
              label: $,
              setAdvancedSearchValue: Ne
            }
          ),
          /* @__PURE__ */ K("div", { className: fe, ref: C, style: { maxWidth: b }, ...O, children: [
            /* @__PURE__ */ a(
              Xs,
              {
                className: "datatable-inner table-responsive ps",
                style: { overflow: "auto", position: "relative", maxWidth: b, maxHeight: k },
                children: /* @__PURE__ */ K(Jr, { className: "datatable-table", children: [
                  /* @__PURE__ */ a(Zr, { className: "datatable-header", children: /* @__PURE__ */ K("tr", { children: [
                    T && /* @__PURE__ */ a("th", { className: m ? "fixed-cell" : "", children: M && /* @__PURE__ */ a(Wt, { checked: ue.length === D.rows.length, onChange: Me }) }),
                    nr(D.columns) && /* @__PURE__ */ a(Gc, { dataColumns: D.columns }),
                    An(D.columns) && /* @__PURE__ */ a(Qc, { dataColumns: D.columns })
                  ] }) }),
                  /* @__PURE__ */ a(
                    ei,
                    {
                      activeData: he,
                      dataColumns: D.columns,
                      dataRows: D.rows,
                      isOnThePage: ye,
                      onRowClick: U,
                      format: v,
                      handleRowSelect: ke,
                      selectedRows: ue,
                      selectable: T,
                      noFoundMessage: L,
                      editable: d
                    }
                  )
                ] })
              }
            ),
            p && /* @__PURE__ */ K(be, { children: [
              /* @__PURE__ */ a("div", { className: "datatable-loader bg-light}", children: /* @__PURE__ */ a("span", { className: "datatable-loader-inner", children: /* @__PURE__ */ a("span", { className: E("datatable-progress", g) }) }) }),
              /* @__PURE__ */ a("p", { className: "text-center text-muted my-4", children: y })
            ] }),
            I && /* @__PURE__ */ a(
              qc,
              {
                fullPagination: f,
                selectValue: j,
                setSelectValue: w,
                activeDataLength: he.length,
                rowsText: J,
                entriesOptions: u,
                fullDataLength: D.rows.length,
                allText: t,
                ofText: X
              }
            )
          ] })
        ]
      }
    );
  }
);
ni.displayName = "MDBDatatable";
Ns.register(...dr || []);
const si = (e) => {
  switch (e.toLowerCase()) {
    case "bar":
      return yr;
    case "line":
      return gr;
    case "pie":
      return br;
    case "doughnut":
      return vr;
    case "polararea":
      return pr;
    case "radar":
      return hr;
    case "bubble":
      return mr;
    default:
      return fr;
  }
}, ri = (e, t, n) => {
  e || (e = {});
  const s = (r, o, c) => {
    const i = r.slice();
    return o.forEach((l, d) => {
      typeof i[d] > "u" ? i[d] = c.cloneUnlessOtherwiseSpecified(l, c) : c.isMergeableObject(l) ? i[d] = Wn(r[d], l, c) : r.indexOf(l) === -1 && i.push(l);
    }), i;
  };
  return Wn(n[t], e, {
    arrayMerge: s
  });
}, oi = {
  line: {
    elements: {
      line: {
        backgroundColor: "rgba(66, 133, 244, 0.0)",
        borderColor: "rgb(66, 133, 244)",
        borderWidth: 2,
        tension: 0
      },
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgb(66, 133, 244)"
      }
    },
    responsive: !0,
    plugins: {
      tooltip: {
        intersect: !1,
        mode: "index"
      },
      legend: {
        display: !0
      }
    },
    scales: {
      x: {
        stacked: !0,
        grid: {
          display: !1,
          drawBorder: !1
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        stacked: !0,
        grid: {
          borderDash: [2],
          drawBorder: !1,
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  },
  bar: {
    elements: {
      line: {
        backgroundColor: "rgb(66, 133, 244)"
      },
      bar: {
        backgroundColor: "rgb(66, 133, 244)"
      }
    },
    responsive: !0,
    plugins: {
      tooltip: {
        intersect: !1,
        mode: "index"
      },
      legend: {
        display: !0
      }
    },
    scales: {
      x: {
        stacked: !0,
        grid: {
          display: !1,
          drawBorder: !1
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        stacked: !0,
        grid: {
          borderDash: [2],
          drawBorder: !1,
          color: function(e) {
            return e.tick && e.tick.value === 0 ? "rgba(0,0,0, 0)" : Ns.defaults.borderColor;
          },
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  },
  pie: {
    elements: {
      arc: { backgroundColor: "rgb(66, 133, 244)" }
    },
    responsive: !0,
    plugins: {
      legend: {
        display: !0
      }
    }
  },
  doughnut: {
    elements: {
      arc: { backgroundColor: "rgb(66, 133, 244)" }
    },
    responsive: !0,
    plugins: {
      legend: {
        display: !0
      }
    }
  },
  polarArea: {
    elements: {
      arc: { backgroundColor: "rgba(66, 133, 244, 0.5)" }
    },
    responsive: !0,
    plugins: {
      legend: {
        display: !0
      }
    }
  },
  radar: {
    elements: {
      line: {
        backgroundColor: "rgba(66, 133, 244, 0.5)",
        borderColor: "rgb(66, 133, 244)",
        borderWidth: 2
      },
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgb(66, 133, 244)"
      }
    },
    responsive: !0,
    plugins: {
      legend: {
        display: !0
      }
    }
  },
  scatter: {
    elements: {
      line: {
        backgroundColor: "rgba(66, 133, 244, 0.5)",
        borderColor: "rgb(66, 133, 244)",
        borderWidth: 2,
        tension: 0
      },
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgba(66, 133, 244, 0.5)"
      }
    },
    responsive: !0,
    plugins: {
      tooltip: {
        intersect: !1,
        mode: "index"
      },
      legend: {
        display: !0
      }
    },
    datasets: {
      borderColor: "red"
    },
    scales: {
      x: {
        stacked: !0,
        grid: {
          display: !1,
          drawBorder: !1
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        stacked: !1,
        grid: {
          borderDash: [2],
          drawBorder: !1,
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  },
  bubble: {
    elements: {
      point: {
        borderColor: "rgb(66, 133, 244)",
        backgroundColor: "rgba(66, 133, 244, 0.5)"
      }
    },
    responsive: !0,
    plugins: {
      legend: {
        display: !0
      }
    },
    scales: {
      x: {
        grid: {
          display: !1,
          drawBorder: !1
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      },
      y: {
        grid: {
          borderDash: [2],
          drawBorder: !1,
          tickBorderDash: [2],
          tickBorderDashOffset: [2]
        },
        ticks: {
          color: "rgba(0,0,0, 0.5)"
        }
      }
    }
  }
}, Ml = ({ data: e, datalabels: t, options: n, type: s, chartRef: r, ...o }) => {
  const c = te(null), i = r || c, l = si(s);
  return /* @__PURE__ */ a(
    l,
    {
      data: e,
      options: ri(n, s, oi),
      ref: i,
      plugins: t ? [ur] : void 0,
      ...o
    }
  );
}, xl = ({ children: e, position: t = "top-right", className: n, style: s }) => {
  const r = E("stack", `stack-${t}`, n), o = Fe(() => t.split("-")[0], [t]), c = Fe(() => t.split("-")[1], [t]), i = Fe(() => c !== "center" ? {
    [o]: 10,
    [c]: 10
  } : {
    [o]: 10,
    left: "50%",
    transform: "translateX(-50%)"
  }, [c, o]), l = Fe(() => {
    const d = ys.toArray(e);
    return o === "bottom" ? d.reverse() : d;
  }, [e, o]);
  return /* @__PURE__ */ a(
    "div",
    {
      className: r,
      style: {
        ...i,
        ...s
      },
      children: l.length > 0 && l.map((d, u) => ne.cloneElement(d, {
        ...d.props,
        style: {
          marginTop: o === "bottom" ? "10px" : "0",
          marginBottom: o === "top" ? "10px" : "0",
          ...d.props.style
        },
        key: u
      }))
    }
  );
}, St = ne.createContext({
  activeItem: 1,
  setActiveItem: null,
  prevActive: { current: 1 },
  setHeight: null,
  completed: [],
  noEditable: !1,
  isAnimating: { current: !1 },
  linear: !1,
  formRef: { current: null },
  validate: { target: 0, after: 0 },
  setValidate: null,
  type: "horizontal",
  stepsLength: 0,
  onValid: void 0,
  onInvalid: void 0,
  mobileProgress: !1,
  disableHeadSteps: !1,
  animations: !0
}), ci = ({ ofLabel: e = "of", stepLabel: t = "step" }) => {
  const { activeItem: n, stepsLength: s } = He(St);
  return /* @__PURE__ */ K("div", { className: "stepper-mobile-head bg-light", children: [
    t,
    " ",
    n,
    " ",
    e,
    " ",
    s
  ] });
}, ii = ({
  mobileProgress: e,
  backLabel: t = "BACK",
  nextLabel: n = "NEXT"
}) => {
  const { activeItem: s, setActiveItem: r, prevActive: o, isAnimating: c, stepsLength: i, onChange: l } = He(St), d = () => {
    if (c.current && s !== o.current)
      return;
    o.current = s;
    const m = s !== i ? s + 1 : s;
    l == null || l(m), r(m);
  };
  return /* @__PURE__ */ K("div", { className: "stepper-mobile-footer bg-light", children: [
    /* @__PURE__ */ a("div", { className: "stepper-back-btn", children: /* @__PURE__ */ K(Ae, { color: "link", onClick: () => {
      if (c.current && s !== o.current)
        return;
      o.current = s;
      const m = s !== 1 ? s - 1 : s;
      l == null || l(m), r(m);
    }, children: [
      /* @__PURE__ */ a(it, { fas: !0, icon: "chevron-left" }),
      t
    ] }) }),
    e && /* @__PURE__ */ a("div", { className: "stepper-mobile-progress gray-500", children: /* @__PURE__ */ a(
      "div",
      {
        className: "stepper-mobile-progress-bar bg-primary",
        style: { width: `${s / i * 100}%` }
      }
    ) }),
    /* @__PURE__ */ a("div", { className: "stepper-next-btn", children: /* @__PURE__ */ K(Ae, { color: "link", onClick: d, children: [
      n,
      /* @__PURE__ */ a(it, { fas: !0, icon: "chevron-right" })
    ] }) })
  ] });
}, li = 500, El = ({
  className: e,
  children: t,
  defaultStep: n = 1,
  activeStep: s,
  linear: r,
  noEditable: o,
  externalNext: c,
  externalPrev: i,
  style: l,
  type: d = "horizontal",
  onChange: u,
  onInvalid: m,
  onValid: f,
  mobileProgress: h,
  disableHeadSteps: v,
  mobileOfLabel: g,
  mobileStepLabel: p,
  mobileBackLabel: y,
  mobileNextLabel: b,
  animations: k = !0,
  ...M
}) => {
  const [L, I] = N(s || n), T = Fe(() => s === void 0 ? L : s, [s, L]), [x, V] = N(void 0), [Y, H] = N([]), [A, J] = N({ target: 0, after: 0 }), [D, Q] = N(0), _ = te(n), U = te(!1), $ = d === "mobile", X = E(
    "stepper",
    d === "horizontal" && "stepper-horizontal",
    d === "vertical" && "stepper-vertical",
    $ && "stepper-mobile",
    e
  ), O = { height: E(d !== "vertical" && x && `${x}px`), ...l }, C = te(null), q = te(null);
  return B(() => {
    const F = () => {
      I((w) => {
        if (U.current && w !== _.current)
          return w;
        _.current = w;
        const W = w !== D ? w + 1 : w;
        return r ? (J({ target: w, after: W }), w) : (u == null || u(W), W);
      });
    }, j = c == null ? void 0 : c.current;
    if (j)
      return j.addEventListener("click", F), () => {
        j.removeEventListener("click", F);
      };
  }, [c, r, D, u]), B(() => {
    const F = () => {
      I((w) => {
        if (U.current && w !== _.current)
          return w;
        _.current = w;
        const W = w !== 1 ? w - 1 : w;
        return r ? (J({ target: w, after: W }), w) : (u == null || u(W), W);
      });
    }, j = i == null ? void 0 : i.current;
    if (j)
      return j.addEventListener("click", F), () => {
        j.removeEventListener("click", F);
      };
  }, [i, r, u]), B(() => {
    H((F) => F.includes(T) ? F : [...F, T]);
  }, [T]), B(() => {
    U.current = !0;
    const F = setTimeout(() => {
      _.current = T, U.current = !1;
    }, li);
    return () => {
      clearTimeout(F);
    };
  }, [T]), B(() => {
    const F = C.current;
    if (!F)
      return;
    const j = F.querySelectorAll("li").length;
    Q(j);
  }, []), /* @__PURE__ */ a("ul", { ref: C, className: X, ...M, style: O, children: /* @__PURE__ */ K(
    St.Provider,
    {
      value: {
        activeItem: T,
        setActiveItem: I,
        prevActive: _,
        setHeight: V,
        completed: Y,
        noEditable: o,
        isAnimating: U,
        linear: r,
        formRef: q,
        validate: A,
        setValidate: J,
        type: d,
        stepsLength: D,
        onValid: f,
        onInvalid: m,
        onChange: u,
        mobileProgress: h,
        disableHeadSteps: v,
        animations: k,
        isControlled: s !== void 0
      },
      children: [
        $ && /* @__PURE__ */ a(ci, { ofLabel: g, stepLabel: p }),
        t,
        $ && /* @__PURE__ */ a(
          ii,
          {
            backLabel: y,
            nextLabel: b,
            mobileProgress: h
          }
        )
      ]
    }
  ) });
}, ai = ({
  stepRef: e,
  setHeight: t,
  isActive: n,
  isValidated: s,
  isMobile: r,
  children: o
}) => {
  const c = P(() => {
    var y, b;
    const i = e.current, l = i == null ? void 0 : i.querySelector(".stepper-content"), d = l && getComputedStyle(l), u = (y = i == null ? void 0 : i.parentNode) == null ? void 0 : y.querySelector(".stepper-mobile-footer"), m = u ? getComputedStyle(u) : "";
    let f;
    r ? f = (b = i == null ? void 0 : i.parentNode) == null ? void 0 : b.querySelector(".stepper-mobile-head") : f = i == null ? void 0 : i.querySelector(".stepper-head");
    const h = f && getComputedStyle(f), v = (l == null ? void 0 : l.offsetHeight) + parseFloat(d == null ? void 0 : d.marginTop) + parseFloat(d == null ? void 0 : d.marginBottom), g = (f == null ? void 0 : f.offsetHeight) + parseFloat(h == null ? void 0 : h.marginTop) + parseFloat(h == null ? void 0 : h.marginBottom), p = m ? (u == null ? void 0 : u.offsetHeight) + parseFloat(m == null ? void 0 : m.marginTop) + parseFloat(m == null ? void 0 : m.marginBottom) : 0;
    t(g + v + p);
  }, [t, e, r]);
  B(() => {
    if (n)
      return setTimeout(() => {
        c();
      }, 10), s && setTimeout(() => {
        c();
      }, 210), window.addEventListener("resize", c), () => {
        window.removeEventListener("resize", c);
      };
  }, [n, c, s]), B(() => {
    c();
  }, [o, c]);
}, ui = (e, t, n) => {
  let s = "";
  const r = n > t, o = n < t;
  return e ? s = E(r && "slide-out-left", o && "slide-out-right") : s = E(r && "slide-in-right", o && "slide-in-left"), s;
}, di = (e, t) => Array.from(e.querySelectorAll("input[required]")).every((s) => t ? t(s) : s.checkValidity()), fi = ({ itemId: e, children: t, className: n, style: s }) => {
  const { activeItem: r, prevActive: o, animations: c } = He(St), [i, l] = N(e === r), [d, u] = N(!1), m = E("stepper-content", "py-3", !i && "stepper-content-hide", n), f = ui(d, o.current, r), v = { display: (c ? i || d : i) ? "block" : "none", ...s };
  return B(() => {
    const { current: g } = o;
    e === g && (u(!0), setTimeout(() => {
      u(!1);
    }, 800));
  }, [e, o, r]), B(() => {
    l(e === r);
  }, [e, r]), /* @__PURE__ */ a(rc, { className: m, start: "onLoad", animation: f, duration: 800, style: v, children: /* @__PURE__ */ a("span", { children: t }) });
}, mi = ({
  itemId: e,
  children: t,
  className: n,
  isValidated: s,
  style: r
}) => {
  const { activeItem: o } = He(St), [c, i] = N(!0), l = E("stepper-content", "py-0", "d-grid", !c && "stepper-content-hide", n), d = {
    transition: "grid-template-rows 0.3s ease-in-out",
    gridTemplateRows: c ? "1fr" : "0fr",
    ...r
  }, u = te(null);
  return B(() => {
    i(e === o);
  }, [e, o]), /* @__PURE__ */ a("div", { style: d, className: l, ref: u, children: /* @__PURE__ */ a(
    "span",
    {
      className: `${c ? "py-3" : "py-0"} overflow-hidden`,
      style: {
        transition: "padding 0.3s ease-in-out"
      },
      children: t
    }
  ) });
}, Dl = ({
  className: e,
  itemId: t,
  children: n,
  headIcon: s,
  headText: r,
  customValidation: o,
  headClassName: c,
  contentClassName: i,
  headStyle: l,
  contentStyle: d,
  ...u
}) => {
  const {
    activeItem: m,
    setActiveItem: f,
    setHeight: h,
    prevActive: v,
    completed: g,
    noEditable: p,
    linear: y,
    formRef: b,
    validate: k,
    setValidate: M,
    type: L,
    onInvalid: I,
    onValid: T,
    onChange: x,
    mobileProgress: V,
    isAnimating: Y,
    disableHeadSteps: H,
    isControlled: A
  } = He(St), [J, D] = N(!1), [Q, _] = N(!1), U = g.includes(t), $ = m === t, X = p && U && !$, C = E(
    "stepper-step",
    $ && "stepper-active",
    U && "stepper-completed",
    X && "stepper-disabled",
    y && J && "was-validated",
    Q && "stepper-invalid",
    e
  ), q = E("stepper-head", c), F = te(null), j = { cursor: E(H && "auto"), ...l };
  ai({ stepRef: F, setHeight: h, isActive: $, isValidated: J, isMobile: L === "mobile", children: n });
  const w = () => {
    const W = Y.current && L !== "vertical" && m !== v.current;
    if (!(X || $ || H || W)) {
      if (y && !A) {
        M({ target: m, after: t });
        return;
      }
      v.current = m, f(t), x == null || x(t);
    }
  };
  return B(() => {
    const { target: W, after: le } = k;
    if (t === W && y) {
      if (le < W) {
        v.current = W, f(le), x == null || x(le);
        return;
      }
      const ue = F.current, de = b.current;
      de == null || de.classList.add("was-validated");
      const re = di(ue, o);
      D(!0), _(!re), re ? (T == null || T(t), de == null || de.classList.remove("was-validated"), v.current = W, f(le), x == null || x(le)) : I == null || I(t);
    }
  }, [
    k,
    t,
    b,
    y,
    f,
    v,
    A,
    T,
    I,
    x,
    o
  ]), /* @__PURE__ */ K("li", { ref: F, className: C, ...u, children: [
    !V && /* @__PURE__ */ K("div", { className: q, tabIndex: $ ? 0 : -1, onClick: w, style: j, children: [
      /* @__PURE__ */ a("span", { className: "stepper-head-icon", children: s }),
      /* @__PURE__ */ a("span", { className: "stepper-head-text", children: r })
    ] }),
    L === "vertical" ? /* @__PURE__ */ a(
      mi,
      {
        style: d,
        className: i,
        isValidated: J,
        itemId: t,
        children: n
      }
    ) : /* @__PURE__ */ a(fi, { style: d, className: i, itemId: t, children: n })
  ] });
}, Tl = ({ className: e, children: t, onSubmit: n, ...s }) => {
  const { formRef: r, setValidate: o, activeItem: c } = He(St), i = E("stepper-form", e);
  return /* @__PURE__ */ a(Ls, { onSubmit: (d) => {
    o({ target: c, after: c }), n == null || n(d);
  }, ref: r, className: i, ...s, noValidate: !0, children: t });
}, sr = ne.createContext({
  activeItem: 0,
  dynamic: !1,
  dynamicStyle: { color: "", icon: "" },
  setDynamicStyle: null,
  setActiveItem: null,
  hoveredItem: 0,
  setHoveredItem: null,
  readonly: !1,
  onChange: void 0
}), Bl = ({
  className: e,
  readonly: t = !1,
  defaultValue: n = 0,
  value: s,
  dynamic: r,
  children: o,
  onChange: c,
  ...i
}) => {
  const l = E("rating", e), [d, u] = N(0), [m, f] = N({ color: "", icon: "" }), [h, v] = N(n), g = Fe(() => s !== void 0 ? s : h, [s, h]);
  return /* @__PURE__ */ a("ul", { className: l, ...i, children: /* @__PURE__ */ a(
    sr.Provider,
    {
      value: {
        readonly: t,
        activeItem: g,
        setActiveItem: v,
        hoveredItem: d,
        setHoveredItem: u,
        dynamic: r,
        dynamicStyle: m,
        setDynamicStyle: f,
        onChange: c
      },
      children: o
    }
  ) });
}, Ll = ({
  className: e,
  color: t,
  itemId: n,
  iconClassName: s,
  insertAfter: r,
  insertBefore: o,
  icon: c,
  onClick: i,
  onMouseEnter: l,
  onMouseLeave: d,
  popover: u,
  size: m = "sm",
  title: f,
  style: h,
  ...v
}) => {
  const {
    activeItem: g,
    setActiveItem: p,
    hoveredItem: y,
    setHoveredItem: b,
    dynamic: k,
    dynamicStyle: M,
    setDynamicStyle: L,
    readonly: I,
    onChange: T
  } = He(sr), x = !y && g && g >= n || y >= n, V = E(x && "active", !t && "text-primary", s), Y = (D) => {
    I || (p && p(n), T == null || T(n), i && i(D));
  }, H = (D) => {
    I || (p && b(n), l && l(D));
  }, A = (D) => {
    I || (p && b(0), d && d(D));
  };
  B(() => {
    k && (y || g) === n && L({ color: t, icon: c });
  }, [g, n, t, c, k, L, y]);
  const J = /* @__PURE__ */ a(be, { children: /* @__PURE__ */ K(
    "li",
    {
      className: e,
      onMouseEnter: H,
      onMouseLeave: A,
      onClick: Y,
      style: { cursor: I ? "default" : "pointer", ...h },
      ...v,
      children: [
        o,
        /* @__PURE__ */ a(
          it,
          {
            far: !x,
            fas: x,
            icon: M.icon ? M.icon : c,
            size: m,
            className: V,
            style: { color: M.color ? M.color : t && t }
          }
        ),
        r
      ]
    }
  ) });
  return /* @__PURE__ */ a(be, { children: f ? /* @__PURE__ */ a(Cr, { tag: "a", title: f, children: J }) : u ? /* @__PURE__ */ a(fo, { tag: "a", btnChildren: J, children: /* @__PURE__ */ a(mo, { children: u }) }) : J });
}, hi = ({
  animation: e = "fade-in",
  className: t,
  containerRef: n,
  lazyRef: s,
  lazyOffset: r = 0,
  lazySrc: o,
  lazyError: c,
  lazyDelay: i = 500,
  lazyPlaceholder: l,
  video: d,
  onLoad: u,
  onError: m,
  ...f
}) => {
  const h = te(null), v = s || h, [g, p] = N(l || "..."), [y, b] = N(!1), [k, M] = N(!1), L = E(e !== "none" && y && `animation ${e}`, t), I = P(() => {
    const x = v.current.getBoundingClientRect();
    if (n) {
      const V = n.current.getBoundingClientRect();
      V.y > 0 && V.y < window.innerHeight && x.y >= V.y && x.y <= V.y + V.height && x.y <= window.innerHeight && (M(!0), u && u());
    }
    x.top + r <= window.innerHeight && x.bottom >= 0 && (M(!0), u && u());
  }, [r, v, n, u]), T = P(() => {
    m && m(c), c && p(c), b(!0);
  }, [c, m]);
  return B(() => {
    k && setTimeout(() => {
      o && p(o), b(!0);
    }, i);
  }, [k, i, o]), B(() => {
    let x;
    n ? n.current.classList.contains("lazy-container") ? x = window : x = n.current : x = window;
    const V = v.current;
    return x.addEventListener("scroll", I), V.addEventListener("error", T), k && x.removeEventListener("scroll", I), () => {
      x.removeEventListener("scroll", I), V.removeEventListener("error", T);
    };
  }, [n, I, k, T, v]), d ? /* @__PURE__ */ a("video", { className: L, src: g, ref: v, ...f }) : /* @__PURE__ */ a("img", { className: L, src: g, ref: v, ...f });
}, Sl = ({
  tag: e = "div",
  lazyContainerRef: t,
  lazyItems: n = [],
  lazyPlaceholder: s,
  lazyError: r,
  className: o,
  ...c
}) => {
  const i = E("lazy-container", o), l = te(null), d = t || l;
  return /* @__PURE__ */ a(e, { ref: d, className: i, ...c, children: n.map((u) => {
    const m = { ...u };
    return s && (m.lazyPlaceholder = s), r && (m.lazyError = r), m.containerRef = d, /* @__PURE__ */ a(hi, { ...m }, Math.floor(Math.random() * 999 + 1));
  }) });
}, Il = ({
  children: e,
  infiniteScrollRef: t,
  infiniteDirection: n,
  tag: s = "div",
  onInfiniteScroll: r,
  onComplete: o,
  windowParent: c = !1,
  ...i
}) => {
  const l = te(null), d = t || l, u = (h) => h.getBoundingClientRect(), m = P(() => {
    if (c)
      return window.scrollY + window.innerHeight === document.documentElement.scrollHeight;
    const h = u(d.current);
    return n === "x" ? h.width + d.current.scrollLeft + 10 >= d.current.scrollWidth : Math.ceil(h.height + d.current.scrollTop) >= d.current.scrollHeight;
  }, [c, n, d]), f = P(() => {
    m() && (o && o(), r && r());
  }, [m, r, o]);
  return B(() => {
    const h = c ? window : d.current;
    return h.addEventListener("scroll", f), () => {
      h.removeEventListener("scroll", f);
    };
  }, [f, d, c]), /* @__PURE__ */ a(s, { ref: d, ...i, children: e });
};
function pi(e) {
  const t = e.getBoundingClientRect();
  return {
    top: t.top + document.body.scrollTop,
    left: t.left + document.body.scrollLeft
  };
}
function bs(e) {
  const t = pi(e), n = e.getBoundingClientRect(), s = t.left === 0 && t.top === 0 ? 0 : window.innerHeight - n.bottom;
  return {
    ...t,
    bottom: s
  };
}
const Al = ({
  className: e,
  stickyRef: t,
  animationSticky: n,
  animationUnsticky: s,
  boundary: r,
  delay: o = 0,
  direction: c = "down",
  offset: i = 0,
  position: l = "top",
  tag: d = "span",
  children: u,
  onActive: m,
  onInactive: f,
  ...h
}) => {
  const v = te(null), g = te(null), p = t || v, y = te(""), b = te(!1), k = te(0), M = te(0), L = te(0), [I, T] = N(), [x, V] = N(), [Y, H] = N(!1), [A, J] = N({}), [D, Q] = N(!1), _ = E(
    "sticky",
    n && Y && `animation ${n}`,
    s && D && `animation ${s}`,
    e
  ), U = P(() => {
    const j = g.current, w = p.current;
    j ? k.current = j.offsetTop : k.current = w.offsetTop;
  }, [p]), $ = P(() => {
    const j = p.current;
    j && (l === "top" ? L.current = k.current - o : L.current = k.current + j.height - document.body.scrollHeight + o);
  }, [o, l, p]), X = P((j) => {
    j > M.current ? y.current = "down" : y.current = "up";
  }, []), O = (j, w) => {
    Object.keys(w).forEach((W) => {
      j.style[W] = w[W];
    });
  }, C = P(() => {
    const j = g.current, w = p.current;
    if (j) {
      const { left: W } = j.getBoundingClientRect();
      J({ left: `${W}px` });
    } else
      J({});
    O(w, A), U();
  }, [U, A, p]), q = P(() => {
    const j = p.current, w = i, { height: W } = j.getBoundingClientRect(), le = {
      height: j.parentElement.getBoundingClientRect().height,
      ...bs(j.parentElement)
    };
    let ue;
    const de = typeof r != "boolean" && (r == null ? void 0 : r.current);
    de ? ue = bs(de).top - W - w : ue = le.height + le[l] - W - w;
    const re = l === "top", De = l === "bottom", pe = r, Ne = ue < 0, he = ue > le.height - W;
    let fe;
    re && (Ne && pe ? fe = { top: `${w + ue}px` } : fe = { top: `${w + 0}px` }), De && (Ne && pe ? fe = { bottom: `${w + ue}px` } : he && pe ? fe = { bottom: `${i + le.bottom}px` } : fe = { bottom: `${w + 0}px` }), O(j, fe);
  }, [r, i, l, p]), F = P(() => {
    const j = window.pageYOffset || document.documentElement.scrollTop, w = i;
    U(), $(), X(j);
    const W = [y.current, "both"].includes(c), le = L.current <= j, ue = le && !b.current && W, de = (!le || !W) && b.current;
    if (ue) {
      const { height: re, left: De, width: pe } = p.current.getBoundingClientRect();
      m && m(), H(!0), V({
        height: `${re}px`,
        width: `${pe}px`,
        opacity: "0"
      }), T({
        top: l === "top" ? `${0 + w}px` : null,
        bottom: l === "bottom" ? `${0 + w}px` : null,
        height: `${re}px`,
        width: `${pe}px`,
        left: `${De}px`,
        zIndex: "100",
        position: "fixed"
      }), q(), b.current = !0;
    }
    de && (f && f(), s ? (Q(!0), setTimeout(() => {
      T({
        top: null,
        bottom: null,
        position: null,
        left: null,
        zIndex: null,
        width: null,
        height: null
      }), H(!1), V({
        height: null,
        width: null,
        opacity: null
      }), Q(!1);
    }, 200)) : (T({
      top: null,
      bottom: null,
      position: null,
      left: null,
      zIndex: null,
      width: null,
      height: null
    }), H(!1), V({
      height: null,
      width: null,
      opacity: null
    })), b.current = !1), b.current && (O(p.current, A), q()), M.current = j <= 0 ? 0 : j;
  }, [
    c,
    U,
    $,
    X,
    i,
    l,
    p,
    A,
    q,
    s,
    m,
    f
  ]);
  return B(() => (window.addEventListener("resize", C), window.addEventListener("scroll", F), () => {
    window.removeEventListener("resize", C), window.removeEventListener("scroll", F);
  }), [C, F]), /* @__PURE__ */ K(be, { children: [
    Y && /* @__PURE__ */ a(d, { className: _, ref: g, style: x, ...h, children: u }),
    /* @__PURE__ */ a(d, { className: _, ref: p, style: I, ...h, children: u })
  ] });
}, vi = ne.forwardRef(
  ({
    backdrop: e = !0,
    backdropColor: t = "black",
    backdropOpacity: n = 0.4,
    color: s,
    className: r,
    loadingText: o = "Loading...",
    isOpen: c,
    fullScreen: i,
    overflow: l = !0,
    parentRef: d,
    spinnerElement: u = /* @__PURE__ */ a(Ms, { className: "loading-icon", role: "status" }),
    textClassName: m,
    textStyles: f,
    tag: h = "div",
    ...v
  }, g) => {
    const p = E("loading-text", m), y = E(
      i ? "loading-full" : "loading",
      "loading-spinner",
      i ? "position-fixed" : "position-absolute",
      s && `text-${s}`,
      r
    ), b = E("loading-backdrop", !i && "position-absolute");
    B(() => {
      const L = d == null ? void 0 : d.current;
      if (L)
        return L.classList.add("position-relative"), () => {
          L.classList.remove("position-relative");
        };
    }, [d]), B(() => {
      if (i && l)
        return c ? document.body.style.overflow = "hidden" : document.body.style.overflow = "", () => {
          document.body.style.overflow = "";
        };
    }, [i, c, l]);
    const k = /* @__PURE__ */ K(h, { className: y, ref: g, ...v, children: [
      u,
      /* @__PURE__ */ a("span", { className: p, style: f, children: o })
    ] }), M = /* @__PURE__ */ a("div", { className: b, style: { opacity: n, backgroundColor: t } });
    return /* @__PURE__ */ a(be, { children: c !== !1 && /* @__PURE__ */ a(be, { children: i ? /* @__PURE__ */ K(pt, { children: [
      k,
      M
    ] }) : /* @__PURE__ */ K(be, { children: [
      k,
      e && M
    ] }) }) });
  }
);
vi.displayName = "MDBLoadingManagement";
const bi = ({
  isOpened: e,
  inputRef: t,
  dropdownEl: n,
  setOpenState: s,
  onClose: r
}) => {
  const o = P(
    (c) => {
      if (!n)
        return;
      const i = t.current === c.target, l = n === c.target, d = n.contains(c.target);
      e && !i && !l && !d && (s(!1), r == null || r());
    },
    [e, s, n, t, r]
  );
  B(() => (document.addEventListener("click", o), () => {
    document.removeEventListener("click", o);
  }), [o]);
}, gi = ({ inputRef: e, dropdownEl: t }) => {
  const n = P(() => {
    if (!e.current || !t)
      return;
    const { width: s } = window.getComputedStyle(e.current);
    t.style.width = s;
  }, [t, e]);
  B(() => (n(), window.addEventListener("resize", n), () => {
    window.removeEventListener("resize", n);
  }), [n]);
}, yi = ({ isOpen: e }) => {
  const [t, n] = N(!1);
  return B(() => {
    let s;
    return e ? n(!0) : s = setTimeout(() => {
      n(!1);
    }, 100), () => {
      clearTimeout(s);
    };
  }, [e]), t;
}, wi = ({
  className: e,
  customContent: t = null,
  inputRef: n,
  isOpen: s,
  isOpened: r,
  children: o,
  setOpenState: c,
  listHeight: i = "190px",
  onOpened: l,
  onClose: d,
  onClosed: u,
  ...m
}) => {
  const [f, h] = N(null), [v, g] = N(null), p = Fe(
    () => [
      {
        name: "matchReferenceWidth",
        enabled: !0,
        fn: ({ state: I, instance: T }) => {
          if (!v)
            return;
          const x = v.offsetWidth, V = I.rects.reference.width;
          Math.round(x) !== Math.round(V) && (v.style.width = `${V}px`, T.update());
        },
        phase: "beforeWrite",
        requires: ["computeStyles"]
      }
    ],
    [v]
  ), y = yi({ isOpen: s }), { styles: b, attributes: k, update: M } = wt(f, v, { modifiers: p }), L = E("autocomplete-dropdown", s && "open", e);
  return bi({ isOpened: r, setOpenState: c, dropdownEl: v, inputRef: n, onClose: d }), gi({ inputRef: n, dropdownEl: v }), B(() => {
    n.current && h(n.current);
  }, [n]), B(() => {
    s && (M == null || M());
  }, [s, M, y]), /* @__PURE__ */ a(be, { children: /* @__PURE__ */ a(pt, { children: /* @__PURE__ */ a(
    "div",
    {
      className: "autocomplete-dropdown-container",
      ref: g,
      ...m,
      style: b.popper,
      ...k.popper,
      onTransitionEnd: (I) => {
        I.propertyName === "opacity" && (y ? l == null || l() : u == null || u());
      },
      children: /* @__PURE__ */ K("div", { className: L, children: [
        /* @__PURE__ */ a(
          "ul",
          {
            className: "autocomplete-items-list",
            role: "listbox",
            style: { maxHeight: i, display: y ? "block" : "none" },
            children: o
          }
        ),
        t
      ] })
    }
  ) }) });
}, ki = ({
  className: e,
  isActive: t,
  children: n,
  onSelect: s,
  value: r,
  ...o
}) => {
  const c = E("autocomplete-item", t && "active", e), i = te(null);
  return B(() => {
    if (!t || !i.current)
      return;
    i.current.scrollIntoView({ block: "nearest" });
  }, [t]), /* @__PURE__ */ a("li", { className: c, onClick: () => s(r), ref: i, ...o, children: n });
}, Ni = ({ isOpen: e, setOpenState: t, length: n }) => {
  const [s, r] = N(-1), o = P(
    (c) => {
      const i = c.key === "Tab", l = c.key === "Escape", d = c.key === "ArrowUp", u = c.key === "ArrowDown", m = c.key === "Home", f = c.key === "End", h = c.key === "Enter", v = c.altKey, g = n - 1;
      if (!e)
        return r(-1);
      if (l || h || i || v && d)
        return t(!1);
      if (u) {
        c.preventDefault(), r((p) => p === g ? g : p + 1);
        return;
      }
      if (d) {
        c.preventDefault(), r((p) => p === 0 ? 0 : p - 1);
        return;
      }
      if (m && s !== -1) {
        c.preventDefault(), r(0);
        return;
      }
      if (f && s !== -1) {
        c.preventDefault(), r(g);
        return;
      }
    },
    [e, t, n, s]
  );
  return B(() => {
    r(-1);
  }, [n]), B(() => (document.addEventListener("keydown", o), () => {
    document.removeEventListener("keydown", o);
  }), [o]), s;
}, Mi = ne.forwardRef(
  ({
    open: e,
    autoSelect: t,
    className: n,
    customContent: s,
    data: r = [],
    displayValue: o,
    value: c,
    isLoading: i,
    listHeight: l,
    noResults: d = "No results found",
    itemContent: u,
    onSelect: m,
    onSearch: f,
    onChange: h,
    onClose: v,
    onClosed: g,
    onOpen: p,
    onOpened: y,
    ...b
  }, k) => {
    const M = te(null), [L, I] = N(!1), [T, x] = N(!1), V = Et(L, e), [Y, H] = N(""), A = Fe(() => c !== void 0 ? c : Y, [c, Y]), J = Ni({ isOpen: V, setOpenState: I, length: r.length });
    xt(k, () => M.current);
    const D = E(V && "focused", "autocomplete-input", n), Q = E((V || A) && "active", "autocomplete-label"), _ = () => {
      I(!0), p == null || p(), M.current && !M.current.value && (f == null || f(""));
    }, U = (C) => o ? o(C) : C, $ = (C) => {
      I(!1), M.current && (M.current.value = C, f == null || f(C), m == null || m(C), h == null || h(C), v == null || v(), H(C));
    };
    return /* @__PURE__ */ K(be, { children: [
      /* @__PURE__ */ a(
        gt,
        {
          autoComplete: "off",
          onKeyDown: (C) => {
            const q = C.key === "Enter", F = C.key === "Tab";
            if (!L)
              return I(!0);
            J !== -1 && (q || t && F) && $(U(r[J]));
          },
          onChange: (C) => {
            f == null || f(C.target.value), h == null || h(C.target.value), H(C.target.value);
          },
          onFocus: _,
          className: D,
          labelClass: Q,
          ref: M,
          role: "combobox",
          value: A,
          ...b,
          children: i && /* @__PURE__ */ a("div", { className: "autocomplete-loader spinner-border", children: /* @__PURE__ */ a("span", { className: "sr-only", children: "Loading..." }) })
        }
      ),
      /* @__PURE__ */ K(
        wi,
        {
          isOpen: V,
          isOpened: T,
          inputRef: M,
          setOpenState: I,
          customContent: s,
          listHeight: l,
          onClose: v,
          onOpened: () => {
            y == null || y(), x(!0);
          },
          onClosed: () => {
            g == null || g(), x(!1);
          },
          children: [
            r.length === 0 && /* @__PURE__ */ a("li", { className: "autocomplete-item autocomplete-no-results", children: d }),
            r.map((C, q) => /* @__PURE__ */ a(
              ki,
              {
                isActive: J === q,
                value: U(C),
                onSelect: $,
                children: u ? u(C) : U(C)
              },
              q
            ))
          ]
        }
      )
    ] });
  }
);
Mi.displayName = "MDBAutocomplete";
const $l = ({
  className: e,
  btnClassName: t,
  btnChildren: n,
  confirmBtnText: s = "Ok",
  cancelBtnClasses: r,
  confirmBtnClasses: o,
  cancelBtnText: c = "Cancel",
  placement: i = "top",
  children: l,
  modal: d = !1,
  onClick: u,
  onConfirm: m,
  onCancel: f,
  onClose: h,
  open: v,
  options: g,
  popperTag: p = "div",
  ...y
}) => {
  const [b, k] = N(), [M, L] = N(), [I, T] = N(!1), x = Et(I, v), [V, Y] = N(!1), [H, A] = N(!1), { styles: J, attributes: D } = wt(b, M, { placement: i, ...g }), Q = E(d ? "popconfirm-modal" : "popconfirm-popover", "shadow-4", e), _ = E("popconfirm", !d && "fade", V && "show"), U = (q) => {
    T(!0), u && u(q);
  }, $ = P(
    (q) => {
      const F = b === q.target, j = q.target === M, w = M && M.contains(q.target), W = b == null ? void 0 : b.contains(q.target);
      !F && !j && !w && !W && (x && V) && (h == null || h(q), T(!1));
    },
    [M, b, x, V, h]
  );
  B(() => {
    x ? (A(!0), setTimeout(() => {
      Y(!0);
    }, 0)) : (Y(!1), d ? A(!1) : setTimeout(() => {
      A(!1);
    }, 150));
  }, [d, x]), B(() => (window.addEventListener("click", $), () => {
    window.removeEventListener("click", $);
  }), [$]);
  const C = /* @__PURE__ */ K("div", { className: _, children: [
    l,
    /* @__PURE__ */ K("div", { className: "popconfirm-buttons-container", children: [
      /* @__PURE__ */ a(Ae, { className: r, onClick: (q) => {
        f == null || f(q), h == null || h(q), T(!1);
      }, size: "sm", children: c }),
      /* @__PURE__ */ a(Ae, { className: o, onClick: (q) => {
        m == null || m(q), h == null || h(q), T(!1);
      }, size: "sm", children: s })
    ] })
  ] });
  return /* @__PURE__ */ K(be, { children: [
    /* @__PURE__ */ a(Ae, { onClick: U, className: t, ...y, ref: k, children: n }),
    H && /* @__PURE__ */ a(pt, { children: d ? /* @__PURE__ */ a("div", { className: "popconfirm-backdrop", children: /* @__PURE__ */ a(p, { ref: L, className: Q, children: C }) }) : /* @__PURE__ */ a(p, { className: Q, ref: L, style: { ...J.popper }, ...D.popper, children: C }) })
  ] });
}, xi = ne.forwardRef(({ className: e, icon: t, tag: n = "p", children: s, ...r }, o) => {
  const c = E("popconfirm-message", e);
  return /* @__PURE__ */ K(n, { className: c, ref: o, ...r, children: [
    t && /* @__PURE__ */ a("span", { className: "popconfirm-icon-container", children: t }),
    /* @__PURE__ */ a("span", { className: "popconfirm-message-text", children: s })
  ] });
});
xi.displayName = "MDBPopconfirmMessage";
const gs = (e) => e, Ei = (e) => e * e, Di = (e) => e * e * e, Ti = (e) => e * e * e * e, Bi = (e) => e * e * e * e * e, Li = (e) => e < 0.5 ? 2 * e * e : -1 + (4 - 2 * e) * e, Si = (e) => (e /= 0.5, e < 1 ? e * e * e / 2 : (e -= 2, (e * e * e + 2) / 2)), Ii = (e) => (e /= 0.5, e < 1 ? 0.5 * e * e * e * e : (e -= 2, -(e * e * e * e - 2) / 2)), Ai = (e) => (e /= 0.5, e < 1 ? e * e * e * e * e / 2 : (e -= 2, (e * e * e * e * e + 2) / 2)), $i = (e) => -e * (e - 2), Ri = (e) => (e--, e * e * e + 1), Hi = (e) => (e--, -(e * e * e * e - 1)), Wi = (e) => (e--, e * e * e * e * e + 1), Ci = (e, t) => {
  switch (t) {
    case "motionLinear":
      return gs(e);
    case "motionEaseInQuad":
      return Ei(e);
    case "motionEaseInCubic":
      return Di(e);
    case "motionEaseInQuart":
      return Ti(e);
    case "motionEaseInQuint":
      return Bi(e);
    case "motionEaseInOutQuad":
      return Li(e);
    case "motionEaseInOutCubic":
      return Si(e);
    case "motionEaseInOutQuart":
      return Ii(e);
    case "motionEaseInOutQuint":
      return Ai(e);
    case "motionEaseOutQuad":
      return $i(e);
    case "motionEaseOutCubic":
      return Ri(e);
    case "motionEaseOutQuart":
      return Hi(e);
    case "motionEaseOutQuint":
      return Wi(e);
    default:
      return gs(e);
  }
}, Rl = ({
  className: e,
  duration: t = 500,
  href: n = "#",
  offset: s = 0,
  easing: r = "motionLinear",
  containerRef: o,
  targetRef: c,
  children: i,
  ...l
}) => {
  const d = te(null);
  B(() => {
    d.current = o ? o.current : document.documentElement;
  }, [o]);
  const u = (g) => {
    const p = g.getBoundingClientRect();
    return {
      top: p.top + document.body.scrollTop,
      left: p.left + document.body.scrollLeft
    };
  }, m = () => {
    const g = d.current, p = c == null ? void 0 : c.current;
    if (g && s !== void 0) {
      const y = g.scrollTop;
      if (!o)
        return u(p).top - s + y;
      const b = p.getBoundingClientRect().y, k = g.getBoundingClientRect().y;
      return b - k - s + y;
    }
  }, f = () => {
    var g;
    if (!o)
      return !0;
    if (d.current) {
      const p = (g = d.current) == null ? void 0 : g.getBoundingClientRect();
      return p.top >= 0 && p.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    }
  }, h = (g, p, y, b, k, M) => {
    const L = b < 0, I = b > 1, T = k <= 0;
    if (L || I || T) {
      g.scrollTop = y;
      return;
    }
    r && (g.scrollTo({
      top: p - (p - y) * Ci(b, r)
    }), b += k * M, setTimeout(() => {
      h(g, p, y, b, k, M);
    }));
  };
  return /* @__PURE__ */ a("a", { className: e, href: n, onClick: (g) => {
    g.preventDefault();
    const p = d.current;
    if (p && t) {
      const y = p.scrollTop, b = m(), k = 0, M = 1 / t, L = 4.25;
      f() ? h(p, y, b, k, M, L) : (h(
        document.documentElement,
        document.documentElement.scrollTop,
        p.offsetTop,
        k,
        M,
        L
      ), setTimeout(() => {
        h(p, y, b, k, M, L);
      }, t));
    }
  }, ...l, children: i });
}, Yi = ne.forwardRef(
  ({
    className: e,
    tag: t = "div",
    zoomLevel: n = 1,
    fontAwesome: s = "free",
    children: r,
    lightboxRef: o,
    onOpen: c,
    onClose: i,
    onSlide: l,
    onZoomIn: d,
    onZoomOut: u,
    disablePortal: m,
    ...f
  }, h) => {
    const v = te(null), g = te(null), p = o || g, y = te(null), [b, k] = N(!1), [M, L] = N(0), [I, T] = N(!1), [x, V] = N([]), [Y, H] = N(""), [A, J] = N(1), [D, Q] = N(!1), [_, U] = N(), [$, X] = N(!1), O = te(!1), C = te(!1), q = te(), F = te(), j = te(), w = te(), W = te(), le = te(), ue = te(), de = E("lightbox", e), re = E(s === "pro" && "fontawesome-pro"), De = E("lightbox-gallery-close-btn", s === "pro" && "fontawesome-pro"), pe = E(
      "lightbox-gallery-fullscreen-btn",
      s === "pro" && "fontawesome-pro",
      I && "active"
    ), Ne = E(
      "lightbox-gallery-zoom-btn",
      s === "pro" && "fontawesome-pro",
      A > 1 && "active"
    ), he = Fe(() => document.documentElement.dir === "rtl", []), fe = () => {
      O.current = !0, setTimeout(() => {
        O.current = !1;
      }, 400);
    }, ye = P(
      (S) => {
        let ce = S;
        return ce > x.length - 1 ? ce = 0 : ce < 0 && (ce = x.length - 1), x[ce].classList.contains("lightbox-disabled") ? ye(ce - 1) : ce;
      },
      [x]
    ), Le = P(() => {
      A >= 3 || (J((S) => S + n), d == null || d());
    }, [d, A, n]), Me = P(() => {
      var ce;
      const S = (ce = v.current) == null ? void 0 : ce.querySelector(".lightbox-gallery-item.active");
      S != null && S.parentElement && (S.parentElement.style.left = "0", S.parentElement.style.top = "0", S.style.transition = "all 0.5s ease-out", S.style.left = "0", S.style.top = "0", lt(S), setTimeout(() => {
        S.style.transition = "none";
      }, 500));
    }, []), ke = P(() => {
      A - n === 1 && Me(), !(A <= 1) && (J((S) => S - n), u == null || u());
    }, [u, Me, A, n]), ae = P(() => {
      var ce;
      if (!v.current)
        return;
      Array.from(
        (ce = v.current) == null ? void 0 : ce.querySelectorAll(".lightbox-gallery-item")
      ).forEach((R) => {
        lt(R);
      });
    }, []), Te = P(() => {
      I && document.exitFullscreen && document.exitFullscreen(), setTimeout(() => {
        document.body.classList.remove("disabled-scroll"), document.body.classList.remove("replace-scrollbar");
      }), k(!1), J(1), Q(!1), ae(), i == null || i();
    }, [ae, I, i]), se = P(
      (S) => {
        if (O.current || x.length <= 1)
          return M;
        let ce = 0;
        switch (S) {
          case "left":
            ce = M - 1;
            break;
          case "right":
            ce = M + 1;
            break;
          case "last":
            ce = x.length - 1;
            break;
          case "first":
            ce = 0;
            break;
        }
        fe();
        const R = ye(ce);
        L(R), J(1), Q(!1), setTimeout(() => {
          var me;
          const oe = (me = v.current) == null ? void 0 : me.querySelector(".lightbox-gallery-item.active");
          ae(), H(oe.getAttribute("data-mdb-caption"));
        }, 300), l == null || l();
      },
      [M, ae, x.length, l, ye]
    ), We = P(
      (S) => {
        if (!b)
          return;
        switch (S.nativeEvent.key) {
          case "ArrowRight":
            se(he ? "left" : "right");
            break;
          case "ArrowLeft":
            se(he ? "right" : "left");
            break;
          case "Escape":
            Te();
            break;
          case "Home":
            se("first");
            break;
          case "End":
            se("last");
            break;
          case "ArrowUp":
            Le();
            break;
          case "ArrowDown":
            ke();
            break;
        }
      },
      [Te, se, Le, ke, b, he]
    ), Se = P(
      (S) => {
        document.body.classList.add("disabled-scroll"), document.documentElement.scrollHeight > document.documentElement.clientHeight && document.body.classList.add("replace-scrollbar"), k(!0), L(S), Q(!1), ae(), setTimeout(() => {
          var R;
          const ce = (R = v.current) == null ? void 0 : R.querySelector(".lightbox-gallery-item.active");
          H(ce.getAttribute("data-mdb-caption"));
        }, 0), c == null || c();
      },
      [ae, c]
    );
    xt(h, () => ({
      outsideAccess(S) {
        Se(S);
      }
    }));
    const $e = P(() => {
      // eslint-disable-next-line
      //@ts-ignore
      (document.webkitIsFullScreen || // eslint-disable-next-line
      //@ts-ignore
      document.mozFullScreen || // eslint-disable-next-line
      //@ts-ignore
      document.msFullscreenElement) === void 0 && T(!1);
    }, []), Ge = () => {
      var S, ce, R;
      if (!I) {
        (ce = (S = v.current) == null ? void 0 : S.requestFullscreen) == null || ce.call(S), T(!0);
        return;
      }
      (R = document.exitFullscreen) == null || R.call(document), T(!1);
    }, nt = (S) => {
      S.nativeEvent.preventDefault();
      const ce = S.nativeEvent instanceof TouchEvent ? S.nativeEvent.touches[0] : S.nativeEvent, R = ce.clientX, oe = ce.clientY;
      S.nativeEvent instanceof TouchEvent && S.type === "touchstart" && S.nativeEvent.touches.length > 1 && (X(!0), U(S.nativeEvent.touches));
      const me = S.target;
      j.current = parseFloat(me.style.left), w.current = parseFloat(me.style.top), q.current = parseFloat(me.style.left), F.current = parseFloat(me.style.top), W.current = R * (1 / A) - q.current, le.current = oe * (1 / A) - F.current, Q(!0);
    }, st = (S) => {
      if (S.type === "touchmove" && S.nativeEvent instanceof TouchEvent && S.nativeEvent.targetTouches.length > 1 && (S.nativeEvent.preventDefault(), dt(S)), !D || $)
        return;
      const ce = S.nativeEvent instanceof TouchEvent ? S.nativeEvent.touches[0] : S.nativeEvent, R = ce.clientX, oe = ce.clientY, me = S.target;
      if (A !== 1) {
        q.current = R * (1 / A) - W.current, F.current = oe * (1 / A) - le.current, me.style.left = `${q.current}px`, me.style.top = `${F.current}px`;
        return;
      }
      x.length <= 1 || (q.current = R * (1 / A) - W.current, me.style.left = `${q.current}px`);
    }, tt = P(() => {
      if (A !== 1 || x.length <= 1 || !q.current || $)
        return;
      if (q.current - (j.current || 0) > 0) {
        se(he ? "right" : "left");
        return;
      }
      se(he ? "left" : "right");
    }, [se, $, he, x.length, A]), Ve = P(
      (S) => {
        $ || (S.nativeEvent instanceof TouchEvent && !S.nativeEvent.touches && qe(S), A !== 1 ? ke() : Le());
      },
      [Le, ke, $, A]
    ), Qe = (S) => {
      if (Q(!1), S.nativeEvent instanceof MouseEvent) {
        tt(), Q(!1);
        return;
      }
      if ($ && S.targetTouches.length === 0) {
        X(!1), U(void 0);
        return;
      }
      Q(!1), tt();
    }, dt = (S) => {
      if (!_)
        return;
      const ce = Math.hypot(
        _[1].pageX - _[0].pageX,
        _[1].pageY - _[0].pageY
      ), R = Math.hypot(
        S.nativeEvent.touches[1].pageX - S.nativeEvent.touches[0].pageX,
        S.nativeEvent.touches[1].pageY - S.nativeEvent.touches[0].pageY
      ), oe = Math.abs(ce - R), me = S.nativeEvent.view.screen.width;
      oe <= me * 0.03 || (ce <= R ? Le() : ke(), U(S.nativeEvent.touches));
    }, lt = (S) => {
      S.parentElement && (S.width >= S.height ? (S.style.width = "100%", S.style.maxWidth = "100%", S.style.height = "auto", S.style.top = `${(S.parentElement.offsetHeight - S.height) / 2}px`, S.style.left = "0") : (S.style.height = "100%", S.style.maxHeight = "100%", S.style.width = "auto", S.style.left = `${(S.parentElement.offsetWidth - S.width) / 2}px`, S.style.top = "0"), S.width >= S.parentElement.offsetWidth && (S.style.width = `${S.parentElement.offsetWidth}px`, S.style.height = "auto", S.style.left = "0", S.style.top = `${(S.parentElement.offsetHeight - S.height) / 2}px`), S.height >= S.parentElement.offsetHeight && (S.style.height = `${S.parentElement.offsetHeight}px`, S.style.width = "auto", S.style.top = "0", S.style.left = `${(S.parentElement.offsetWidth - S.width) / 2}px`), q.current = parseFloat(S.style.left) || 0, F.current = parseFloat(S.style.top) || 0);
    }, rt = (S) => {
      const ce = S.getAttribute("data-mdb-img") ? S.getAttribute("data-mdb-img") : S.getAttribute("src") ? S.getAttribute("src") : "", R = S.getAttribute("alt") ? S.getAttribute("alt") : S.getAttribute("data-mdb-caption") ? S.getAttribute("data-mdb-caption") : "", oe = S.getAttribute("data-mdb-caption") ? S.getAttribute("data-mdb-caption") : S.getAttribute("alt") ? S.getAttribute("alt") : "";
      return { source: ce, alt: R, caption: oe };
    }, ot = P(() => {
      const ce = [...p.current.querySelectorAll(".lightbox-item")].filter((R) => !R.classList.contains("lightbox-disabled"));
      V(ce);
    }, [p]), Pe = P(() => {
      ae();
    }, [ae]), qe = (S) => {
      q.current = window.innerWidth / 2 - S.nativeEvent.offsetX - 50, F.current = window.innerHeight / 2 - S.nativeEvent.offsetY - 50;
      const ce = S.target;
      ce.style.left = `${q.current}px`, ce.style.top = `${F.current}px`, ce.style.transition = "all 0.5s ease-out", setTimeout(() => {
        ce.style.transition = "none";
      }, 500);
    }, ct = (S) => {
      if (S.deltaY > 0)
        return ke();
      A >= 3 || (qe(S), Le());
    };
    return B(() => {
      ot();
    }, [ot]), B(() => {
      x.length && ae();
    }, [ae, x]), B(() => (x.forEach((S, ce) => {
      !S.classList.contains("lightbox-disabled") && S.addEventListener("click", () => Se(ce));
    }), () => {
      x.forEach((S, ce) => {
        S.removeEventListener("click", () => Se(ce));
      });
    }), [Se, x]), B(() => (window.addEventListener("resize", Pe), window.addEventListener("fullscreenchange", $e), () => {
      window.removeEventListener("resize", Pe), window.removeEventListener("fullscreenchange", $e);
    }), [$e, Pe]), B(() => {
      const S = document.querySelector("meta[name=viewport]");
      if (ue.current || (ue.current = (S == null ? void 0 : S.getAttribute("content")) || ""), !b) {
        C.current = !1, S == null || S.setAttribute("content", ue.current);
        return;
      }
      setTimeout(() => {
        var ce;
        C.current = !0, (ce = y.current) == null || ce.focus(), S == null || S.setAttribute("content", `${ue.current} user-scalable=no`);
      }, 300);
    }, [b]), /* @__PURE__ */ K(be, { children: [
      /* @__PURE__ */ a(t, { ref: p, className: de, ...f, children: r }),
      /* @__PURE__ */ a(pt, { disablePortal: m, children: /* @__PURE__ */ K(
        "div",
        {
          className: "lightbox-gallery",
          onClick: (S) => S.target.tagName === "DIV" && Te(),
          onKeyUp: We,
          ref: v,
          style: {
            opacity: b ? 1 : 0,
            pointerEvents: b ? "initial" : "none",
            visibility: b ? "visible" : "hidden"
          },
          children: [
            /* @__PURE__ */ a("div", { className: "lightbox-gallery-loader" }),
            /* @__PURE__ */ K("div", { className: "lightbox-gallery-toolbar", children: [
              /* @__PURE__ */ a("div", { className: "lightbox-gallery-left-tools", children: /* @__PURE__ */ a("p", { className: "lightbox-gallery-counter", children: `${M + 1} / ${x.length}` }) }),
              /* @__PURE__ */ K("div", { className: "lightbox-gallery-right-tools", children: [
                /* @__PURE__ */ a("button", { className: pe, onClick: Ge }),
                /* @__PURE__ */ a(
                  "button",
                  {
                    "aria-label": A > 1 ? "Zoom out" : "Zoom in",
                    className: Ne,
                    onClick: () => A > 1 ? ke() : Le()
                  }
                ),
                /* @__PURE__ */ a("button", { className: De, onClick: Te })
              ] })
            ] }),
            /* @__PURE__ */ a(
              "div",
              {
                className: "lightbox-gallery-content",
                style: {
                  transform: b ? "scale(1)" : "scale(0.25)",
                  transition: "all 0.5s ease-out"
                },
                children: x.map((S, ce) => {
                  const { source: R, alt: oe, caption: me } = rt(S), Ee = ce === M ? 1 : 0, Ue = ce === M ? A : 0, _e = M === x.length - 1 && ce === 0 && x.length > 1, z = M === 0 && ce === x.length - 1 && x.length > 1;
                  let Z;
                  return M < ce && !z || _e ? Z = "100%" : M > ce && !_e || z ? Z = "-100%" : Z = "0%", /* @__PURE__ */ a(
                    "div",
                    {
                      className: "lightbox-gallery-image",
                      style: {
                        position: "absolute",
                        opacity: Ee,
                        left: b ? Z : "0%",
                        transform: `scale(${Ue})`,
                        transition: M === ce || C.current ? "all 0.5s ease-out" : "none"
                      },
                      children: /* @__PURE__ */ a(
                        "img",
                        {
                          src: R || "",
                          alt: oe || "",
                          "data-mdb-caption": me || "",
                          onMouseDown: nt,
                          onMouseMove: st,
                          onMouseUp: Qe,
                          onWheel: ct,
                          onTouchStart: nt,
                          onTouchMove: st,
                          onTouchEnd: Qe,
                          onDoubleClick: Ve,
                          className: `lightbox-gallery-item ${M === ce && "active"}`
                        }
                      )
                    },
                    ce
                  );
                })
              }
            ),
            /* @__PURE__ */ a("div", { className: "lightbox-gallery-arrow-left", children: /* @__PURE__ */ a("button", { "aria-label": "Previous", className: re, onClick: () => se("left") }) }),
            /* @__PURE__ */ a("div", { className: "lightbox-gallery-arrow-right", children: /* @__PURE__ */ a(
              "button",
              {
                "aria-label": "Next",
                className: re,
                onClick: () => se("right"),
                ref: y
              }
            ) }),
            /* @__PURE__ */ a("div", { className: "lightbox-gallery-caption-wrapper", children: /* @__PURE__ */ a("p", { className: "lightbox-gallery-caption", children: Y }) })
          ]
        }
      ) })
    ] });
  }
);
Yi.displayName = "MDBLightbox";
const Pi = ne.forwardRef(
  ({ className: e, fullscreenSrc: t, disabled: n, caption: s, ...r }, o) => {
    const c = E("lightbox-item", n && "lightbox-disabled", e);
    return /* @__PURE__ */ a("img", { ref: o, "data-mdb-caption": s, "data-mdb-img": t, className: c, ...r });
  }
);
Pi.displayName = "MDBLightboxItem";
const Xi = ne.forwardRef(
  ({ className: e, ...t }, n) => {
    const [s, r] = N(!1), o = P(() => {
      const i = document.documentElement.scrollTop;
      r(!!i);
    }, []), c = E(s && "navbar-scrolled", "navbar-scroll", e);
    return B(() => {
      window.addEventListener("scroll", o);
    }, [o]), /* @__PURE__ */ a(xs, { className: c, ref: n, ...t });
  }
);
Xi.displayName = "MDBAnimatedNavbar";
const rr = Lt(
  ({ className: e, closeIcon: t, tag: n = "div", color: s, size: r, children: o, onDelete: c, ...i }, l) => {
    const [d, u] = N(!0), m = E("chip", r && `chip-${r}`, s && `chip-outline btn-outline-${s}`, e);
    return d ? /* @__PURE__ */ K(n, { ref: l, className: m, ...i, children: [
      o,
      t && /* @__PURE__ */ a("i", { className: "close fas fa-times", onClick: () => {
        c == null || c(o), u(!1);
      } })
    ] }) : null;
  }
);
rr.displayName = "MDBChip";
const Oi = ne.forwardRef(
  ({
    className: e,
    value: t = "",
    id: n,
    labelId: s,
    labelClass: r,
    label: o,
    onChange: c,
    labelRef: i,
    labelStyle: l,
    readonly: d,
    editable: u,
    onAdd: m,
    onDelete: f,
    initialValues: h = [],
    ...v
  }, g) => {
    const p = te(null), y = i ?? p, b = te(null);
    xt(g, () => b.current);
    const [k, M] = N(h), [L, I] = N(null), [T, x] = N(0), [V, Y] = N(null), [H, A] = N(t), J = k.length > 0 || H.length > 0, D = E(
      "form-outline",
      "chips-input-wrapper",
      k.length > 0 && "chips-padding chips-transition"
    ), Q = E("form-control", J && "active", e), _ = E("form-label", r);
    B(() => {
      !y.current || y.current.clientWidth === 0 || x(y.current.clientWidth * 0.8 + 8);
    }, [y]);
    const U = () => {
      y.current && x(y.current.clientWidth * 0.8 + 8);
    }, $ = (w) => {
      A(w.target.value), c == null || c(w);
    }, X = (w) => {
      H.length || ((w.key === "ArrowLeft" || w.key === "ArrowDown") && Y((W) => W ? W - 1 : k.length - 1), (w.key === "ArrowRight" || w.key === "ArrowUp") && Y((W) => W === k.length - 1 || W === null ? 0 : W + 1), w.key === "Backspace" && V !== null && O(V)), w.key === "Enter" && H.trim().length && (m == null || m(H), M([...k, { tag: H }]), A(""));
    }, O = (w) => {
      const W = k.find((le, ue) => w === ue);
      if (W) {
        f == null || f(W == null ? void 0 : W.tag);
        const le = k.filter((ue, de) => w !== de);
        M(le), Y(null);
      }
    }, C = (w, W) => {
      u && I(W);
    }, q = (w, W) => {
      if (!u)
        return;
      const le = w.currentTarget.textContent, ue = k.map((de, re) => re === W && le ? {
        tag: le
      } : de);
      le ? M(ue) : O(W), I(null), Y(null);
    }, F = (w, W) => {
      w.key === "Enter" && u && L !== null && q(w, W);
    }, j = () => {
      H.trim().length && (m == null || m(H), M([...k, { tag: H }]), A(""));
    };
    return /* @__PURE__ */ a("div", { className: "chips chips-placeholder", children: /* @__PURE__ */ K("div", { className: D, children: [
      k.map((w, W) => /* @__PURE__ */ a(
        rr,
        {
          contentEditable: L === W,
          suppressContentEditableWarning: !0,
          onDoubleClick: (le) => C(le, W),
          onDelete: () => O(W),
          onKeyDown: (le) => F(le, W),
          closeIcon: L !== W,
          className: E("btn", W === V && "active"),
          children: w.tag
        },
        `${Math.random()}-${W}`
      )),
      /* @__PURE__ */ a(
        "input",
        {
          type: "text",
          readOnly: d,
          className: Q,
          onChange: $,
          onFocus: U,
          onKeyDown: X,
          onBlur: () => j(),
          value: H,
          id: n,
          ref: b,
          ...v
        }
      ),
      o && /* @__PURE__ */ a("label", { className: _, style: l, id: s, htmlFor: n, ref: y, children: o }),
      /* @__PURE__ */ K("div", { className: "form-notch", children: [
        /* @__PURE__ */ a("div", { className: "form-notch-leading" }),
        /* @__PURE__ */ a("div", { className: "form-notch-middle", style: { width: T } }),
        /* @__PURE__ */ a("div", { className: "form-notch-trailing" })
      ] })
    ] }) });
  }
);
Oi.displayName = "MDBChipsInput";
const Hl = ({
  className: e,
  defaultValues: t = [0, 100],
  values: n,
  getValues: s,
  onChange: r,
  min: o = 0,
  max: c = 100,
  step: i = "1",
  tooltips: l,
  ...d
}) => {
  const [u, m] = N(n || t), f = Fe(() => n === void 0 ? u : n, [n, u]), h = E("multi-range", e), [v, g] = N({ zIndex: "auto" }), p = (b) => {
    const k = Number(b.target.value), M = Number(f[1]);
    g(k === M ? { zIndex: 1 } : { zIndex: "auto" }), !(k > M) && (m([k, f[1]]), r && r([k, f[1]]));
  }, y = (b) => {
    const k = Number(b.target.value), M = Number(f[0]);
    k < M || (m([f[0], k]), r && r([f[0], k]));
  };
  return B(() => {
    s && s({ first: u[0], second: u[1] });
  }, [u, s]), /* @__PURE__ */ K("div", { className: h, ...d, children: [
    /* @__PURE__ */ a(
      Yn,
      {
        value: f[0],
        onChange: p,
        min: o,
        max: c,
        step: i,
        disableTooltip: !l,
        style: v
      }
    ),
    /* @__PURE__ */ a(
      Yn,
      {
        value: f[1],
        onChange: y,
        min: o,
        max: c,
        step: i,
        className: "multi-range-slider-second",
        disableTooltip: !l
      }
    )
  ] });
}, Wl = ({
  animationSticky: e,
  animationUnsticky: t,
  boundary: n = !1,
  delay: s = 0,
  direction: r = "down",
  offset: o = 0,
  position: c = "top"
}) => {
  const i = te(null), l = te(null), d = te(""), u = te(!1), m = te(0), f = te(0), h = te(0), v = te(!1), g = te(""), [p, y] = N({}), [b, k] = N({}), [M, L] = N({}), [I, T] = N(!1), [x, V] = N(!1), Y = (X) => {
    const O = X.getBoundingClientRect(), C = O.left + document.body.scrollLeft, q = O.top + document.body.scrollTop, F = C === 0 && q === 0 ? 0 : window.innerHeight - O.bottom;
    return {
      top: q,
      left: C,
      bottom: F
    };
  }, H = P(() => {
    const X = l.current, O = i.current;
    O && (m.current = X ? X.offsetTop : O.offsetTop);
  }, [i]), A = P(() => {
    const X = i.current;
    if (!X)
      return;
    const { height: O } = X.getBoundingClientRect(), C = m.current, q = C - s - O / 2, F = C + O - document.body.scrollHeight + s;
    h.current = c === "top" ? q : F;
  }, [s, c, i]), J = P((X) => {
    d.current = X > f.current ? "down" : "up";
  }, []), D = (X, O) => {
    Object.keys(O).forEach((C) => {
      X.style[C] = O[C];
    });
  }, Q = P(() => {
    const X = l.current, O = i.current;
    if (!O)
      return;
    const { left: C } = X.getBoundingClientRect(), q = X ? { left: C } : {};
    L(q), D(O, q), H();
  }, [H, i]), _ = P(() => {
    var de;
    const X = i.current;
    if (!X)
      return;
    const { height: O } = X.getBoundingClientRect(), C = {
      height: (de = X.parentElement) == null ? void 0 : de.getBoundingClientRect().height,
      ...Y(X.parentElement)
    }, q = typeof n != "boolean" && (n == null ? void 0 : n.current), F = q ? Y(q).top - O - o : C.height + C[c] - O - o, j = c === "bottom", w = n, W = F < 0, le = F > C.height - O;
    let ue;
    if (W && w)
      return ue = { [c]: `${o + F}px` }, D(X, ue);
    if (le && w && j)
      return ue = { bottom: `${o + C.bottom}px` }, D(X, ue);
    ue = { [c]: `${o}px` }, D(X, ue);
  }, [n, o, c, i]), U = P(() => {
    y({
      [c]: null,
      height: null,
      width: null,
      left: null,
      zIndex: null,
      position: null
    }), T(!1), k({
      height: null,
      width: null,
      opacity: null
    });
  }, [c]), $ = P(() => {
    if (!i.current)
      return;
    const X = window.pageYOffset || document.documentElement.scrollTop;
    H(), A(), J(X);
    const O = [d.current, "both"].includes(r), C = h.current <= X, q = C && !u.current && O, F = (!C || !O) && u.current;
    if (q) {
      const { height: j, left: w, width: W } = i.current.getBoundingClientRect();
      T(!0), k({
        height: `${j}px`,
        width: `${W}px`,
        opacity: "0"
      }), y({
        [c]: `${o}px`,
        height: `${j}px`,
        width: `${W}px`,
        left: `${w}px`,
        zIndex: "100",
        position: "fixed"
      }), _(), u.current = !0;
    }
    F && (t ? (V(!0), setTimeout(() => {
      U(), V(!1);
    }, 200)) : U(), u.current = !1), u.current && (D(i.current, M), _()), f.current = X <= 0 ? 0 : X;
  }, [
    t,
    _,
    r,
    M,
    o,
    c,
    U,
    H,
    A,
    J
  ]);
  return B(() => {
    var C;
    if (!i.current || v.current)
      return;
    const X = i.current.tagName.toLowerCase(), O = document.createElement(X);
    l.current = O, (C = i.current.parentElement) == null || C.insertBefore(O, i.current), g.current = i.current.className, v.current = !0;
  }, [v]), B(() => {
    D(l.current, b);
  }, [b]), B(() => {
    i.current && D(i.current, p);
  }, [p]), B(() => {
    const X = i.current;
    if (!X)
      return;
    const O = E(e && I && `animation ${e}`), C = E(t && x && `animation ${t}`), q = E(I && g.current);
    X.className = E("sticky", g.current, O, C), l.current.className = E(q);
  }, [e, t, x, I]), B(() => (window.addEventListener("resize", Q), window.addEventListener("scroll", $), () => {
    window.removeEventListener("resize", Q), window.removeEventListener("scroll", $);
  }), [Q, $]), i;
}, Cl = ({
  animation: e = "slide-right",
  delay: t,
  infinite: n,
  duration: s = 500,
  repeatOnScroll: r,
  reset: o,
  start: c = "onClick",
  externalElement: i
}) => {
  const l = te(null), d = te(!1), u = P(() => {
    if (!l.current)
      return;
    const g = l.current.getBoundingClientRect(), p = g.top >= 0 && g.left >= 0 && g.right <= (innerWidth || document.documentElement.clientWidth) && g.bottom <= (innerHeight || document.documentElement.clientHeight);
    d.current = p;
  }, [l]);
  B(() => (u(), addEventListener("scroll", u), () => removeEventListener("scroll", u)), [u]);
  const m = P(() => {
    l.current && (t && (l.current.style.animationDelay = t.toString() + "ms"), s && (l.current.style.animationDuration = s.toString() + "ms"), n && (l.current.style.animationIterationCount = "infinite"), l.current.classList.add(e, "animation"));
  }, [t, s, l, n, e]), f = P(() => {
    l.current && (l.current.style.animationDelay = "", l.current.style.animationDuration = "", l.current.style.animationIterationCount = "", l.current.classList.remove(e, "animation"));
  }, [e, l]), h = P(() => {
    var g;
    o && ((g = l.current) == null || g.addEventListener("animationend", f));
  }, [l, f, o]), v = P(
    (g) => {
      var p, y, b, k;
      if (g === "onLoad") {
        h(), m();
        return;
      }
      if (g === "onClick") {
        h(), i ? (p = i.current) == null || p.addEventListener("click", m) : (y = l.current) == null || y.addEventListener("click", m);
        return;
      }
      if (g === "onHover") {
        h(), i ? (b = i.current) == null || b.addEventListener("mouseenter", m) : (k = l.current) == null || k.addEventListener("mouseenter", m);
        return;
      }
      g === "onScroll" && addEventListener("scroll", () => {
        var M;
        if (!((M = l.current) != null && M.classList.contains(e) && !r)) {
          if (d.current) {
            m();
            return;
          }
          f();
        }
      });
    },
    [
      m,
      d,
      l,
      f,
      h,
      e,
      r,
      i
    ]
  );
  return B(() => v(c), [v, c]), l;
}, Yl = (e, t) => {
  const n = P(() => {
    navigator.clipboard.writeText(e);
  }, [e]);
  B(() => {
    const s = t.current;
    return s.addEventListener("click", n), () => {
      s.removeEventListener("click", n);
    };
  }, [n, t]);
};
export {
  Ho as MDBAccordion,
  Wo as MDBAccordionItem,
  kl as MDBAlert,
  Xi as MDBAnimatedNavbar,
  rc as MDBAnimation,
  Mi as MDBAutocomplete,
  Nr as MDBBadge,
  Xr as MDBBreadcrumb,
  Or as MDBBreadcrumbItem,
  Ae as MDBBtn,
  Er as MDBBtnGroup,
  Dr as MDBCard,
  Ir as MDBCardBody,
  Ar as MDBCardFooter,
  Rr as MDBCardGroup,
  Tr as MDBCardHeader,
  Zi as MDBCardImage,
  el as MDBCardLink,
  $r as MDBCardOverlay,
  Br as MDBCardSubTitle,
  Sr as MDBCardText,
  Lr as MDBCardTitle,
  fl as MDBCarousel,
  hl as MDBCarouselCaption,
  ml as MDBCarouselItem,
  Ml as MDBChart,
  Wt as MDBCheckbox,
  rr as MDBChip,
  Oi as MDBChipsInput,
  bl as MDBClientOnly,
  kr as MDBCol,
  Ds as MDBCollapse,
  wr as MDBContainer,
  ni as MDBDatatable,
  Yc as MDBDateTimepicker,
  Qs as MDBDatepicker,
  nl as MDBDropdown,
  sl as MDBDropdownItem,
  rl as MDBDropdownMenu,
  ol as MDBDropdownToggle,
  wo as MDBFile,
  zr as MDBFooter,
  it as MDBIcon,
  Il as MDBInfiniteScroll,
  gt as MDBInput,
  Bs as MDBInputGroup,
  Sl as MDBLazyContainer,
  hi as MDBLazyLoading,
  Yi as MDBLightbox,
  Pi as MDBLightboxItem,
  Hr as MDBListGroup,
  Wr as MDBListGroupItem,
  vi as MDBLoadingManagement,
  il as MDBModal,
  bo as MDBModalBody,
  ho as MDBModalContent,
  sc as MDBModalDialog,
  go as MDBModalFooter,
  po as MDBModalHeader,
  vo as MDBModalTitle,
  Hl as MDBMultiRange,
  xs as MDBNavbar,
  jr as MDBNavbarBrand,
  Kr as MDBNavbarItem,
  Vr as MDBNavbarLink,
  qr as MDBNavbarNav,
  _r as MDBNavbarToggler,
  Ur as MDBPagination,
  Qr as MDBPaginationItem,
  Gr as MDBPaginationLink,
  $l as MDBPopconfirm,
  xi as MDBPopconfirmMessage,
  fo as MDBPopover,
  mo as MDBPopoverBody,
  cl as MDBPopoverHeader,
  to as MDBProgress,
  Es as MDBProgressBar,
  tl as MDBRadio,
  Yn as MDBRange,
  Bl as MDBRating,
  Ll as MDBRatingElement,
  yn as MDBRipple,
  Yr as MDBRow,
  Xs as MDBScrollbar,
  ll as MDBScrollspy,
  al as MDBScrollspyLink,
  ul as MDBScrollspySubList,
  tr as MDBSelect,
  gl as MDBSelectDeprecated,
  yl as MDBSideNav,
  wl as MDBSideNavCollapse,
  tc as MDBSideNavItem,
  nc as MDBSideNavLink,
  ec as MDBSideNavMenu,
  Rl as MDBSmoothScroll,
  Ms as MDBSpinner,
  xl as MDBStack,
  El as MDBStepper,
  Tl as MDBStepperForm,
  Dl as MDBStepperStep,
  Al as MDBSticky,
  dl as MDBSwitch,
  Jr as MDBTable,
  eo as MDBTableBody,
  Zr as MDBTableHead,
  ko as MDBTabs,
  xo as MDBTabsContent,
  No as MDBTabsItem,
  Mo as MDBTabsLink,
  Eo as MDBTabsPane,
  pl as MDBTextArea,
  qs as MDBTimepicker,
  Nl as MDBToast,
  Cr as MDBTooltip,
  Zo as MDBTouch,
  Pr as MDBTypography,
  Ls as MDBValidation,
  vl as MDBValidationItem,
  Cl as useAnimatedRef,
  Yl as useClipboard,
  Wl as useStickyRef
};
